export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO-8601 timestamp, with millisecond precision, expressing its timezone offset */
  Timestamp: any;
  /** A date string in YYYY-MM-DD format */
  DateOnlyString: string;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A date only returning scalar */
  DateOnly: any;
  /** A scalar type for handling large integers beyond JavaScript safe integer limit */
  BigInt: any;
  RatingReviewCursor: any;
  /** Currently just template id */
  ContactQuarantinedMessageBatchCursor: any;
  GroupConnectionCursor: any;
  GuestListMemberCursor: any;
  EventSearchCursor: any;
  LinkRedirectBlockCursor: any;
  Url: any;
  /** Currently link redirect id */
  LinkRedirectCursor: any;
  /**
   * An opaque identifier providing a unique reference to an element within a pagination query.
   * The term for it in the Relay Specification is a "Cursor".
   *   https://relay.dev/graphql/connections.htm#sec-Cursor
   */
  ProductCatalogSearchCursor: any;
  ProductCatalogEntityCursor: any;
  NegativeInt: any;
  /** Currently just template id */
  StationeryTemplateCursor: any;
  UserActivityCursor: any;
  /** Represents NULL values */
  Void: any;
};

/** Property Identifier Input. Only one of the fields should be non-null */
export type AccommodationCatalogPropertyIdentifierInput = {
  accommodationPlaceId?: InputMaybe<Scalars['String']>;
  joyPlaceId?: InputMaybe<Scalars['String']>;
};

export enum AccommodationCategory {
  Hotel = 'Hotel',
  Other = 'Other',
  VacationRental = 'VacationRental',
}

export enum ArchivedStatus {
  archivedByCouple = 'archivedByCouple',
  archivedBySystem = 'archivedBySystem',
  archivedByVendor = 'archivedByVendor',
  notArchived = 'notArchived',
}

export enum DateFormat {
  full = 'full',
  long = 'long',
  numerical = 'numerical',
  short = 'short',
}

export enum TimeFormat {
  time = 'time',
  timeWithSeconds = 'timeWithSeconds',
}

export enum TimezoneFormat {
  long = 'long',
  short = 'short',
}

export enum AccommodationPlaceDisplayLocation {
  AccommodationPage = 'AccommodationPage',
  CustomPage = 'CustomPage',
}

export enum AccommodationPlaceRoomBlockStatus {
  active = 'active',
  cancelled = 'cancelled',
}

/** TrackingQueryStringKey */
export enum TrackingQueryStringKey {
  campaignId = 'campaignId',
  clientReference = 'clientReference',
  eventId = 'eventId',
}

/** RedirectMechanismType */
export enum RedirectMechanismType {
  custom = 'custom',
  joyNativeCheckout = 'joyNativeCheckout',
  partnerHotel = 'partnerHotel',
  partnerSearch = 'partnerSearch',
}

export enum TravelCurrencyCode {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ARS = 'ARS',
  AUD = 'AUD',
  AZN = 'AZN',
  BAM = 'BAM',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BWP = 'BWP',
  BYN = 'BYN',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CVE = 'CVE',
  CZK = 'CZK',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EEK = 'EEK',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  EUR = 'EUR',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GNF = 'GNF',
  GTQ = 'GTQ',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KHR = 'KHR',
  KMF = 'KMF',
  KRW = 'KRW',
  KWD = 'KWD',
  KZT = 'KZT',
  LBP = 'LBP',
  LKR = 'LKR',
  LTL = 'LTL',
  LVL = 'LVL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MOP = 'MOP',
  MUR = 'MUR',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SOS = 'SOS',
  SYP = 'SYP',
  THB = 'THB',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  USD = 'USD',
  UYU = 'UYU',
  UZS = 'UZS',
  VEF = 'VEF',
  VND = 'VND',
  XAF = 'XAF',
  XOF = 'XOF',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMK = 'ZMK',
  ZWL = 'ZWL',
}

export enum StrikeoutRateProvider {
  booking = 'booking',
  expedia = 'expedia',
  unknown = 'unknown',
}

/** Status of an accommodation place recommendation */
export enum AccommodationPlaceRecommendationStatus {
  abandoned = 'abandoned',
  accepted = 'accepted',
  added = 'added',
  declined = 'declined',
  pending = 'pending',
}

export enum AccommodationPlaceCategory {
  campsite = 'campsite',
  hotel = 'hotel',
  rental = 'rental',
}

export enum DistancesBetweenPointsType {
  DRIVING_DISTANCE = 'DRIVING_DISTANCE',
  GEO_DISTANCE = 'GEO_DISTANCE',
  WALKING_DISTANCE = 'WALKING_DISTANCE',
}

export enum HotelProvider {
  customUrl = 'customUrl',
  googlePlaceUrl = 'googlePlaceUrl',
  hotelWebsiteUrl = 'hotelWebsiteUrl',
  joynativecheckout = 'joynativecheckout',
  nuitee = 'nuitee',
  zh = 'zh',
}

/** AccommodationPlaceType */
export enum AccommodationPlaceType {
  custom = 'custom',
  hotel = 'hotel',
}

export enum EventPageType {
  app = 'app',
  custom = 'custom',
  faq = 'faq',
  guests = 'guests',
  moments = 'moments',
  registry = 'registry',
  rsvp = 'rsvp',
  schedule = 'schedule',
  story = 'story',
  tidbits = 'tidbits',
  travel = 'travel',
  vip = 'vip',
  welcome = 'welcome',
}

export enum EventRSVPAttendanceStatus {
  attending = 'attending',
  noAttendanceQuestion = 'noAttendanceQuestion',
  notAttending = 'notAttending',
  other = 'other',
  unanswered = 'unanswered',
}

export enum PersonGuestState {
  evicted = 'evicted',
  left = 'left',
  user = 'user',
}

export enum VirtualEventProvider {
  eventlive = 'eventlive',
  googleMeet = 'googleMeet',
  unknown = 'unknown',
  youtube = 'youtube',
  zoom = 'zoom',
}

export enum EventUserStatus {
  admin = 'admin',
  crasher = 'crasher',
  guest = 'guest',
  owner = 'owner',
}

export enum LocationAnchorSource {
  approximated_centroid = 'approximated_centroid',
  event_location = 'event_location',
  event_venue = 'event_venue',
}

export enum FavoriteType {
  art = 'art',
  font = 'font',
  template = 'template',
}

export enum DesignLayoutType {
  aloha = 'aloha',
  brannan = 'brannan',
}

export enum FontWeight {
  none = 'none',
  uppercase = 'uppercase',
}

export enum Typeface {
  handwriting = 'handwriting',
  monospace = 'monospace',
  sansSerif = 'sansSerif',
  script = 'script',
  serif = 'serif',
}

export enum ThemeVariationType {
  aloha = 'aloha',
  brannan = 'brannan',
  invite = 'invite',
  prints = 'prints',
  savethedate = 'savethedate',
  thumbnail = 'thumbnail',
}

export enum FeatureValueType {
  boolean = 'boolean',
  color = 'color',
  range = 'range',
}

export enum EventDesignPurpose {
  draft = 'draft',
  live = 'live',
}

export enum BrannanNavigation {
  classic = 'classic',
  singlePage = 'singlePage',
}

export enum DesignFeatureType {
  alohaColorPreference = 'alohaColorPreference',
  alohaTextColorPreference = 'alohaTextColorPreference',
  brannanBackgroundTransparency = 'brannanBackgroundTransparency',
  brannanColorPreference = 'brannanColorPreference',
  brannanInnerFrameBorder = 'brannanInnerFrameBorder',
  brannanTextColorPreference = 'brannanTextColorPreference',
}

export enum ColorPointerLocation {
  event = 'event',
  theme = 'theme',
}

export enum Category {
  BUTTONS = 'BUTTONS',
  CAPTION = 'CAPTION',
  DATE = 'DATE',
  EVENT_TITLE = 'EVENT_TITLE',
  HEADING = 'HEADING',
  LOCATION = 'LOCATION',
  NAVIGATION = 'NAVIGATION',
  PAGE_TITLE = 'PAGE_TITLE',
  PARAGRAPH = 'PARAGRAPH',
  SUB_HEADING = 'SUB_HEADING',
}

export enum GuestSiteTargetEnum {
  bliss = 'bliss',
  charm = 'charm',
}

export type PeopleFindCriteria = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type PeopleFindOptions = {
  allGuestStates?: InputMaybe<Scalars['Boolean']>;
  strategy: PeopleFindStrategy;
};

export enum PeopleFindStrategy {
  fuzzy = 'fuzzy',
  myInvite = 'myInvite',
}

export enum RoomBlockPerks {
  hotelPoints15k = 'hotelPoints15k',
}

export enum LeadState {
  Created = 'Created',
  Exposed = 'Exposed',
  InProgress = 'InProgress',
  Lost = 'Lost',
  Viewed = 'Viewed',
  Won = 'Won',
}

export enum LeadStateV2 {
  ConciergeAssigned = 'ConciergeAssigned',
  Created = 'Created',
  Exposed = 'Exposed',
  InProgress = 'InProgress',
  Lost = 'Lost',
  NewPricingRequested = 'NewPricingRequested',
  OfferAccepted = 'OfferAccepted',
  OfferSent = 'OfferSent',
  PricingReceived = 'PricingReceived',
  PricingRequested = 'PricingRequested',
  Viewed = 'Viewed',
  Won = 'Won',
}

export enum ContactMethods {
  /** @deprecated deprecated, please use meeting */
  calendly = 'calendly',
  email = 'email',
  meeting = 'meeting',
  phoneCall = 'phoneCall',
  sms = 'sms',
}

export enum ReservedRoomBlockStatus {
  active = 'active',
  cancelled = 'cancelled',
  inactive = 'inactive',
  pending = 'pending',
}

/** General information for an Event */
export enum EventType {
  babyRegistry = 'babyRegistry',
  card = 'card',
  general = 'general',
  wedding = 'wedding',
}

export enum QandaType {
  faq = 'faq',
  tidbit = 'tidbit',
}

export enum CustomItemDataType {
  cash = 'cash',
  charity = 'charity',
  gift = 'gift',
}

export enum DonationFundPaymentMethodEnum {
  cashapp = 'cashapp',
  cashOrCheck = 'cashOrCheck',
  joyCredit = 'joyCredit',
  other = 'other',
  paypal = 'paypal',
  venmo = 'venmo',
}

export enum FeePaidByEnum {
  couple = 'couple',
  guest = 'guest',
}

export enum DonationFundPlatformTypeEnum {
  cashapp = 'cashapp',
  cashOrCheck = 'cashOrCheck',
  other = 'other',
  paypal = 'paypal',
  venmo = 'venmo',
}

/**
 * Structured country data is prefered (i.e. the countryCode with
 * the country field set to that countrys name). For freeform country
 * omit the countryCode (null / undefined).
 */
export type ShippingAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  validated?: InputMaybe<Scalars['Boolean']>;
};

export enum LegacyRegistryItemType {
  canned = 'canned',
  custom = 'custom',
  product = 'product',
}

export enum RegistryItemRecommendationStatus {
  skipped = 'skipped',
  swapped = 'swapped',
  unseen = 'unseen',
}

export enum RegistryRecommendationStatus {
  /** The couple has completed viewing and selecting their recommendations */
  completed = 'completed',
  /** registry has recommendations, but couple has not viewed them yet */
  hasRecommendations = 'hasRecommendations',
  /**
   * The couple is in progress viewing and selecting recommendations,
   * but has not viewed the entire selection yet
   */
  inProgress = 'inProgress',
  /** has not started the recommendations process */
  notStarted = 'notStarted',
}

export enum RegistryType {
  /** An adopted external registry that was transferred from the transitional registry. */
  adopted = 'adopted',
  /** Simply add a link to any external registry. */
  linked = 'linked',
  /** Internal registry managed in Joy. */
  standalone = 'standalone',
  /** Automatically and periodically import items from an external registry into Joy. */
  synced = 'synced',
  /** Move an external registry into Joy, manage items, and see gift details within Joy. */
  transferred = 'transferred',
}

export enum SafetyRating {
  none = 'none',
  safeOverride = 'safeOverride',
  unsafeRequiresEscalation = 'unsafeRequiresEscalation',
}

/**
 * public: only isPublic schedule rows (DB filter; same set for anyone who can open schedule).
 * all: default — admin sees all items; guest sees public plus invited private.
 */
export enum EventScheduleEventsToInclude {
  all = 'all',
  public = 'public',
}

export enum TravelType {
  booking = 'booking',
  ferry = 'ferry',
  flight = 'flight',
  hotel = 'hotel',
  list = 'list',
  note = 'note',
  rentalCar = 'rentalCar',
  rentalHome = 'rentalHome',
  shuttle = 'shuttle',
  taxi = 'taxi',
  tent = 'tent',
  train = 'train',
}

export enum LegacyRsvpQuestionSubtype {
  advice = 'advice',
  attendance = 'attendance',
  food = 'food',
  honeymoon = 'honeymoon',
  hotel = 'hotel',
  multipleChoice = 'multipleChoice',
  phone = 'phone',
  song = 'song',
  text = 'text',
}

export enum LegacyRsvpQuestionType {
  multipleChoice = 'multipleChoice',
  plainText = 'plainText',
}

/** All possible media approval states, including PENDING (set automatically on guest uploads) */
export enum MediaApprovalStatus {
  /** Approved by an admin */
  APPROVED = 'APPROVED',
  /** Removed from collection */
  DELETED = 'DELETED',
  /** Awaiting admin review */
  PENDING = 'PENDING',
  /** Rejected by an admin */
  REJECTED = 'REJECTED',
}

export enum MagicTokenPermissions {
  upload = 'upload',
  view = 'view',
}

export enum MediaCollectionDisplayMode {
  DEFAULT = 'DEFAULT',
  LIVE_SLIDESHOW = 'LIVE_SLIDESHOW',
}

export enum MediaCollectionSortField {
  CREATED_AT = 'CREATED_AT',
  TAKEN_AT = 'TAKEN_AT',
}

export enum MediaCollectionSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum ComponentType {
  eventCountdown = 'eventCountdown',
  eventDetails = 'eventDetails',
  eventDisplayName = 'eventDisplayName',
  greetingMessage = 'greetingMessage',
  jsonDataBlob = 'jsonDataBlob',
  mediaGallery = 'mediaGallery',
  photo = 'photo',
  rsvpAndUnlockGuestDetailsButton = 'rsvpAndUnlockGuestDetailsButton',
  text = 'text',
  travelMap = 'travelMap',
  video = 'video',
}

export enum PointOnMapType {
  venue = 'venue',
}

export enum PageContentType {
  default = 'default',
  userGenerated = 'userGenerated',
}

export enum PhotoXPosition {
  center = 'center',
  left = 'left',
  right = 'right',
}

export enum PhotoYPosition {
  bottom = 'bottom',
  center = 'center',
  top = 'top',
}

export enum EventPageVisibility {
  hidden = 'hidden',
  passwordProtected = 'passwordProtected',
  public = 'public',
}

export enum EventPlaceType {
  venue = 'venue',
}

export type RegistryPayoutAccountOnboardingUrlParamsInput = {
  /**
   * Route where user can start onboarding one more time(as it was not possible to load onboardingUrl this time).
   * For example(default value): "/edit/registry/credit-card/setup"
   */
  restartRoute?: InputMaybe<Scalars['String']>;
  /**
   * Route where users should be returned after they either completed onboarding flow or cancelled it.
   * For example(default value): "/edit/registry/manage?setupCreditCard=true"
   */
  returnRoute?: InputMaybe<Scalars['String']>;
};

/** Settings information for an Event */
export enum PrivacyModeType {
  custom = 'custom',
  private = 'private',
  public = 'public',
}

export enum Layout {
  aloha = 'aloha',
  brannan = 'brannan',
  harrison = 'harrison',
  hennepin = 'hennepin',
}

export enum EventWebsiteState {
  draft = 'draft',
  published = 'published',
}

export type EventUsersFilter = {
  types?: InputMaybe<Array<EventType>>;
};

export enum FeedMessagePushNotificationTypeEnum {
  marketing = 'marketing',
  registryItemOrdered = 'registryItemOrdered',
  unknown = 'unknown',
}

export enum FeedMessageStatusEnum {
  read = 'read',
  seen = 'seen',
  unknown = 'unknown',
  unread = 'unread',
}

export enum FeedMessageTargetIdentifierType {
  registryItemId = 'registryItemId',
  unknown = 'unknown',
  url = 'url',
}

export enum FeedMessageTypeEnum {
  email = 'email',
  generic = 'generic',
  pushNotification = 'pushNotification',
  test = 'test',
  unknown = 'unknown',
}

export enum VendorTypeEnum {
  catering = 'catering',
  dessert = 'dessert',
  djs = 'djs',
  florist = 'florist',
  makeup = 'makeup',
  misc = 'misc',
  officiants = 'officiants',
  photo = 'photo',
  planners = 'planners',
  rental = 'rental',
  transport = 'transport',
  venue = 'venue',
  video = 'video',
}

export enum CredentialTypeEnum {
  APPLE = 'APPLE',
  GOOGLE = 'GOOGLE',
  OUTLOOK = 'OUTLOOK',
}

export enum RoleTypeEnum {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  USER = 'USER',
}

export enum MatchStatus {
  connected = 'connected',
  hired = 'hired',
  matched = 'matched',
  saved = 'saved',
  suggested = 'suggested',
}

export enum VendorState {
  alreadyHired = 'alreadyHired',
  interested = 'interested',
  notInterested = 'notInterested',
  started = 'started',
}

export enum MetaTagFilter {
  event = 'event',
  user = 'user',
  vendor = 'vendor',
}

export enum AccommodationCatalogPhotoSubjectType {
  PROPERTY_LOBBY = 'PROPERTY_LOBBY',
  PROPERTY_MAIN_ENTRANCE = 'PROPERTY_MAIN_ENTRANCE',
  PROPERTY_MAIN_PHOTO = 'PROPERTY_MAIN_PHOTO',
  PROPERTY_RESTAURANT = 'PROPERTY_RESTAURANT',
  PROPERTY_UNKNOWN = 'PROPERTY_UNKNOWN',
  ROOM_BATHROOM = 'ROOM_BATHROOM',
  ROOM_BEDS = 'ROOM_BEDS',
  ROOM_UNKNOWN = 'ROOM_UNKNOWN',
}

export enum AccommodationCatalogPropertyType {
  Affittacamere = 'Affittacamere',
  AgritourismProperty = 'AgritourismProperty',
  AllInclusiveProperty = 'AllInclusiveProperty',
  Aparthotel = 'Aparthotel',
  Apartment = 'Apartment',
  BedAndBreakfast = 'BedAndBreakfast',
  Boat = 'Boat',
  Bungalow = 'Bungalow',
  Cabin = 'Cabin',
  Campsite = 'Campsite',
  Chalet = 'Chalet',
  Condo = 'Condo',
  Cottage = 'Cottage',
  CountryHouse = 'CountryHouse',
  Cruise = 'Cruise',
  FarmStay = 'FarmStay',
  GuestAccommodation = 'GuestAccommodation',
  GuestHouse = 'GuestHouse',
  HolidayPark = 'HolidayPark',
  Homes = 'Homes',
  Homestay = 'Homestay',
  Hostel = 'Hostel',
  Hotel = 'Hotel',
  House = 'House',
  Houseboat = 'Houseboat',
  Inn = 'Inn',
  Lodge = 'Lodge',
  MobileHome = 'MobileHome',
  Motel = 'Motel',
  Palace = 'Palace',
  Pension = 'Pension',
  Pousada = 'Pousada',
  PrivateVacationHome = 'PrivateVacationHome',
  Ranch = 'Ranch',
  Residence = 'Residence',
  Resort = 'Resort',
  Riad = 'Riad',
  Ryokan = 'Ryokan',
  Tent = 'Tent',
  Tourist = 'Tourist',
  Unknown = 'Unknown',
  Villa = 'Villa',
}

export enum TravelOfferProvider {
  nuitee = 'nuitee',
  zh = 'zh',
}

export enum TravelReviewerType {
  COUPLE = 'COUPLE',
  FAMILY = 'FAMILY',
  FRIENDS = 'FRIENDS',
  SOLO = 'SOLO',
  UNKNOWN = 'UNKNOWN',
}

export enum TravelPurpose {
  BUSINESS = 'BUSINESS',
  LEISURE = 'LEISURE',
  UNKNOWN = 'UNKNOWN',
}

export type AdminReservationSearchInput = {
  /** Start of date range filter (defaults to 1 year ago) */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  /** End of date range filter (defaults to now) */
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  /** Number of results to return (1–100, default 20) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of results to skip (default 0) */
  offset?: InputMaybe<Scalars['Int']>;
  /** Search term — partial match against email, confirmation codes (Joy / ZH / Nuitee / property), or guest name */
  query: Scalars['String'];
};

export type AdminVendorListPayload = {
  count: Scalars['Int'];
};

export type TravelPricingsComparisonPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsComparisonMetadata>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  propertyIdentifier: AccommodationCatalogPropertyIdentifierInput;
};

/** A checkIn/checkOut pair of dates (allows for +/- 2 days), like Kayak using range types */
export type AccommodationCatalogStayDatesInput = {
  checkIn: AccommodationCatalogDateRangeInput;
  checkOut: AccommodationCatalogDateRangeInput;
};

/** A inclusive range of dates [low, high]. When low = high or  it mean this objects represents a single date */
export type AccommodationCatalogDateRangeInput = {
  high: Scalars['DateOnlyString'];
  low: Scalars['DateOnlyString'];
};

export type TravelPricingsComparisonMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum DeviceType {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
}

/** Room occupancy information when searching for offers */
export type AccommodationCatalogUnitsOccupancyInput = {
  /** Details for the number of Adults and Children staying in each room. If size of array is more than unitCount, then the first unitCount entries are considered. If the number of entries is less then some defaults will be assumed */
  occupancies?: InputMaybe<Array<AccommodationCatalogUnitOccupancyInput>>;
  /** The number of rooms needed. */
  unitCount?: Scalars['Int'];
};

/** Room occupancy information when searching for offers on a single unit */
export type AccommodationCatalogUnitOccupancyInput = {
  /** Number of adults who will be staying in this unit */
  adults: Scalars['Int'];
  /** Ages of children who will be staying in this unit, if known, otherwise array of nulls */
  childrenAges: Array<InputMaybe<Scalars['Int']>>;
};

export type TravelPricingsBatchComparisonPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsComparisonMetadata>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  propertyIdentifiers: Array<AccommodationCatalogPropertyIdentifierInput>;
};

export enum AttendanceState {
  ATTENDING = 'ATTENDING',
  MAYBE = 'MAYBE',
  NOT_ATTENDING = 'NOT_ATTENDING',
  PENDING = 'PENDING',
}

export type AutopopulateOperationsByEventIdPayload = {
  eventId: Scalars['ID'];
};

export enum IdempotentOperationType {
  autoAccommodation = 'autoAccommodation',
  autoStayAreas = 'autoStayAreas',
  generateRecommendations = 'generateRecommendations',
  travelAlertNotification = 'travelAlertNotification',
}

export enum AutopopulateJobStatusV5 {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

export type AutopopulateStayAreaOperationsByEventIdPayload = {
  eventId: Scalars['ID'];
};

/** Status of a stay area */
export enum StayAreaStatus {
  abandoned = 'abandoned',
  added = 'added',
  pending = 'pending',
}

export type BookingSlotByEmailArgs = {
  bookingTypeHandle?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  vendorHandle?: InputMaybe<Scalars['String']>;
};

export enum BookingTypeLocationType {
  CUSTOM = 'CUSTOM',
  DEFAULT = 'DEFAULT',
}

export enum BookingTypeProcessType {
  INSTANT = 'INSTANT',
  REQUEST = 'REQUEST',
}

export enum BookingTypeEventType {
  INPERSON = 'INPERSON',
  PHONECALL = 'PHONECALL',
  VIDEOCALL = 'VIDEOCALL',
}

export enum BookingSlotVenueEventType {
  CORPORATE = 'CORPORATE',
  GALA_NONPROFIT = 'GALA_NONPROFIT',
  INTERNAL = 'INTERNAL',
  OTHER = 'OTHER',
  SOCIAL = 'SOCIAL',
  WEDDING = 'WEDDING',
}

export enum BookingSlotStatusType {
  CONFIRMED = 'CONFIRMED',
  EXPIRED = 'EXPIRED',
  REJECTED = 'REJECTED',
  REQUESTED = 'REQUESTED',
}

export type DateFilter = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

/**
 * Input for calculating a cash fund contribution receipt.
 * Expressing the Currency here is not required; it depends upon the connected Payout Account
 */
export type CalculateCashFundContributionReceiptInput = {
  cashFundId: Scalars['ID'];
  contributionAmountInMinorUnits: Scalars['Int'];
};

/** We expect it will slowly evolve and start looking like CreateRegistryPurchaseContextInput type */
export type CalculateRegistryPurchaseInfoInput = {
  address?: InputMaybe<ShippingAddressInput>;
  eCard?: InputMaybe<ECard>;
  eventId: Scalars['ID'];
  lineItems?: InputMaybe<Array<RegistryLineItemInput>>;
  printOrder?: InputMaybe<PrintOrder>;
};

export type ECard = {
  details?: InputMaybe<Array<ECardDetails>>;
  emailDraftId: Scalars['String'];
  imageURL?: InputMaybe<Scalars['String']>;
  offerType?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  type: Scalars['String'];
};

export type ECardDetails = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type RegistryLineItemInput = {
  /**
   * An opaque value provided as result from an earlier API call
   *
   * Initially any non-empty value will trigger an attempt to apply wedding completion discount
   */
  discountCampaign?: InputMaybe<Scalars['String']>;
  /**
   * For the case of standard dropship item - it is a quantity value for line item.
   * For the case of cash fund - it is a way to provide amount which will be given with this purchase in cents. So quantity=100 means $1.
   */
  quantity: Scalars['Int'];
  registryItemId: Scalars['ID'];
};

export type PrintOrder = {
  orderId: Scalars['String'];
};

export enum HandleStatus {
  available = 'available',
  unavailable = 'unavailable',
}

export enum InvalidTransitionalRegistryUrlReasonCode {
  invalidRegistryUrl = 'invalidRegistryUrl',
  registryIsPrivate = 'registryIsPrivate',
  registryUnavailable = 'registryUnavailable',
  unsupportedDomain = 'unsupportedDomain',
}

export type ProductHeuristicSearchInput = {
  lines: Array<ProductHeuristicSearchInput_Line>;
  shippingAddress: ProductHeuristicSearchInput_ShippingAddress;
};

export type ProductHeuristicSearchInput_Line = {
  productInfo: ProductHeuristicSearchInput_Line_ProductInfo;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type ProductHeuristicSearchInput_Line_ProductInfo = {
  externalUrl?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<ProductHeuristicSearchInput_Price>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProductHeuristicSearchInput_Price = {
  currencyCode: Scalars['String'];
  valueInMinorUnits: Scalars['Int'];
};

export type ProductHeuristicSearchInput_ShippingAddress = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
};

/**
 * A strategy by which the Client may present Attribute Values to the user for selection.
 *
 * Each is a combination of short-codes.
 *
 * eg. 'image', 'Carousel', 'Multi' =
 *   "Display a Carousel of images from which the User can make multiple selections."
 */
export enum ProductCatalogAttributeSelectionType {
  colorListMulti = 'colorListMulti',
  imageListMulti = 'imageListMulti',
  priceBucket = 'priceBucket',
  priceRange = 'priceRange',
  /** aka. 'titleListMulti' */
  stringListMulti = 'stringListMulti',
}

/**
 * The field within an Attribute Value to be used for presentation by the Client.
 *
 * This Type is similar to GroupDimensionSwatchType.
 */
export enum ProductCatalogAttributeValueType {
  /** The Value should be presented as a swatch of its color hex value */
  color = 'color',
  /** The Value should be presented using its image URL */
  image = 'image',
  price = 'price',
  /** The Value should be presented as a string of text (usually its title) */
  title = 'title',
}

export enum ProductCatalogCollectionType {
  brand = 'brand',
  productFamily = 'productFamily',
  relatedProducts = 'relatedProducts',
}

export enum ProductCatalogDisplayType {
  carousel = 'carousel',
}

export enum ProductCatalogCurationSource {
  expert = 'expert',
  joy = 'joy',
}

export enum PDPSectionType {
  details = 'details',
  gallery = 'gallery',
  highlight = 'highlight',
  productAction = 'productAction',
  productFamilyCollections = 'productFamilyCollections',
  relatedProductCollections = 'relatedProductCollections',
}

/**
 * Supported Dimension swatch types
 * A "swatch" is a visual element representing a Dimension Option; usually it is selectable
 *
 * This Type is similar to ProductCatalogAttributeValueType.
 */
export enum GroupDimensionSwatchType {
  color = 'color',
  image = 'image',
  none = 'none',
}

export enum ProductCatalogAssetType {
  photo = 'photo',
  video = 'video',
}

/** Different types of catalog item tree roots */
export enum CatalogTreeRootInput {
  curations = 'curations',
  /** The default department, category, sub-category hierarchy */
  default = 'default',
  registryStoreRecommendations = 'registryStoreRecommendations',
}

export enum PDPElementType {
  body = 'body',
  heading = 'heading',
  photo = 'photo',
  sectionHeader = 'sectionHeader',
}

export type RatingReviewQueryInput = {
  orderBy?: InputMaybe<RatingReviewOrderBy>;
};

export enum RatingReviewOrderBy {
  newest = 'newest',
  oldest = 'oldest',
  ratingAsc = 'ratingAsc',
  ratingDesc = 'ratingDesc',
}

export enum RatingReviewAssetType {
  photo = 'photo',
  video = 'video',
}

/**
 * The 'Storefront Status' indicates how Merch wants a Catalog Item to behave
 * RE: whether it can be purchased, added to a Registry, found in a search result, etc.
 */
export enum ProductCatalogStorefrontStatus {
  /** This Catalog Item is fully available for search, add-to-Registry, and purchase. */
  available = 'available',
  /** This Catalog Item has a long out-of-stock window, and cannot be purchased today. */
  backordered = 'backordered',
  /** This Catalog Item cannot be purchased today, but can be added to a Registry anticipating future inventory. */
  comingSoon = 'comingSoon',
  /** This Catalog Item can no longer be added to a Registry, but can be purchased if previously added. */
  delisted = 'delisted',
  /** This Catalog Item is no longer available, as a permanent state. */
  discontinued = 'discontinued',
}

export enum ProductCatalogItemTilePresentationType {
  childDetails = 'childDetails',
  parentDetails = 'parentDetails',
}

export type ContactQuarantinedMessageBatchFilter = {
  eventId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  messageBatchId?: InputMaybe<Scalars['ID']>;
  messageBatchType?: InputMaybe<Scalars['String']>;
  quarantineStatus?: InputMaybe<QuarantineStatus>;
};

export enum QuarantineStatus {
  approved = 'approved',
  canceled = 'canceled',
  rejected = 'rejected',
  review = 'review',
}

export type ContactQuarantinedMessageBatchSort = {
  createdAt?: InputMaybe<FilterDirection>;
};

export enum FilterDirection {
  asc = 'asc',
  desc = 'desc',
}

export type GetDesignGuestSiteTargetPayload = {
  layout: DesignLayoutType;
  themeId: Scalars['String'];
};

export enum EmailTemplateType {
  generalMessage = 'generalMessage',
  registrationApproval = 'registrationApproval',
}

export type EventTypesByCategoryFilters = {
  category?: InputMaybe<Array<Scalars['String']>>;
  categorySubtype?: InputMaybe<Array<Scalars['String']>>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Array<Scalars['String']>>;
};

export type EventVipsPayload = {
  eventId: Scalars['ID'];
};

export type CashFundsPayoutAccountOnboardingUrlParams = {
  /** Route where user can start onboarding one more time (as it was not possible to load onboardingUrl this time). */
  restartRoute?: InputMaybe<Scalars['String']>;
  /** Route where users should be returned after they either completed onboarding flow or canceled it. */
  returnRoute?: InputMaybe<Scalars['String']>;
};

export type FindDefaultThingsToDoPagePayload = {
  eventId: Scalars['ID'];
};

export type EmailSearchCriteria = {
  emailType?: InputMaybe<Scalars['String']>;
  endCreateDate?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  fromEmail?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  startCreateDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  toEmail?: InputMaybe<Scalars['String']>;
};

export type FindHotelMatchRateInput = {
  adults: Scalars['Float'];
  checkIn: Scalars['String'];
  checkOut: Scalars['String'];
  currencyISO4217: Scalars['String'];
  guestNationalityISO2: Scalars['String'];
};

export type FindMatchingAccommodationCatalogPropertiesByDetailsPayload = {
  eventId?: InputMaybe<Scalars['String']>;
  hotelDetails: AccommodationCatalogPropertyDetailsPayload;
  metadata?: InputMaybe<FindMatchingAccommodationCatalogPropertiesByDetailsMetadata>;
};

export type AccommodationCatalogPropertyDetailsPayload = {
  city: Scalars['String'];
  countryCode: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  long?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type FindMatchingAccommodationCatalogPropertiesByDetailsMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type FindMatchingAccommodationCatalogPropertyPayload = {
  sourceId: Scalars['String'];
  sourceType: AccommodationPlaceSourceType;
};

/** AccommodationPlaceSourceType */
export enum AccommodationPlaceSourceType {
  google = 'google',
  joyPlace = 'joyPlace',
  nuitee = 'nuitee',
  zh = 'zh',
}

export type FormAnswerFilters = {
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  formId?: InputMaybe<Scalars['ID']>;
  guestKey?: InputMaybe<Scalars['String']>;
};

/**
 * State of a ticket type - controls whether tickets can be purchased.
 * Designed for extensibility (future states can be added).
 */
export enum TicketTypeState {
  /** Available for purchase (subject to capacity/dates) */
  ACTIVE = 'ACTIVE',
  /** Not available for purchase (hidden or paused) */
  INACTIVE = 'INACTIVE',
}

export enum FormType {
  OTHER = 'OTHER',
  REGISTRATION = 'REGISTRATION',
  SURVEY = 'SURVEY',
}

export type FormFilters = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type FormTemplateFilters = {
  eventCategoryTags?: InputMaybe<Array<Scalars['String']>>;
  eventSubTypeTags?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type GetCashFundForContributionInput = {
  cashFundId: Scalars['ID'];
  /**
   * Links a specific Invite to the Contribution.
   * The 'inviteToken' has higher priority when linking an Invite. If an 'inviteToken' is provided, this property is ignored.
   * Note: If a guest has multiple Invites for the same Cash Fund (from different Solicitations),
   * the system will automatically select the Invite with the fewest existing Contributions.
   */
  guestKey?: InputMaybe<Scalars['String']>;
  /** Links a specific Invite to the Contribution. */
  inviteToken?: InputMaybe<Scalars['String']>;
};

export enum CollaborationInviteState {
  accepted = 'accepted',
  pending = 'pending',
  revoked = 'revoked',
}

export enum EcardType {
  changethedate = 'changethedate',
  custom = 'custom',
  invitation = 'invitation',
  savethedate = 'savethedate',
  savethedatephoto = 'savethedatephoto',
}

export type EventSearchCriteria = {
  coupleNames?: InputMaybe<Scalars['String']>;
  eventTypes?: InputMaybe<Array<EventType>>;
  includeAllPastEvents?: InputMaybe<Scalars['Boolean']>;
};

export type GuestListMemberSort = {
  direction: SortDirection;
  field: GuestListMemberSortField;
};

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum GuestListMemberSortField {
  ADDRESS_LINE_1 = 'ADDRESS_LINE_1',
  ADDRESS_LINE_2 = 'ADDRESS_LINE_2',
  ATTENDANCE_STATUS = 'ATTENDANCE_STATUS',
  CITY = 'CITY',
  COUNTRY = 'COUNTRY',
  DISPLAY_NAME = 'DISPLAY_NAME',
  EMAIL = 'EMAIL',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  STATE = 'STATE',
  ZIP = 'ZIP',
}

export enum GuestlistColumnDisplayState {
  DEFAULT = 'DEFAULT',
  DISABLED = 'DISABLED',
  HIDDEN = 'HIDDEN',
}

export enum GuestlistColumnScope {
  CONTACT = 'CONTACT',
  EVENT = 'EVENT',
}

export enum GuestlistCustomColumnType {
  BOOLEAN = 'BOOLEAN',
  CHECKBOX = 'CHECKBOX',
  CURRENCY = 'CURRENCY',
  DATE = 'DATE',
  EMAIL = 'EMAIL',
  LONG_TEXT = 'LONG_TEXT',
  MULTI_SELECT = 'MULTI_SELECT',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  RICH_TEXT = 'RICH_TEXT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT = 'TEXT',
}

export type TravelHotelReviewsInput = {
  joyPlaceId: Scalars['String'];
  language?: Scalars['String'];
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<TravelOfferProvider>;
  sort?: InputMaybe<TravelReviewSortInput>;
};

export type TravelReviewSortInput = {
  field: TravelReviewSortField;
  order: TravelReviewSortOrder;
};

export enum TravelReviewSortField {
  DATE = 'DATE',
  RATING = 'RATING',
}

export enum TravelReviewSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type MessageRelationshipCriteria = {
  externalMessageIds: Array<Scalars['String']>;
  relationshipTag?: InputMaybe<Scalars['String']>;
};

/**
 * Messaging tier for an event. Determines which messaging features are enabled.
 * - basic: Free tier, email-only messaging (equivalent to null for backwards compatibility)
 * - messagingPlus: Paid tier, enables SMS messaging in addition to email
 */
export enum MessagingTier {
  basic = 'basic',
  messagingPlus = 'messagingPlus',
}

export enum PhoneNumberDeliveryMethod {
  sms = 'sms',
}

export enum PostOfficeMessageType {
  generic = 'generic',
  giftWrap = 'giftWrap',
  greetingCard = 'greetingCard',
  reminder = 'reminder',
  thankyou = 'thankyou',
}

export enum RegistryStoreConnectAction {
  link = 'link',
  sync = 'sync',
  transfer = 'transfer',
}

export type ImageSizingCriteria = {
  maxHeight?: InputMaybe<Scalars['Int']>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  pixelRatio?: InputMaybe<Scalars['Int']>;
};

export enum RsvpDeadlineStatus {
  closed = 'closed',
  disabled = 'disabled',
  gracePeriod = 'gracePeriod',
  open = 'open',
}

export type GetThingsToDoContainersPayload = {
  eventId: Scalars['ID'];
};

export type GoogleCalendarLinkStateInput = {
  referrerUri: Scalars['String'];
  vendorUserId: Scalars['ID'];
};

export enum JoyFeatureType {
  liveSlideshow = 'liveSlideshow',
  messagingPlus = 'messagingPlus',
}

export type HotelInventoryByIdsRequest = {
  hotelIds: Array<Scalars['String']>;
  metadata?: InputMaybe<HotelInventoryByIdsRequestMetadata>;
};

export type HotelInventoryByIdsRequestMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum HotelTypeEnum {
  Affittacamere = 'Affittacamere',
  AgritourismProperty = 'AgritourismProperty',
  AllInclusiveProperty = 'AllInclusiveProperty',
  Aparthotel = 'Aparthotel',
  Apartment = 'Apartment',
  BedAndBreakfast = 'BedAndBreakfast',
  Boat = 'Boat',
  Bungalow = 'Bungalow',
  Cabin = 'Cabin',
  Campsite = 'Campsite',
  Chalet = 'Chalet',
  Condo = 'Condo',
  Cottage = 'Cottage',
  CountryHouse = 'CountryHouse',
  Cruise = 'Cruise',
  FarmStay = 'FarmStay',
  GuestAccommodation = 'GuestAccommodation',
  GuestHouse = 'GuestHouse',
  HolidayPark = 'HolidayPark',
  Homes = 'Homes',
  Homestay = 'Homestay',
  Hostel = 'Hostel',
  Hotel = 'Hotel',
  House = 'House',
  Houseboat = 'Houseboat',
  Inn = 'Inn',
  Lodge = 'Lodge',
  MobileHome = 'MobileHome',
  Motel = 'Motel',
  Palace = 'Palace',
  Pension = 'Pension',
  Pousada = 'Pousada',
  PrivateVacationHome = 'PrivateVacationHome',
  Ranch = 'Ranch',
  Residence = 'Residence',
  Resort = 'Resort',
  Riad = 'Riad',
  Ryokan = 'Ryokan',
  Tent = 'Tent',
  Tourist = 'Tourist',
  Unknown = 'Unknown',
  Villa = 'Villa',
}

export type HotelInventoryByRadiusRequest = {
  hotelInventorySearchType?: InputMaybe<HotelInventorySearchType>;
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  metadata?: InputMaybe<HotelInventoryByRadiusRequestMetadata>;
  radiusInKM: Scalars['Float'];
};

export enum HotelInventorySearchType {
  ALL = 'ALL',
}

export type HotelInventoryByRadiusRequestMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type HotelRoomsAndRatesRequest = {
  checkIn: Scalars['DateOnly'];
  checkOut: Scalars['DateOnly'];
  currency: TravelCurrencyCode;
  hotelId: Scalars['String'];
  occupancies: Array<HotelRoomsAndRatesRequestOccupancy>;
};

export type HotelRoomsAndRatesRequestOccupancy = {
  childrenAges?: InputMaybe<Array<Scalars['Int']>>;
  numOfAdults: Scalars['Int'];
};

export type HotelRoomsAndRatesByLocationRequest = {
  checkIn: Scalars['DateOnly'];
  checkOut: Scalars['DateOnly'];
  currency: TravelCurrencyCode;
  hotelInventorySearchType?: InputMaybe<HotelInventorySearchType>;
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  metadata?: InputMaybe<HotelInventoryByRadiusRequestMetadata>;
  occupancies: Array<HotelRoomsAndRatesRequestOccupancy>;
  radiusInKM: Scalars['Float'];
};

export type HotelSuggestionRequest = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  hotelInventorySearchType?: InputMaybe<HotelInventorySearchType>;
  metadata?: InputMaybe<HotelInventoryRequestMetadata>;
  size?: InputMaybe<Scalars['Float']>;
  term: Scalars['String'];
};

export type HotelInventoryRequestMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type ImproveTextInput = {
  /** The type of improvement to apply */
  action: TextImprovementAction;
  /** The context in which the text will be used */
  context: TextContext;
  /** Custom instructions for NEW_DRAFT and MANUAL actions */
  customInstructions?: InputMaybe<Scalars['String']>;
  /** The event ID for which this text improvement is being requested */
  eventId: Scalars['String'];
  /** Additional metadata for text improvement */
  metadata?: InputMaybe<TextImprovementMetadata>;
  /** The raw text to improve */
  rawText: Scalars['String'];
};

/** The type of text improvement to apply */
export enum TextImprovementAction {
  CONCISE = 'CONCISE',
  EXPAND = 'EXPAND',
  FRIENDLY = 'FRIENDLY',
  MANUAL = 'MANUAL',
  NEW_DRAFT = 'NEW_DRAFT',
  PROFESSIONAL = 'PROFESSIONAL',
  PROOFREAD = 'PROOFREAD',
  REWRITE = 'REWRITE',
  SIMPLIFY = 'SIMPLIFY',
}

/** The context in which the text will be used */
export enum TextContext {
  EMAIL_EVENT_HOST_TO_GUESTS = 'EMAIL_EVENT_HOST_TO_GUESTS',
  EMAIL_TO_GUESTS = 'EMAIL_TO_GUESTS',
  GENERAL = 'GENERAL',
  INVITATION_MESSAGE = 'INVITATION_MESSAGE',
  THANK_YOU_NOTE = 'THANK_YOU_NOTE',
  WEBSITE_COMPONENT = 'WEBSITE_COMPONENT',
}

export type TextImprovementMetadata = {
  /** Expected output format (html, markdown, or plaintext) */
  format?: InputMaybe<Scalars['String']>;
  /** Locale for language-specific improvements (e.g., "en-US", "es-ES") */
  locale?: InputMaybe<Scalars['String']>;
};

export type InsightRagQueryInput = {
  query: Scalars['String'];
};

export type InternalEventSearchCriteria = {
  dateCriteria?: InputMaybe<EventSearchDateCriteria>;
  eventTypes?: InputMaybe<Array<EventType>>;
};

export type EventSearchDateCriteria = {
  endDate?: InputMaybe<Scalars['String']>;
  searchField: EventSearchDateType;
  startDate?: InputMaybe<Scalars['String']>;
};

export enum EventSearchDateType {
  createAt = 'createAt',
  eventDate = 'eventDate',
}

/**
 * Search criteria for internal message queries.
 * Supports filtering by recipient, event, message batch, and date range.
 */
export type InternalMessageSearchCriteria = {
  email?: InputMaybe<Scalars['String']>;
  endCreateDate?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  guestKey?: InputMaybe<Scalars['String']>;
  messageBatchId?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  startCreateDate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MessageType>;
};

export enum MessageType {
  email = 'email',
  sms = 'sms',
}

export type IsPageContainerSlugAvailablePayload = {
  eventId: Scalars['ID'];
  pageSlug: Scalars['String'];
};

export type JoyPlaceBySourceIdRequest = {
  /** The `eventId` argument is deprecated. Use the `externalPDP` field with the appropriate alternative approach instead. */
  eventId?: InputMaybe<Scalars['ID']>;
  sourceId: Scalars['String'];
  sourceType: Scalars['String'];
};

export type JoyPlacesBySourceIdsRequest = {
  sourceIds: Array<Scalars['String']>;
  sourceType: Scalars['String'];
};

export type JsonDataContainerByIdPayload = {
  id: Scalars['ID'];
};

export type LinkRedirectBlockFilter = {
  blockType?: InputMaybe<BlockType>;
  id?: InputMaybe<Scalars['ID']>;
  targetValue?: InputMaybe<Scalars['String']>;
};

export enum BlockType {
  domain = 'domain',
  event = 'event',
  user = 'user',
}

export type LinkRedirectFilter = {
  active?: InputMaybe<Scalars['Boolean']>;
  eventId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  joyUrl?: InputMaybe<Scalars['Url']>;
  link?: InputMaybe<Scalars['String']>;
  quarantined?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type LocationSuggestionRequest = {
  countries?: InputMaybe<Array<Scalars['String']>>;
  size?: InputMaybe<Scalars['Float']>;
  term: Scalars['String'];
  types?: InputMaybe<Array<LocationSuggestionType>>;
};

export enum LocationSuggestionType {
  Airport = 'Airport',
  BusStation = 'BusStation',
  City = 'City',
  Country = 'Country',
  Hotel = 'Hotel',
  MultiCity = 'MultiCity',
  Neighborhood = 'Neighborhood',
  PointOfInterest = 'PointOfInterest',
  Region = 'Region',
  State = 'State',
  TrainStation = 'TrainStation',
}

export type MessageSearchQueryCriteria = {
  email?: InputMaybe<Scalars['String']>;
  endCreateDate?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  guestKey?: InputMaybe<Scalars['String']>;
  messageBatchId?: InputMaybe<Scalars['String']>;
  messageType?: InputMaybe<Scalars['String']>;
  personId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  startCreateDate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MessageType>;
};

export enum MessageStatus {
  delivered = 'delivered',
  failed = 'failed',
  none = 'none',
  pending = 'pending',
  read = 'read',
  sent = 'sent',
}

export enum MilestonesActivityAction {
  assignee_changed = 'assignee_changed',
  attachment_added = 'attachment_added',
  attachment_removed = 'attachment_removed',
  comment_added = 'comment_added',
  dependency_added = 'dependency_added',
  dependency_removed = 'dependency_removed',
  export_completed = 'export_completed',
  import_completed = 'import_completed',
  import_started = 'import_started',
  milestone_created = 'milestone_created',
  milestone_deleted = 'milestone_deleted',
  milestone_updated = 'milestone_updated',
  phase_changed = 'phase_changed',
  status_changed = 'status_changed',
}

export type MilestonesFilterInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<Array<MilestoneCategory>>;
  categoryId?: InputMaybe<Array<Scalars['ID']>>;
  dueAfter?: InputMaybe<Scalars['Timestamp']>;
  dueBefore?: InputMaybe<Scalars['Timestamp']>;
  phaseId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<MilestoneStatus>>;
};

export enum MilestoneCategory {
  accommodations = 'accommodations',
  analytics = 'analytics',
  connectivity = 'connectivity',
  expo = 'expo',
  finance = 'finance',
  governance = 'governance',
  hackathon = 'hackathon',
  logistics = 'logistics',
  operations = 'operations',
  procurement = 'procurement',
  production = 'production',
  program = 'program',
  protocol = 'protocol',
  registration = 'registration',
  schedule = 'schedule',
  security = 'security',
  speakers = 'speakers',
  sponsorship = 'sponsorship',
  venue = 'venue',
  website = 'website',
}

export enum MilestoneStatus {
  at_risk = 'at_risk',
  done = 'done',
  in_progress = 'in_progress',
  not_started = 'not_started',
}

export enum MilestonesImportExportFormat {
  csv = 'csv',
  ms_project_xml = 'ms_project_xml',
  xlsx = 'xlsx',
}

export enum MilestonesImportErrorSeverity {
  error = 'error',
  warning = 'warning',
}

export enum MilestonesImportOperation {
  create = 'create',
  skip = 'skip',
  update = 'update',
}

export enum MilestonesImportJobStatus {
  cancelled = 'cancelled',
  completed = 'completed',
  executing = 'executing',
  failed = 'failed',
  parsing = 'parsing',
  pending = 'pending',
  preview_ready = 'preview_ready',
}

export enum MilestoneGroupField {
  assignee = 'assignee',
  category = 'category',
  phase = 'phase',
  status = 'status',
}

export type MilestonesPaginationInput = {
  cursor?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type MilestonesSortInput = {
  direction: MilestonesSortDirection;
  field: MilestonesSortField;
};

export enum MilestonesSortDirection {
  asc = 'asc',
  desc = 'desc',
}

export enum MilestonesSortField {
  assigneeName = 'assigneeName',
  category = 'category',
  createdAt = 'createdAt',
  dueDate = 'dueDate',
  name = 'name',
  phaseSortOrder = 'phaseSortOrder',
  sortOrder = 'sortOrder',
  status = 'status',
}

export type NearbyAttractionsSearchPayload = {
  metadata: NearbyAttractionsSearchMetadata;
  point: TravelInputPoint;
};

export type NearbyAttractionsSearchMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type TravelInputPoint = {
  accommodationPlaceId?: InputMaybe<Scalars['String']>;
  geoLocation?: InputMaybe<TravelGeoLocation>;
  joyPlaceId?: InputMaybe<Scalars['String']>;
  pointType: TravelInputPointType;
};

export type TravelGeoLocation = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export enum TravelInputPointType {
  accommodationPlace = 'accommodationPlace',
  geoLocation = 'geoLocation',
  joyPlace = 'joyPlace',
}

export enum CheckoutType {
  STRIPE_NATIVE = 'STRIPE_NATIVE',
  VAULTERA_VAULT = 'VAULTERA_VAULT',
}

export enum SwitchNames {
  nuitee = 'nuitee',
  zh = 'zh',
}

/**
 * Order lifecycle states - determines how tickets are counted in TicketType.
 *
 * **RESERVED states** (tickets held, count towards reservedCount):
 * - PENDING_PAYMENT: Awaiting payment confirmation
 * - PENDING_APPROVAL: Awaiting manual approval (e.g., for comped tickets)
 *
 * **SOLD state** (tickets confirmed, count towards soldCount):
 * - COMPLETED: Payment confirmed, tickets issued
 *
 * **RELEASED states** (tickets returned to availability pool):
 * - CANCELLED: Order cancelled by user or admin
 * - EXPIRED: Payment window expired
 * - REFUNDED: Payment refunded
 */
export enum OrderStatus {
  /** Released: Order cancelled by user or admin */
  CANCELLED = 'CANCELLED',
  /** Sold: Payment confirmed, tickets issued */
  COMPLETED = 'COMPLETED',
  /** Released: Payment window expired */
  EXPIRED = 'EXPIRED',
  /** Reserved: Awaiting manual approval (e.g., comped tickets) */
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  /** Reserved: Awaiting payment confirmation */
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  /** Released: Payment refunded */
  REFUNDED = 'REFUNDED',
}

/** Status of a ticket. */
export enum TicketStatus {
  CANCELLED = 'CANCELLED',
  CHECKED_IN = 'CHECKED_IN',
  VALID = 'VALID',
}

/** Type of order based on payment requirements. */
export enum OrderType {
  COMPED = 'COMPED',
  FREE = 'FREE',
  PAID = 'PAID',
}

export type OutlookCalendarLinkStateInput = {
  referrerUri: Scalars['String'];
  vendorUserId: Scalars['ID'];
};

export type PageContainerBySlugOptions = {
  /** View from the Admin Perspective */
  admin?: InputMaybe<Scalars['Boolean']>;
};

export type PageContainerBySlugPayload = {
  eventName: Scalars['String'];
  pageSlug: Scalars['String'];
};

export type PhotosBySimpleTagsPayload = {
  exclude?: InputMaybe<Array<Scalars['String']>>;
  include: Array<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export type GuestNotFoundArgs = {
  buttonLink: Scalars['String'];
  guest: EmailPerson;
  recipient: EmailPerson;
  source?: InputMaybe<Scalars['String']>;
};

export type EmailPerson = {
  avatarUrl?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type MessageToHostArgs = {
  guest: EmailPerson;
  message: Scalars['String'];
  recipient: EmailPerson;
};

export type RequestCodeArgs = {
  code: Scalars['String'];
  guest: EmailPerson;
  recipient: EmailPerson;
  website: Scalars['String'];
};

export type TravelPricingsForAccommodationByRegionPayload = {
  accommodationSearchType?: InputMaybe<AccommodationSearchType>;
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByRegionPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  region: AccommodationCatalogRegionInput;
};

/** AccommodationSearchType */
export enum AccommodationSearchType {
  ALL = 'ALL',
}

export type TravelPricingsForAccommodationByRegionPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

/** Different ways to give a search region, only one of the fields should be non-null */
export type AccommodationCatalogRegionInput = {
  circular?: InputMaybe<AccommodationCatalogRegionCircularInput>;
};

/** Circular regions input (latitude and longitude) */
export type AccommodationCatalogRegionCircularInput = {
  /** Latitude in DD (Decimal Degrees) format. +ve is N and -ve is S of Equator */
  latitude: Scalars['Float'];
  /** Longitude in DD (Decimal Degrees) format, +ve is E and -ve is W of Meridian */
  longitude: Scalars['Float'];
  /** radius in KM */
  radius: Scalars['Int'];
};

export enum FeeType {
  payment_processing_fee = 'payment_processing_fee',
}

export type TravelPricingsForAccommodationByRegionV20250708Payload = {
  accommodationSearchType?: InputMaybe<AccommodationSearchType>;
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  executionSpeed?: InputMaybe<ExecutionSpeed>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByRegionV20250708PayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  region: AccommodationCatalogRegionInput;
};

/** Execution speed of the query, SLOW = 15s, NORMAL = 10s, FAST = 6s, FASTEST = 3s */
export enum ExecutionSpeed {
  FAST = 'FAST',
  FASTEST = 'FASTEST',
  NORMAL = 'NORMAL',
  SLOW = 'SLOW',
}

export type TravelPricingsForAccommodationByRegionV20250708PayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type ProductCatalogBrandsDirectoryQueryInput = {
  /** the category locator */
  category?: InputMaybe<Scalars['String']>;
  /** filter by storefront */
  storefront?: InputMaybe<CatalogStorefront>;
  /**
   * The category URL which ends with the category locator.
   * ie; /shop/brands/:CATEGORY_LOCATOR
   */
  url?: InputMaybe<Scalars['String']>;
};

export enum CatalogStorefront {
  baby = 'baby',
  wedding = 'wedding',
}

/** Reference to a ProductCatalogDisplayInfo, which doesn't have an ID and must be referenced by its displayInfoId and pdpSectionType */
export type ProductCatalogDisplayInfoRef = {
  displayInfoId: Scalars['ID'];
  pdpSectionType: Scalars['String'];
};

export type ProductCatalogItemRecommendationInput = {
  productUrl: Scalars['String'];
};

/** The order that input fields are evaluated is undefined and subject to change in the future */
export type ProductCatalogSearchQueryInput = {
  brandId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Payload for Filter, Search & Sort (FSS) criteria */
  filters?: InputMaybe<ProductCatalogSearchQueryFiltersInput>;
  /**
   * A Category or Item Locator.
   * Other types of Locators (eg. Brand) are not supported by the search logic.
   * NOTE:  A Curation is considered a Category.
   */
  locator?: InputMaybe<Scalars['String']>;
  /**
   * Criteria for sorting.
   * If null, the default is the first value in the 'ProductCatalogSearchQueryOrderBy' enum.
   */
  orderBy?: InputMaybe<ProductCatalogSearchQueryOrderBy>;
  type?: InputMaybe<CatalogTreeRootInput>;
  /**
   * A site URL.
   * The search logic supports URLs for Category, Item, Brand (since they can be differentiated by path structure)
   */
  url?: InputMaybe<Scalars['String']>;
};

/** Criteria for Filter, Search & Sort (FSS) */
export type ProductCatalogSearchQueryFiltersInput = {
  /**
   * Criteria for Filter by Attributes.
   *
   * Each Selection Group in the input is AND-ed into the resulting query.
   * Example: ('brand:kitchenaid' AND 'color:red'):
   *
   * filterSelectionGroups: [
   *   [ { groupCode: "brand", valueCodes: [ "kitchenaid" ] } ]
   *   [ { groupCode: "color", valueCodes: [ "red" ] } ]
   * ]
   */
  filterSelectionGroups?: InputMaybe<Array<ProductCatalogSearchQueryFiltersSelectionGroupInput>>;
  /** Criteria for full-text Search */
  queryText?: InputMaybe<Scalars['String']>;
};

/** Criteria for Filter by Attributes (part of FSS) */
export type ProductCatalogSearchQueryFiltersSelectionGroupInput = {
  /** A unique Attribute Group code */
  groupCode: Scalars['String'];
  /** OR */
  priceRange?: InputMaybe<ProductCatalogSearchQueryFiltersSelectionGroupMonetaryRangeInput>;
  /**
   * One or more unique Attribute Value codes.
   *
   * Each Attribute Value in the input is OR-ed into the resulting query.
   * Example: ('size:small' OR 'size:medium'):
   *
   * {
   *   groupCode: "size",
   *   valueCodes: [ "small", "medium" ]
   * }
   */
  valueCodes?: InputMaybe<Array<Scalars['String']>>;
};

export type ProductCatalogSearchQueryFiltersSelectionGroupMonetaryRangeInput = {
  maxValueInMinorUnits?: InputMaybe<Scalars['Int']>;
  minValueInMinorUnits?: InputMaybe<Scalars['Int']>;
};

/**
 * Possible sorting options.
 * Client should display the enum values in the same order.
 */
export enum ProductCatalogSearchQueryOrderBy {
  featured = 'featured',
  newArrivals = 'newArrivals',
  priceAsc = 'priceAsc',
  priceDesc = 'priceDesc',
}

export type ProductExternalSearchQueryInput = {
  text: Scalars['String'];
};

export type ProductHeroContentInputCriteria = {
  storefront?: InputMaybe<CatalogStorefront>;
};

export enum ProductHeroRedirectUrlType {
  external = 'external',
  inApp = 'inApp',
}

export enum ProductHeroGradientMode {
  custom = 'custom',
  dark = 'dark',
  light = 'light',
  none = 'none',
}

export enum ProductHeroHorizontalAlignment {
  center = 'center',
  left = 'left',
  right = 'right',
}

export enum ProductHeroTextColorMode {
  custom = 'custom',
  dark = 'dark',
  light = 'light',
}

export type ProductInventoryByCatalogItemIdInput = {
  catalogItemId: Scalars['ID'];
  reasonCode?: InputMaybe<InventoryCheckReasonCode>;
};

export enum InventoryCheckReasonCode {
  buyForSelfAvailability = 'buyForSelfAvailability',
  checkoutMechanismsRequest = 'checkoutMechanismsRequest',
  completionDiscount = 'completionDiscount',
  productInventoryRequest = 'productInventoryRequest',
  salesOrderCreation = 'salesOrderCreation',
  salesOrderFulfillment = 'salesOrderFulfillment',
}

/** @Deprecated */
export type ProductUniversalSearchQueryInput = {
  text: Scalars['String'];
};

/** Specifies how many results to return for a given source. */
export type ProductUniversalSearchSourceLimit = {
  /** Maximum number of results for a given source. */
  limit: Scalars['Int'];
  source: ProductUniversalItemSource;
};

export enum ProductUniversalItemSource {
  catalogSearch = 'catalogSearch',
  googleSearch = 'googleSearch',
  googleShoppingRegular = 'googleShoppingRegular',
  googleShoppingSponsored = 'googleShoppingSponsored',
}

export type RecentTravelReservationsByEventPayload = {
  eventId: Scalars['String'];
};

export type RegistryCatalogInventoryInput = {
  catalogItemId: Scalars['ID'];
  eventId?: InputMaybe<Scalars['ID']>;
};

export type AccommodationContentSearchInput = {
  circularRegionSearch?: InputMaybe<AccommodationCatalogRegionCircularInput>;
  maxResults?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<AccommodationContentSearchInputMetadata>;
  propertyIdentifiers?: InputMaybe<Array<AccommodationCatalogPropertyIdentifierInput>>;
};

export type AccommodationContentSearchInputMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type ExtendedAccommodationContentSearchPayload = {
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  /** Strategy for fetching accommodation content: cacheOnly (no API calls), preferCache (selective fields if cache miss), preferVendor (full fields from API). Default: preferVendor. */
  fetchStrategy?: InputMaybe<FetchStrategy>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  location: ExtendedAccommodationCatalogSearchLocation;
  metadata?: InputMaybe<ExtendedAccommodationContentSearchMetadata>;
  occupancies?: InputMaybe<AccommodationCatalogUnitsOccupancyInput>;
  radiusKM?: InputMaybe<Scalars['Float']>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  stayDates: AccommodationCatalogStayDatesInput;
  /** When true, skips cached pricing and fetches real-time pricing from providers. Default: false (uses cache for faster response). */
  useRealtimePricing?: InputMaybe<Scalars['Boolean']>;
};

/** Strategy for fetching accommodation content from cache vs vendor API */
export enum FetchStrategy {
  CACHE_ONLY = 'CACHE_ONLY',
  PREFER_CACHE = 'PREFER_CACHE',
  PREFER_VENDOR = 'PREFER_VENDOR',
}

export type ExtendedAccommodationCatalogSearchLocation = {
  /** Context of the location */
  context?: InputMaybe<ExtendedAccommodationCatalogSearchLocationContext>;
  /** Latitude in DD (Decimal Degrees) format. +ve is N and -ve is S of Equator */
  latitude: Scalars['Float'];
  /** Longitude in DD (Decimal Degrees) format, +ve is E and -ve is W of Meridian */
  longitude: Scalars['Float'];
};

export type ExtendedAccommodationCatalogSearchLocationContext = {
  /** Google Place ID of the location */
  googlePlaceId?: InputMaybe<Scalars['String']>;
};

export type ExtendedAccommodationContentSearchMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  preferredProviderType?: InputMaybe<PreferredHotelProviderType>;
  priceComparisonPayload?: InputMaybe<PriceComparisonPayload>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

/** PreferredHotelProviderType */
export enum PreferredHotelProviderType {
  hotels = 'hotels',
  joynativecheckout = 'joynativecheckout',
  stays = 'stays',
}

export type PriceComparisonPayload = {
  comparisonType?: InputMaybe<PriceComparisonType>;
  metadata?: InputMaybe<PriceComparisonPayloadMetaData>;
  preferredProvider?: InputMaybe<PreferredHotelProviderType>;
  preferredProviderPriceMaxExtraPercent?: InputMaybe<Scalars['Float']>;
};

/** PriceComparisonType */
export enum PriceComparisonType {
  basePrice = 'basePrice',
  perNightBasePrice = 'perNightBasePrice',
  perNightTotalPrice = 'perNightTotalPrice',
  totalPrice = 'totalPrice',
}

export type PriceComparisonPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum ScoringPriorityField {
  distanceFromSearchLocation = 'distanceFromSearchLocation',
  price = 'price',
  standardRoomPriceDiscountPercent = 'standardRoomPriceDiscountPercent',
  starRating = 'starRating',
  usedByEventsCount = 'usedByEventsCount',
  userRating = 'userRating',
}

export enum TravelOfferCancellationPolicyRuleValueType {
  Amount = 'Amount',
  Nights = 'Nights',
  Percentage = 'Percentage',
}

export type SearchExtendedAccommodationPropertiesV2Payload = {
  customSearchParams?: InputMaybe<SearchExtendedAccommodationPropertiesV2CustomSearchParams>;
  eventHandle: Scalars['String'];
};

export type SearchExtendedAccommodationPropertiesV2CustomSearchParams = {
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  /** Strategy for fetching accommodation content: cacheOnly (no API calls), preferCache (selective fields if cache miss), preferVendor (full fields from API). Default: preferCache. */
  fetchStrategy?: InputMaybe<FetchStrategy>;
  /** Whether fees should be included in totalAmount. If not provided, defaults to false in code */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<ExtendedAccommodationCatalogSearchLocation>;
  metadata?: InputMaybe<ExtendedAccommodationContentSearchMetadata>;
  occupancies?: InputMaybe<AccommodationCatalogUnitsOccupancyInput>;
  radiusKM?: InputMaybe<Scalars['Int']>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  stayDates?: InputMaybe<AccommodationCatalogStayDatesInput>;
  /** When true, skips cached pricing and fetches real-time pricing from providers. Default: false (uses cache for faster response). */
  useRealtimePricing?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceTagSearch = {
  tagName: Scalars['String'];
};

export type SearchPayload = {
  type?: InputMaybe<VendorTypeEnum>;
};

export type SearchTravelOfferReservationsPayload = {
  bookingId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
};

export enum TravelOfferReservationCancellationPolicyRuleValueType {
  Amount = 'Amount',
  Nights = 'Nights',
  Percentage = 'Percentage',
}

export enum TravelOfferReservationRefundability {
  FullyRefundable = 'FullyRefundable',
  NonRefundable = 'NonRefundable',
  PartiallyRefundable = 'PartiallyRefundable',
}

export enum TravelReservationGuestAgeClassification {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
}

export enum TravelReservationGuestTitle {
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS',
}

export enum TravelOfferReservationStatus {
  cancelled = 'cancelled',
  draft = 'draft',
  failed = 'failed',
  pending_confirmation = 'pending_confirmation',
  processing = 'processing',
  submitted = 'submitted',
  success = 'success',
}

export type StationeryPrintOrdersFiltersInput = {
  category?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  eventId?: InputMaybe<Scalars['ID']>;
  eventName?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<StationeryPrintOrdersOrderByFields>;
  ownerId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<StationeryPrintOrderStatusEnum>;
  statusList?: InputMaybe<Array<StationeryPrintOrderStatusEnum>>;
  type?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  /** Only applies to stationeryAllOrders. Ignored by stationeryPrintOrders (which hardcodes its own vendor exclusion). */
  vendorList?: InputMaybe<Array<StationeryPrintOrderVendorEnum>>;
};

export type StationeryPrintOrdersOrderByFields = {
  direction?: InputMaybe<StationeryPrintOrdersOrderByDirection>;
  field?: InputMaybe<StationeryPrintOrdersOrderByField>;
};

export enum StationeryPrintOrdersOrderByDirection {
  asc = 'asc',
  desc = 'desc',
}

export enum StationeryPrintOrdersOrderByField {
  createdAt = 'createdAt',
  currentStatus = 'currentStatus',
}

export enum StationeryPrintOrderStatusEnum {
  canceled = 'canceled',
  complete = 'complete',
  delivered = 'delivered',
  error = 'error',
  init = 'init',
  inProgress = 'inProgress',
  paid = 'paid',
  paused = 'paused',
  queued = 'queued',
  readyToShip = 'readyToShip',
  refunded = 'refunded',
  sent = 'sent',
  shipped = 'shipped',
}

export enum StationeryPrintOrderVendorEnum {
  joy_digital = 'joy_digital',
  joy_live_slideshow = 'joy_live_slideshow',
  joy_messaging_plus = 'joy_messaging_plus',
  paperlust = 'paperlust',
  taylor = 'taylor',
  taylor_mm = 'taylor_mm',
}

export type StationeryPrintOrdersPaginationInput = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export enum StationeryDraftFormat {
  digital = 'digital',
  print = 'print',
}

export enum StationeryTemplateCategoryEnum {
  enclosure = 'enclosure',
  holiday = 'holiday',
  invitation = 'invitation',
  menu = 'menu',
  monogram = 'monogram',
  napkin = 'napkin',
  saveTheDate = 'saveTheDate',
  sign = 'sign',
  thankYou = 'thankYou',
}

export enum StationeryPrintOrderDeliveryMethodEnum {
  express = 'express',
  free = 'free',
  mail_innovations_expedited_parcel = 'mail_innovations_expedited_parcel',
  mail_innovations_standard_flat = 'mail_innovations_standard_flat',
  standard = 'standard',
  /** The same as `ups_express_saver` but more readable. */
  ups_canada_express_saver = 'ups_canada_express_saver',
  ups_express_saver = 'ups_express_saver',
  ups_ground_canada_standard = 'ups_ground_canada_standard',
  ups_international_express_saver = 'ups_international_express_saver',
  usps_international_first_class = 'usps_international_first_class',
}

export enum StationeryPrintOrderIssueTarget {
  cx = 'cx',
  user = 'user',
}

export enum StationeryPrintOrderIssueType {
  quality_control = 'quality_control',
  recipient_address_incomplete = 'recipient_address_incomplete',
}

export enum StationeryPrintOrderStateEnum {
  canceled = 'canceled',
  valid = 'valid',
}

export type GetStationeryDigitalViewInput = {
  cardId?: InputMaybe<Scalars['String']>;
  personIds?: InputMaybe<Array<Scalars['String']>>;
};

export enum StationeryDigitalViewSource {
  copy = 'copy',
  email = 'email',
  link = 'link',
  none = 'none',
  sms = 'sms',
  whatsapp = 'whatsapp',
}

export type StationeryDraftsByEventInput = {
  eventId: Scalars['String'];
};

export type StationeryPreviewInput = {
  content: Scalars['JSON'];
  density?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<StationeryImageFormatEnum>;
  layout: StationeryLayout;
  quality?: InputMaybe<Scalars['Float']>;
};

export enum StationeryImageFormatEnum {
  jpg = 'jpg',
  png = 'png',
}

export type StationeryLayout = {
  cutMargin: Scalars['Float'];
  height: Scalars['Float'];
  safeZoneMargin: Scalars['Float'];
  width: Scalars['Float'];
};

export type StationeryPrintOrdersByEventInput = {
  eventId: Scalars['String'];
};

export type StationeryTemplateFilter = {
  approved?: InputMaybe<Scalars['Boolean']>;
  /** Performs "OR" operation on the categories. */
  categories?: InputMaybe<Array<StationeryTemplateCategoryEnum>>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Performs "OR" operation on the eventIdsFavorites. */
  eventIdsFavorites?: InputMaybe<Array<Scalars['ID']>>;
  heightInches?: InputMaybe<Scalars['Float']>;
  ownerIdFavorites?: InputMaybe<Scalars['ID']>;
  side?: InputMaybe<Scalars['String']>;
  /** Performs "OR" operation on the tags. */
  tags?: InputMaybe<Array<Scalars['String']>>;
  /** Performs "OR" operation on the themeIds. */
  themeIds?: InputMaybe<Array<Scalars['ID']>>;
  widthInches?: InputMaybe<Scalars['Float']>;
};

/**
 * Favorites can not only be created in single user-scope, but also in event-scope.
 * That option allows for fine-grained control on: "how to derive the information about my favorites."
 * e.g. I want to look at all templates, but only show favorites that I have personally added to favorites (vs. the whole event / or in many events).
 */
export type StationeryTemplateIncludeOptions = {
  includeFavoritesByEventIds?: InputMaybe<Array<Scalars['ID']>>;
  includeFavoritesByOwnerId?: InputMaybe<Scalars['ID']>;
  includeProducts?: InputMaybe<Scalars['Boolean']>;
};

export type StationeryTemplateOrderBy = {
  direction: StationeryTemplateOrderDirection;
  field: StationeryTemplateOrderField;
};

export enum StationeryTemplateOrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum StationeryTemplateOrderField {
  MY_FAVORITES = 'MY_FAVORITES',
}

export type SuggestedVendorPayload = {
  count: Scalars['Int'];
  idsToExclude?: InputMaybe<Array<Scalars['ID']>>;
};

export type SuggestionGroupByVendorTypePayload = {
  vendorType: VendorTypeEnum;
};

export type SyntheticCollectionByIdsPayload = {
  collectionIds: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type SyntheticCollectionByNamesPayload = {
  name: Scalars['String'];
  names: Array<Scalars['String']>;
};

export enum AiModelVersion {
  gpt35turboInstruct = 'gpt35turboInstruct',
  /** @deprecated No longer supported */
  textDavinci003 = 'textDavinci003',
}

export type PayloadStrings = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export enum PromptType {
  LoveStoryForWeddingWebsite = 'LoveStoryForWeddingWebsite',
  PoliteDeclineToAnInvitation = 'PoliteDeclineToAnInvitation',
  RegistryGiftSuggestions = 'RegistryGiftSuggestions',
  ThankYouNote = 'ThankYouNote',
  WeddingHashtagIdeas = 'WeddingHashtagIdeas',
  WeddingToastSpeech = 'WeddingToastSpeech',
  WeddingVows = 'WeddingVows',
}

export enum TransitionalRegistryStatus {
  failed = 'failed',
  inProgress = 'inProgress',
  ready = 'ready',
}

export type TravelAlertSubscriptionQueryInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export enum TravelAlertSubscriptionSource {
  ACCOMMODATIONS = 'ACCOMMODATIONS',
  GUEST_GUIDE = 'GUEST_GUIDE',
}

export enum TravelAlertSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  OPTED_OUT = 'OPTED_OUT',
  PAUSED = 'PAUSED',
}

export enum TravelAlertTriggerType {
  BOOKING_WINDOW = 'BOOKING_WINDOW',
  INVENTORY_LOW = 'INVENTORY_LOW',
  PRICE_DROP = 'PRICE_DROP',
  PRICE_INCREASE = 'PRICE_INCREASE',
}

export type TravelDistancesBetweenPointsPayload = {
  endingPoint: TravelInputPoint;
  startingPoint: TravelInputPoint;
};

export type TravelDistancesFromOriginPayload = {
  destinations: Array<TravelInputPoint>;
  origin: TravelInputPoint;
};

export type TravelOfferFromOfferTokenParams = {
  locale?: InputMaybe<Scalars['String']>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum TravelOfferDistributionType {
  Corporate = 'Corporate',
  Distribution = 'Distribution',
  Member = 'Member',
  Unknown = 'Unknown',
}

export enum TravelOfferRefundability {
  FullyRefundable = 'FullyRefundable',
  NonRefundable = 'NonRefundable',
}

export type TravelOffersForAccommodationByRegionPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelOffersForAccommodationByRegionPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  /** default pagination: { limit: 20, offset: 0 } */
  pagination?: InputMaybe<Pagination>;
  region: AccommodationCatalogRegionInput;
};

export type TravelOffersForAccommodationByRegionPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type Pagination = {
  limit: Scalars['Float'];
  offset: Scalars['Float'];
};

export type TravelOffersForAccommodationForPropertiesPayload = {
  anonymousId?: InputMaybe<Scalars['String']>;
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: Scalars['String'];
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  offerProvider?: InputMaybe<TravelOfferProvider>;
  propertyIdentifiers: Array<AccommodationCatalogPropertyIdentifierInput>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type TravelPlacePricingAndBookingDetailsPayload = {
  accommodationPlaceIds?: InputMaybe<Array<Scalars['String']>>;
  currencyCode: TravelCurrencyCode;
  /** Controls how stay dates are resolved. USE_EVENT_DATES uses metadata.eventId and falls back to payload dates if eventId is missing. USE_PAYLOAD_DATES always uses payload dates. */
  dateResolutionStrategy?: InputMaybe<DateResolutionStrategy>;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  joyPlaceIds?: InputMaybe<Array<Scalars['String']>>;
  metadata?: InputMaybe<TravelPlacePricingAndBookingDetailsPayloadMetadata>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
};

/** DateResolutionStrategy */
export enum DateResolutionStrategy {
  USE_EVENT_DATES = 'USE_EVENT_DATES',
  USE_PAYLOAD_DATES = 'USE_PAYLOAD_DATES',
}

export type TravelPlacePricingAndBookingDetailsPayloadMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  /** Source identifier for tracking API call origins */
  callSource?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  locale?: Scalars['String'];
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export enum AccommodationDatesSource {
  AROUND_EVENT_DATE = 'AROUND_EVENT_DATE',
  AROUND_PUBLIC_SCHEDULE = 'AROUND_PUBLIC_SCHEDULE',
  FROM_TRAVEL_SETTINGS = 'FROM_TRAVEL_SETTINGS',
}

export type TravelPricingsForAccommodationByPropertyIdPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByPropertyIdPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  propertyIdentifiers: Array<AccommodationCatalogPropertyIdentifierInput>;
};

export type TravelPricingsForAccommodationByPropertyIdPayloadMetaData = {
  anonymousId?: InputMaybe<Scalars['String']>;
  /** Source identifier for tracking API call origins */
  callSource?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  /** the locale of the user. example: en-US, es-ES, fr-FR */
  locale?: Scalars['String'];
  /** User country code sent to Amplitude for channel routing decisions (e.g., determining international channel vs domestic channel) */
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type ComparisonsForTravelPlaceIdPayload = {
  currencyCode: TravelCurrencyCode;
  dates: AccommodationCatalogStayDatesInput;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<TravelPricingsForAccommodationByPropertyIdPayloadMetaData>;
  occupancies: AccommodationCatalogUnitsOccupancyInput;
  placeIds: Array<PlaceIdInput>;
};

export type PlaceIdInput = {
  accommodationsPlaceId?: InputMaybe<Scalars['String']>;
  joyPlaceId?: InputMaybe<Scalars['String']>;
};

export type TravelReservationBookingDetailsPayload = {
  eventId: Scalars['String'];
};

export enum TravelReservationEvaluationDecision {
  PASS = 'PASS',
  QUARANTINE = 'QUARANTINE',
}

export enum TravelReservationEvaluationDispositionCode {
  APPROVED_LEGIT = 'APPROVED_LEGIT',
  CANCELED_EFW_ACTIONABLE = 'CANCELED_EFW_ACTIONABLE',
  CANCELED_FRAUD_SUSPECTED = 'CANCELED_FRAUD_SUSPECTED',
  CANCELED_IDENTITY_COLLISION = 'CANCELED_IDENTITY_COLLISION',
  CANCELED_IDENTITY_FRAUD_ACTIVITY = 'CANCELED_IDENTITY_FRAUD_ACTIVITY',
  CANCELED_NON_REFUNDABLE_RISK = 'CANCELED_NON_REFUNDABLE_RISK',
}

export enum TravelReservationEvaluationSpecialHandlingCase {
  INFRA_FAILURE_FALLBACK = 'INFRA_FAILURE_FALLBACK',
  LLM_UNAVAILABLE_FALLBACK_PASS = 'LLM_UNAVAILABLE_FALLBACK_PASS',
  LLM_UNAVAILABLE_FALLBACK_QUARANTINE = 'LLM_UNAVAILABLE_FALLBACK_QUARANTINE',
  POST_TIMEOUT_ASYNC_FAILED = 'POST_TIMEOUT_ASYNC_FAILED',
  POST_TIMEOUT_ASYNC_RESULT = 'POST_TIMEOUT_ASYNC_RESULT',
  TIMEOUT_FALLBACK_QUARANTINE = 'TIMEOUT_FALLBACK_QUARANTINE',
}

export type TravelReservationEvaluationsFilterInput = {
  decision?: InputMaybe<TravelReservationEvaluationDecision>;
  /** YYYY-MM-DD (UTC) — filter by createdAt <= end of that UTC day */
  endDate?: InputMaybe<Scalars['DateOnlyString']>;
  isShadowMode?: InputMaybe<Scalars['Boolean']>;
  /** When true, returns only evaluations with no disposition recorded yet (the CX work queue) */
  pendingDispositionOnly?: InputMaybe<Scalars['Boolean']>;
  /** YYYY-MM-DD (UTC) — filter by createdAt >= start of that UTC day */
  startDate?: InputMaybe<Scalars['DateOnlyString']>;
};

export type TravelReservationSummariesByPropertyIdentifiersPayload = {
  afterDate: Scalars['DateOnlyString'];
  identifiers: Array<AccommodationCatalogPropertyIdentifierInputV2>;
};

export type AccommodationCatalogPropertyIdentifierInputV2 = {
  id: Scalars['String'];
  type: AccommodationCatalogPropertyIdentifierV2Type;
};

export enum AccommodationCatalogPropertyIdentifierV2Type {
  joyPlace = 'joyPlace',
}

export enum UploadStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export enum MediaStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
}

export type UrlMetadataInput = {
  cacheBust?: InputMaybe<Scalars['Boolean']>;
  url: Scalars['String'];
};

export type UserActivityFilter = {
  activities?: InputMaybe<Array<BusinessActivityFilter>>;
  eventId?: InputMaybe<Scalars['ID']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type BusinessActivityFilter = {
  activity: Scalars['String'];
  business: Scalars['String'];
  includeJoyAdminActivity?: InputMaybe<Scalars['Boolean']>;
};

export type VendorListPayload = {
  items: Scalars['Int'];
  offset: Scalars['Int'];
  type: VendorTypeEnum;
};

export enum VendorUserRole {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  USER = 'USER',
}

export enum UrlVerificationStatus {
  invalid = 'invalid',
  valid = 'valid',
}

export type WarehouseInventorySearchInput = {
  joySKU: Scalars['String'];
  reasonCode: InventoryCheckReasonCode;
  requestedQty: Scalars['Int'];
};

export type WebsiteHeaderPresentationLayoutBySchemaInput = {
  eventId: Scalars['String'];
  schemaURL: Scalars['String'];
  websiteLayout?: InputMaybe<Scalars['String']>;
};

export type ZentrumHubHotelIsValidRequest = {
  checkIn?: InputMaybe<Scalars['DateTime']>;
  checkOut?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<ZentrumHubHotelIsValidRequestWithMetadata>;
  zhId: Scalars['Float'];
};

export type ZentrumHubHotelIsValidRequestWithMetadata = {
  anonymousId?: InputMaybe<Scalars['String']>;
  deviceType?: InputMaybe<DeviceType>;
  eventId?: InputMaybe<Scalars['ID']>;
  userCountryCode?: InputMaybe<Scalars['String']>;
};

export type AddAccommodationPlaceV2Request = {
  accommodationRoomBlock?: InputMaybe<AccommodationPlaceV2RoomBlockRequest>;
  autoSuggestionAlgo?: InputMaybe<AutoSuggestionAlgoType>;
  category?: InputMaybe<AccommodationPlaceCategory>;
  customAddress?: InputMaybe<Scalars['String']>;
  customName?: InputMaybe<Scalars['String']>;
  customPhone?: InputMaybe<Scalars['String']>;
  customPhotoId?: InputMaybe<Scalars['String']>;
  customStarRating?: InputMaybe<Scalars['Float']>;
  customUrl?: InputMaybe<Scalars['String']>;
  displayLocation?: InputMaybe<AccommodationPlaceDisplayLocation>;
  eventId: Scalars['ID'];
  isCustomLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isHostStayingHere?: InputMaybe<Scalars['Boolean']>;
  isPhotoHidden?: InputMaybe<Scalars['Boolean']>;
  layoutType?: InputMaybe<Scalars['String']>;
  sourceOfData: AccommodationPlaceSourceOfData;
  type?: InputMaybe<AccommodationPlaceType>;
  userNote?: InputMaybe<Scalars['String']>;
};

export type AccommodationPlaceV2RoomBlockRequest = {
  bookingUrl: Scalars['String'];
  checkInDate: Scalars['DateOnlyString'];
  checkOutDate: Scalars['DateOnlyString'];
  currencyCode?: InputMaybe<Scalars['String']>;
  cutoffDate: Scalars['DateOnlyString'];
  isJoyManagedRoomBlock: Scalars['Boolean'];
  numberOfRoomsReserved: Scalars['Float'];
  pricePerNight?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<AccommodationPlaceRoomBlockStatus>;
  strikeoutPricePerNight?: InputMaybe<Scalars['Float']>;
};

/** AutoSuggestionAlgoType */
export enum AutoSuggestionAlgoType {
  PastEventBased = 'PastEventBased',
  PriceBased = 'PriceBased',
  Proximity = 'Proximity',
}

export type AccommodationPlaceSourceOfData = {
  sourceId: Scalars['String'];
  sourceType: AccommodationPlaceSourceType;
};

export type AddAccommodationRecommendationToEventPayload = {
  recommendationId: Scalars['ID'];
};

export type AddAccommodationRecommendationToEventPayloadV2 = {
  eventId: Scalars['ID'];
  recommendationId: Scalars['ID'];
};

export type AddContactToGroupInput = {
  contactId: Scalars['ID'];
  groupId: Scalars['ID'];
  makeLeader?: InputMaybe<Scalars['Boolean']>;
};

export type AddEventCountdownComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddEventDetailsComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddEventDisplayNameComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddGreetingMessageComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddHostToBookingTypePayload = {
  bookingTypeId: Scalars['String'];
  vendorUserId: Scalars['String'];
};

export type AddInviteePayload = {
  email?: InputMaybe<Scalars['String']>;
  /** Display name for mailings/correspondence (e.g., 'Mr. Evan Jones & Guest', 'The Smith Family') */
  envelopeName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  /** Country code of the user's phone, numbers without a country code will be assumed to be in this country. Ignored if phoneDisplay has a country code, otherwise, this will be used to help parse it to E.164. */
  fallbackCountryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  /** Phone number as entered by the user, not necessarily valid */
  phoneDisplay?: InputMaybe<Scalars['String']>;
};

export type AddJsonDataBlobComponentPayload = {
  containerId: Scalars['ID'];
  jsonDataContainerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddMediaGalleryComponentPayload = {
  containerId: Scalars['ID'];
  mediaCollectionId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type addMediaToCollectionInput = {
  collectionId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  mediaId: Scalars['ID'];
};

export type addMediaToCollectionInputV2 = {
  collectionId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  mediaIds: Array<Scalars['ID']>;
};

export type PhotoComponentAddPayload = {
  containerId: Scalars['ID'];
  photoId: Scalars['String'];
  sortOrder: Scalars['Float'];
};

export type PointsOnMapAddPayload = {
  address: Scalars['String'];
  componentId: Scalars['ID'];
  googlePlaceID?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  postalCode: Scalars['String'];
  type: PointOnMapType;
};

export type AddRsvpAndUnlockGuestDetailsButtonComponentPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type CreateStationeryPrintOrderIssueInput = {
  additionalUserFacingDescription?: InputMaybe<Scalars['String']>;
  createdByEventId?: InputMaybe<Scalars['String']>;
  createdByUserId: Scalars['String'];
  issueTarget: StationeryPrintOrderIssueTarget;
  issueType: StationeryPrintOrderIssueType;
};

export type ServiceTagPayload = {
  serviceTagId: Scalars['ID'];
  vendorId: Scalars['ID'];
};

export type AddTestimonyPayload = {
  content: Scalars['String'];
  matchId?: InputMaybe<Scalars['String']>;
  reviewer?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['String'];
};

export type TextComponentAddPayload = {
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
  text: Scalars['String'];
};

export type TravelMapComponentAddPayload = {
  blockOrdering?: InputMaybe<Array<Scalars['String']>>;
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type AddVendorPhotoInput = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type AddVendorProfilePhoto = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type AddMatchToListPayload = {
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
};

export type VideoComponentAddPayload = {
  caption?: InputMaybe<Scalars['String']>;
  containerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
  videoUrl: Scalars['String'];
};

export type AnnotateRegistryOrderPayload = {
  lineItemAnnotations?: InputMaybe<Array<AnnotateRegistryOrderLineItemInput>>;
  orderAnnotations?: InputMaybe<AnnotateRegistryOrderInput>;
};

export type AnnotateRegistryOrderLineItemInput = {
  lineItemNote?: InputMaybe<Scalars['String']>;
  locator: Scalars['String'];
};

export type AnnotateRegistryOrderInput = {
  giftNote?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type ApplyEventConfigPayload = {
  eventConfigData: Scalars['JSONObject'];
  eventConfigSchemaUrl: Scalars['String'];
  eventId: Scalars['ID'];
};

export type ApplyWebsiteColorsPayload = {
  artBackgroundColor: Scalars['String'];
  artFontColor: Scalars['String'];
  eventDesignId: Scalars['ID'];
  linkAndButtonColor: Scalars['String'];
  pageBackgroundColor: Scalars['String'];
  pageFontColor: Scalars['String'];
};

export type ApplyWebSiteTemplateSettingsPayload = {
  /** to Apply Brannan Specific Settings (required when websiteLayout is brannan) */
  brannanSettings?: InputMaybe<BrannanSettings>;
  /** to Apply Color Settings */
  colorSettings: EventDesignColorsSettings;
  eventDesignId: Scalars['ID'];
  /** to Apply FontPack Settings */
  fontPackName: Scalars['String'];
  /** to Apply Header Layout Settings */
  headerLayout: HeaderLayoutSettings;
  /** to Apply Theme and Layout Settings */
  themeAndLayoutSettings: ThemeAndLayoutSettings;
};

export type BrannanSettings = {
  bgTransparency?: InputMaybe<BackgroundTransparency>;
  innerFrameBorder?: InputMaybe<InnerFrameBorder>;
};

export type BackgroundTransparency = {
  featureId: Scalars['ID'];
  rangeValue: Scalars['Float'];
};

export type InnerFrameBorder = {
  booleanValue: Scalars['Boolean'];
  featureId: Scalars['ID'];
};

export type EventDesignColorsSettings = {
  artBackgroundColor: Scalars['String'];
  artFontColor: Scalars['String'];
  linkAndButtonColor: Scalars['String'];
  pageBackgroundColor: Scalars['String'];
  pageFontColor: Scalars['String'];
};

export type HeaderLayoutSettings = {
  dataJSON: Scalars['JSON'];
  eventId: Scalars['ID'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type ThemeAndLayoutSettings = {
  brannanNavigation?: InputMaybe<BrannanNavigation>;
  fontId: Scalars['ID'];
  layoutId: Scalars['ID'];
  themeId: Scalars['ID'];
  useCustomTheme?: InputMaybe<Scalars['Boolean']>;
  useSuggestedThemeColor: Scalars['Boolean'];
};

export type ArchiveCollectionPayload = {
  id: Scalars['ID'];
};

export type ArchiveUserActivityInput = {
  target: UserActivityTargetInput;
};

export type UserActivityTargetInput = {
  eventId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type AssignAddressPayload = {
  location: InviteeLocation;
  personId: Scalars['ID'];
};

export type InviteeLocation = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type AuthenticateRegistryReservationInput = {
  /** A specially-formatted url the user currently recieves via email */
  url: Scalars['String'];
};

export type AutoPopulateAccommodationPlacesPayload = {
  eventId: Scalars['ID'];
  force?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocation>;
};

export type AutoPopulateAccommodationPlacesLocation = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type AutoPopulateAccommodationPlacesPayloadV3 = {
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  force?: InputMaybe<Scalars['Boolean']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocationV3>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  venueGooglePlaceId?: InputMaybe<Scalars['String']>;
};

export type AutoPopulateAccommodationPlacesFilters = {
  priceRange?: InputMaybe<AutoPopulateAccommodationPlacesFiltersPriceRange>;
  starRatings?: InputMaybe<Array<Scalars['Int']>>;
  userRatingRange?: InputMaybe<UserRatingRange>;
};

export type AutoPopulateAccommodationPlacesFiltersPriceRange = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type UserRatingRange = {
  excludeUnrated?: InputMaybe<Scalars['Boolean']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type AutoPopulateAccommodationPlacesLocationV3 = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type AutoPopulateAccommodationPlacesPayloadV4 = {
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  force?: InputMaybe<Scalars['Boolean']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocationV3>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  venueGooglePlaceId?: InputMaybe<Scalars['String']>;
};

export type AutoPopulateAccommodationPlacesPayloadV5 = {
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  force?: InputMaybe<Scalars['Boolean']>;
  idempotentId?: InputMaybe<Scalars['String']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<AutoPopulateAccommodationPlacesLocationV3>;
  scenario?: InputMaybe<AutopopulateAccommodationPlacesScenario>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  /** Optional user feedback driving regeneration behavior. */
  userFeedback?: InputMaybe<UserFeedbackDtoEnum>;
  venueGooglePlaceId?: InputMaybe<Scalars['String']>;
};

/** AutopopulateAccommodationPlacesScenario */
export enum AutopopulateAccommodationPlacesScenario {
  eventCreate = 'eventCreate',
  venueChange = 'venueChange',
}

/** User feedback for hotel suggestion regeneration */
export enum UserFeedbackDtoEnum {
  CLOSER = 'CLOSER',
  LUXURY = 'LUXURY',
  MORE_AFFORDABLE = 'MORE_AFFORDABLE',
  SIMILAR = 'SIMILAR',
}

export type AutoPopulateStayAreasPayload = {
  address?: InputMaybe<Scalars['String']>;
  autoPopulate?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['ID'];
  idempotentId?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  location?: InputMaybe<StayAreaCoordinatesInput>;
  scenario?: InputMaybe<Scalars['String']>;
  searchRadius?: InputMaybe<Scalars['Int']>;
};

export type StayAreaCoordinatesInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export enum DeferredOperationJobStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}

export type BackfillPaymentAttemptsInput = {
  /** YYYY-MM-DD end date for the backfill range */
  endDate: Scalars['DateOnlyString'];
  /** YYYY-MM-DD start date for the backfill range */
  startDate: Scalars['DateOnlyString'];
};

export type BacktestEvaluationsInput = {
  /** YYYY-MM-DD (UTC) — end of the backtest window */
  endDate?: InputMaybe<Scalars['DateOnlyString']>;
  /** Poll an existing backtest by key. When provided, all other fields are ignored. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  /** YYYY-MM-DD (UTC) — start of the backtest window */
  startDate?: InputMaybe<Scalars['DateOnlyString']>;
  systemPromptOverride?: InputMaybe<Scalars['String']>;
};

export enum BacktestOperationStatus {
  DONE = 'DONE',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
}

export type BatchUpdateEventPagesPayload = {
  id: Scalars['ID'];
  payload: PartialUpdatePagePayload;
};

export type PartialUpdatePagePayload = {
  visibility: EventPageVisibility;
};

export type RegistryOrderCancelInput = {
  cancelationMethod: SalesOrderCancelMethod;
  cancelationReason: Scalars['String'];
  registryOrderId: Scalars['ID'];
};

export enum SalesOrderCancelMethod {
  local = 'local',
}

export type ChangeLinkRedirectUrlInput = {
  linkRedirectId: Scalars['ID'];
  redirectUrl: Scalars['Url'];
};

export enum PhoneNumberVerificationStatus {
  approved = 'approved',
  canceled = 'canceled',
  deleted = 'deleted',
  expired = 'expired',
  failed = 'failed',
  maxAttemptsReached = 'maxAttemptsReached',
  pending = 'pending',
}

export type ClaimVendorUserWithToken = {
  token: Scalars['String'];
};

export type BundleStationeryPrintOrderInput = {
  childOrderNumbers: Array<Scalars['String']>;
  mainOrderNumber: Scalars['String'];
};

export type TransferRegistryOptions = {
  timeoutMs?: InputMaybe<Scalars['Int']>;
};

export type CreateConciergePrintOrderInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyISO4217?: InputMaybe<Scalars['String']>;
  details: StationeryConciergePrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  phoneNumber: Scalars['String'];
  priceInMinorUnits: Scalars['Int'];
  quantity: Scalars['Int'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationeryConciergePrintOrderDetailsInput = {
  assetUrl: Scalars['String'];
  cardType: Scalars['String'];
  cardTypeSku: Scalars['String'];
  designSetLabel?: InputMaybe<Scalars['String']>;
  designSetName: Scalars['String'];
  eventDate?: InputMaybe<Scalars['String']>;
  formLink: Scalars['String'];
  magnetCard?: InputMaybe<Scalars['Boolean']>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
  taxCode?: InputMaybe<Scalars['String']>;
};

export type StationeryPrintOrderDiscountInput = {
  amountInMinorUnits: Scalars['Int'];
  code: Scalars['String'];
  percentage?: InputMaybe<Scalars['Float']>;
};

export type StationeryPrintOrderShippingAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  region: Scalars['String'];
};

export type CreateDigitalPrintOrderInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyISO4217?: InputMaybe<Scalars['String']>;
  details: StationeryDigitalPrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  priceInMinorUnits: Scalars['Int'];
  quantity: Scalars['Int'];
  selectedProductDetails?: InputMaybe<StationeryPrintOrderProductInput>;
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  stationeryDraftId: Scalars['ID'];
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationeryDigitalPrintOrderDetailsInput = {
  digitalEnvelopeImageUrl?: InputMaybe<Scalars['String']>;
  features: Array<Scalars['String']>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
  taxCode?: InputMaybe<Scalars['String']>;
};

export type StationeryPrintOrderProductInput = {
  attributes: Array<SelectedStationeryPrintOrderProductAttributeInput>;
  selectedShippingMethodId?: InputMaybe<Scalars['String']>;
  variantGroupId?: InputMaybe<Scalars['String']>;
};

export type SelectedStationeryPrintOrderProductAttributeInput = {
  attributeId: Scalars['String'];
  optionId: Scalars['String'];
};

export type CreateStationerySamplePrintOrderInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyISO4217?: InputMaybe<Scalars['String']>;
  deliveryMethod: StationeryPrintOrderDeliveryMethodEnum;
  details: StationerySamplePrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  priceConfigId: Scalars['ID'];
  quantity: Scalars['Int'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationerySamplePrintOrderDetailsInput = {
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
};

export type BookingSlotArgs = {
  alternateEmail?: InputMaybe<Scalars['String']>;
  bookingTypeId: Scalars['String'];
  customerInsights?: InputMaybe<BookingSlotCustomerInsightsInput>;
  dateString: Scalars['String'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
  simpleNotes?: InputMaybe<Scalars['String']>;
  simpleSurvey?: InputMaybe<SimpleSurveyInput>;
  timezone: Scalars['String'];
};

export type BookingSlotCustomerInsightsInput = {
  address?: InputMaybe<Scalars['String']>;
  companyWebsite?: InputMaybe<Scalars['String']>;
  consideredVenues?: InputMaybe<Scalars['String']>;
  engagementDate?: InputMaybe<Scalars['DateTime']>;
  hiredVendors?: InputMaybe<Scalars['String']>;
  hostedEventBefore?: InputMaybe<Scalars['Boolean']>;
  pastVenues?: InputMaybe<Scalars['String']>;
  venueEventType?: InputMaybe<BookingSlotVenueEventType>;
};

export type SimpleSurveyInput = {
  dates?: InputMaybe<Array<Scalars['String']>>;
  extraInfo?: InputMaybe<Scalars['String']>;
  guestCount?: InputMaybe<Scalars['String']>;
  needWeddingPlanner?: InputMaybe<Scalars['String']>;
  totalBudget?: InputMaybe<Scalars['String']>;
  typeOfEvent?: InputMaybe<Scalars['String']>;
};

export type CreateBookingTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  bookingType?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type BookingTypeInput = {
  availability?: InputMaybe<BookingTypeAvailabilityInput>;
  bookingProcess: BookingTypeProcessType;
  description: Scalars['String'];
  eventLength: Scalars['Int'];
  eventType: BookingTypeEventType;
  handle?: InputMaybe<Scalars['String']>;
  hostId: Scalars['String'];
  interval?: InputMaybe<Scalars['Int']>;
  isPrivate: Scalars['Boolean'];
  locationString?: InputMaybe<Scalars['String']>;
  meetingInfoNotes?: InputMaybe<Scalars['String']>;
  meetingUrl?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  title: Scalars['String'];
  vendorId: Scalars['String'];
};

export type BookingTypeAvailabilityInput = {
  bookingTypeId: Scalars['String'];
  friday: Array<BookingTypeAvailabilityDayInput>;
  monday: Array<BookingTypeAvailabilityDayInput>;
  saturday: Array<BookingTypeAvailabilityDayInput>;
  sunday: Array<BookingTypeAvailabilityDayInput>;
  thursday: Array<BookingTypeAvailabilityDayInput>;
  tuesday: Array<BookingTypeAvailabilityDayInput>;
  wednesday: Array<BookingTypeAvailabilityDayInput>;
};

export type BookingTypeAvailabilityDayInput = {
  end: Scalars['String'];
  start: Scalars['String'];
};

/** Input for creating a new Cash Fund associated with a host. This initiates the collection mechanism for contributions towards a specific goal or fixed amounts. */
export type CreateCashFundInput = {
  /** Optional fixed amount per contribution in minor units, if contributions are standardized. */
  fixedContributionAmountInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Whether to hide the progress towards the total goal from contributors. */
  hideGoal: Scalars['Boolean'];
  /** The ID of the host this cash fund belongs to, linking to the CashFundsHost type. */
  hostId: Scalars['ID'];
  /** The name or title of the cash fund, displayed to contributors. */
  name: Scalars['String'];
  /** Optional descriptive note about the cash fund's purpose. */
  note?: InputMaybe<Scalars['String']>;
  /**
   * URL of a photo to associate with the cash fund, used in solicitations and displays.
   * Contributes to the Solicitation Photo reference
   */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** The total target amount in minor currency units (e.g., cents for USD) for the fund's goal. */
  totalGoalInMinorUnits?: InputMaybe<Scalars['Int']>;
};

/**
 * Used for creating a Checkout Session for standard checkout flow.
 * This input follows the same field pattern as CreateCashFundPaymentIntentInput.
 */
export type CreateCashFundCheckoutSessionInput = {
  /** Contribution amount. */
  amountInMinorUnits: Scalars['Int'];
  /**
   * URL template where customers will be redirected if they decide to cancel the checkout.
   * The template supports the following placeholders (same as successUrlTemplate)
   * - '{cashFundId}' - ID of the cash fund
   * - '{paymentAttemptId}' or '{paymentId}' - ID of the payment attempt
   * - '{contributionId}' - Deprecated: use {paymentAttemptId} instead (kept for backward compatibility)
   * - '{eventId}' - ID of the event
   */
  cancelUrlTemplate: Scalars['String'];
  /** The ID of the cash fund. */
  cashFundId: Scalars['ID'];
  /** Contributor's email. */
  contributorEmail: Scalars['String'];
  /** Contributor's full name. */
  contributorFullName: Scalars['String'];
  /** Optional message. */
  contributorMessage?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the contribution.
   * The 'inviteToken' has higher priority when linking an Invite. If an 'inviteToken' is provided, this property is ignored.
   * Note: If a guest has multiple Invites for the same Cash Fund (from different Solicitations),
   * the system will automatically select the Invite with the fewest existing Contributions.
   */
  guestKey?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the contribution.
   * Omitted if Contribution is not from an Invite.
   */
  inviteToken?: InputMaybe<Scalars['String']>;
  /**
   * URL template where customers will be redirected after successful checkout.
   * The template supports the following placeholders:
   * - '{cashFundId}' - ID of the cash fund
   * - '{paymentAttemptId}' or '{paymentId}' - ID of the payment attempt
   * - '{contributionId}' - Deprecated: use {paymentAttemptId} instead (kept for backward compatibility)
   * - '{eventId}' - ID of the event
   */
  successUrlTemplate: Scalars['String'];
};

/** Input for creating a Payment Intent for express checkout to a cash fund. Used in scenarios where contributor details are captured post-payment. */
export type CreateCashFundPaymentIntentInput = {
  /** The contribution amount in minor currency units. */
  amountInMinorUnits: Scalars['Int'];
  /** The ID of the cash fund receiving the contribution. */
  cashFundId: Scalars['ID'];
  /** Email of the contributor for receipts and tracking. */
  contributorEmail: Scalars['String'];
  /** A single unified name, first + last, same format as the Cardholder name provided by Stripe. */
  contributorFullName: Scalars['String'];
  /** Optional message from contributor to the host. */
  contributorMessage?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the Contribution.
   * The 'inviteToken' has higher priority when linking an Invite. If an 'inviteToken' is provided, this property is ignored.
   * Note: If a guest has multiple Invites for the same Cash Fund (from different Solicitations),
   * the system will automatically select the Invite with the fewest existing Contributions.
   */
  guestKey?: InputMaybe<Scalars['String']>;
  /**
   * Links a specific Invite to the Contribution.
   * Omitted if Contribution is not from an Invite.
   */
  inviteToken?: InputMaybe<Scalars['String']>;
};

/** Input for creating a Cash Fund Solicitation, which is an email campaign to invite recipients to contribute to the cash fund. */
export type CreateCashFundSolicitationInput = {
  /** The ID of the cash fund this solicitation promotes. */
  cashFundId: Scalars['ID'];
  /** Configuration for the solicitation's appearance and behavior. */
  config: CashFundSolicitationConfigInput;
  /** The body message for the invitation emails. */
  inviteMessage: Scalars['String'];
  /** The subject line for the invitation emails. */
  inviteSubject: Scalars['String'];
  /** Optional name for the solicitation campaign. */
  name?: InputMaybe<Scalars['String']>;
};

/** Configuration options for a Cash Fund Solicitation, controlling email appearance and personalization. */
export type CashFundSolicitationConfigInput = {
  /** Text for the call-to-action button in the email. */
  buttonText: Scalars['String'];
  /** Whether to include recipient names in the salutation or content. */
  includeRecipientNames: Scalars['Boolean'];
  /**
   * URL for the photo displayed in the solicitation email.
   * Contributes to the Solicitation Photo reference
   */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Greeting style for personalized emails (e.g., "Dear friends"). */
  salutation: Scalars['String'];
};

export type ChecklistItemCreateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  reminderAt?: InputMaybe<Scalars['DateTime']>;
  subItems?: InputMaybe<Array<ChecklistSubItemCreateInput>>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ChecklistSubItemCreateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateCollectionOnEventMatchPayload = {
  description: Scalars['String'];
  eventMatchId: Scalars['ID'];
  name: Scalars['String'];
};

export type CreateCollectionOnVendorPayload = {
  description: Scalars['String'];
  name: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type CreateCollectionWithPhotos = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  photoIds: Array<Scalars['String']>;
};

export type ContactInput = {
  address?: InputMaybe<ContactAddressInput>;
  contact: ContactInputData;
  phoneNumbers?: InputMaybe<Array<InputMaybe<ContactPhoneNumberInput>>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type ContactAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  householdId?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  region: Scalars['String'];
  validated: Scalars['Boolean'];
};

export type ContactInputData = {
  contactCollectionId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  firebaseEventId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  householdDisplayName?: InputMaybe<Scalars['String']>;
  householdId?: InputMaybe<Scalars['String']>;
  isNewPartyMember?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  legacyAddressString?: InputMaybe<Scalars['String']>;
  party?: InputMaybe<Scalars['String']>;
};

export type ContactPhoneNumberInput = {
  allowSMS: Scalars['Boolean'];
  label?: InputMaybe<Scalars['String']>;
  mobile: Scalars['Boolean'];
  number: Scalars['String'];
};

export type ContactCollectionInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  collectHousehold?: InputMaybe<Scalars['Boolean']>;
  eventDateDisplayEnabled: Scalars['Boolean'];
  eventId?: InputMaybe<Scalars['String']>;
  mediaSource: Scalars['String'];
  mediaType: Scalars['String'];
  message: Scalars['String'];
  websiteLinkEnabled: Scalars['Boolean'];
};

export type ContactInputWithoutTags = {
  address?: InputMaybe<ContactAddressInput>;
  contact: ContactInputData;
  phoneNumbers?: InputMaybe<Array<InputMaybe<ContactPhoneNumberInput>>>;
};

export enum ContactTagSource {
  contact = 'contact',
  guestlist = 'guestlist',
}

export type CustomerInsightsInput = {
  bookingSlotId?: InputMaybe<Scalars['ID']>;
  rawData?: InputMaybe<Scalars['JSON']>;
};

export type RegistryItemMetadata = {
  /** Tells us where the registry item is added from, refer to doc for source type */
  source?: InputMaybe<Scalars['String']>;
  sourceMetadata?: InputMaybe<RegistryItemSourceMetadata>;
};

export type RegistryItemSourceMetadata = {
  /**
   * The Registry Item's known price, as a String, in USD, with no currency symbol when first scanned,
   * It does not necessarily have to match the price that was saved (in fact, when it doesn't that's when we care the most).
   */
  scannedPrice?: InputMaybe<Scalars['String']>;
};

export enum InsertPositionType {
  first = 'first',
  last = 'last',
}

export type CreateDonationFundDonationInput = {
  amountMonetaryMinorValue: Scalars['Int'];
  email: Scalars['String'];
  fundId: Scalars['ID'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  platformType?: InputMaybe<DonationFundPaymentMethodEnum>;
};

export type CreateEmailTemplateInput = {
  eventId: Scalars['String'];
  name: Scalars['String'];
  templateData: Scalars['JSON'];
  templateType: EmailTemplateType;
};

export type EventChecklistCreateInput = {
  eventId: Scalars['ID'];
  items?: InputMaybe<Array<ChecklistItemCreateInput>>;
  title: Scalars['String'];
};

export type CreateEventDesignPayload = {
  colors?: InputMaybe<CreateEventDesignColorsPayload>;
  eventId: Scalars['ID'];
  fontPackName?: InputMaybe<Scalars['String']>;
  layoutName?: InputMaybe<Scalars['String']>;
  pageShadow?: InputMaybe<Scalars['Boolean']>;
  pageTransparency?: InputMaybe<Scalars['Boolean']>;
  /** ie succulent_sunset */
  themeId?: InputMaybe<Scalars['String']>;
};

export type CreateEventDesignColorsPayload = {
  artBackgroundColor?: InputMaybe<Scalars['String']>;
  artFontColor?: InputMaybe<Scalars['String']>;
  linkAndButtonColor?: InputMaybe<Scalars['String']>;
  pageBackgroundColor?: InputMaybe<Scalars['String']>;
  pageFontColor?: InputMaybe<Scalars['String']>;
};

export type CreateEventPagePayload = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  pageSlug?: InputMaybe<Scalars['String']>;
  pageSubTitle?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  type: EventPageType;
};

export type EventPlaceCreatePayload = {
  eventId: Scalars['String'];
  googlePlaceId: Scalars['String'];
  type: EventPlaceType;
};

export type EventScheduleCreateItemPayload = {
  description?: InputMaybe<Scalars['String']>;
  dressCode?: InputMaybe<Scalars['String']>;
  endTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  showMap?: InputMaybe<Scalars['Boolean']>;
  startTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  unplugged?: InputMaybe<Scalars['Boolean']>;
  virtualEventLink?: InputMaybe<Scalars['String']>;
};

export type CreateEventTypeInput = {
  category: Scalars['String'];
  categorySubtype: Scalars['String'];
  configJson: Scalars['JSONObject'];
  description: Scalars['String'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  schemaUrl: Scalars['String'];
  title: Scalars['String'];
};

export type CreateEventPayload0301 = {
  accentColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  accentLightText?: InputMaybe<Scalars['Boolean']>;
  accentText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  acquisitionContext?: InputMaybe<AcquisitionContext>;
  baseColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  baseLightText?: InputMaybe<Scalars['Boolean']>;
  baseText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  /** Source of the event being created. ie: Create Wedding, Vendor RFP */
  creationSource?: InputMaybe<Scalars['String']>;
  enableTranslucentEffect?: InputMaybe<Scalars['Boolean']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  /** List of feature flags to enable for this event */
  eventFeatures?: InputMaybe<Array<Scalars['String']>>;
  eventType?: InputMaybe<EventType>;
  exhibitId?: InputMaybe<Scalars['String']>;
  fianceeFirstName?: InputMaybe<Scalars['String']>;
  fianceeLastName?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<Scalars['String']>;
  graphicAccent?: InputMaybe<Scalars['String']>;
  headerLayout?: InputMaybe<CreateEventHeaderLayoutSettings>;
  /** Tracking information for an Impact Radius Campaign */
  impactRadiusTracking?: InputMaybe<CreateEventImpactRadiusTrackingPayload>;
  /** Optional locale override (BCP 47 format, e.g., 'en-US', 'fr', 'ja'). Overrides middleware-detected locale if provided. */
  locale?: InputMaybe<Scalars['String']>;
  /** An ISO-8601 timestamp or datestamp (no 'T') */
  mainDate?: InputMaybe<Scalars['String']>;
  mainTzid?: InputMaybe<Scalars['String']>;
  ownerFirstName?: InputMaybe<Scalars['String']>;
  ownerLastName?: InputMaybe<Scalars['String']>;
  paletteId?: InputMaybe<Scalars['String']>;
  paletteName?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['String']>;
  useSuggestedBackgroundColor?: InputMaybe<Scalars['Boolean']>;
  useWeddingColor?: InputMaybe<Scalars['Boolean']>;
  /** Venue information for the event. Prefer this over the deprecated flat fields below. */
  venue?: InputMaybe<EventLocationInput>;
  websiteDesignSettings?: InputMaybe<WebsiteDesignSettingsInput>;
};

export type AcquisitionContext = {
  currentTimestamp: Scalars['Float'];
  details: Array<AcquisitionContextDetails>;
};

export type AcquisitionContextDetails = {
  data: Array<AcquisitionContextData>;
  referrer?: InputMaybe<Scalars['String']>;
  relativeUrl: Scalars['String'];
  timestamp: Scalars['Float'];
};

export type AcquisitionContextData = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type CreateEventHeaderLayoutSettings = {
  dataJSON: Scalars['JSON'];
  schemaURL: Scalars['String'];
  websiteLayout?: InputMaybe<Scalars['String']>;
};

export type CreateEventImpactRadiusTrackingPayload = {
  actionTrackerId: Scalars['Int'];
  campaignId: Scalars['Int'];
  clickId: Scalars['String'];
  /** New or Returning */
  customerStatus: Scalars['String'];
  /** An ISO-8601 timestamp */
  eventDate: Scalars['String'];
  orderId: Scalars['String'];
};

/** Venue information for an event */
export type EventLocationInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  placeId?: InputMaybe<Scalars['String']>;
  placeName?: InputMaybe<Scalars['String']>;
};

export type WebsiteDesignSettingsInput = {
  colors?: InputMaybe<WebsiteDesignColorSettingsInput>;
  fontPackName?: InputMaybe<Scalars['String']>;
  pageShadow?: InputMaybe<Scalars['Boolean']>;
  pageTransparency?: InputMaybe<Scalars['Boolean']>;
  welcomePhotoPresentationLayout?: InputMaybe<Scalars['String']>;
};

export type WebsiteDesignColorSettingsInput = {
  artBackgroundColor?: InputMaybe<Scalars['String']>;
  artFontColor?: InputMaybe<Scalars['String']>;
  linkAndButtonColor?: InputMaybe<Scalars['String']>;
  pageBackgroundColor?: InputMaybe<Scalars['String']>;
  pageFontColor?: InputMaybe<Scalars['String']>;
};

export type CreateFerryTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateFlightTravelItemPayload = {
  code?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateFormInput = {
  config: Scalars['JSONObject'];
  description: Scalars['String'];
  eventId?: InputMaybe<Scalars['String']>;
  schemaUrl: Scalars['String'];
  settings?: InputMaybe<Scalars['JSONObject']>;
  /** Ticket types for this form. Required when ticketingEnabled is true in settings. */
  ticketTypes?: InputMaybe<Array<FormTicketTypeInput>>;
  title: Scalars['String'];
  type?: InputMaybe<FormType>;
};

/**
 * Ticket type definition for form creation (embedded in CreateFormInput).
 * Note: This is different from CreateTicketTypeInput which is used for standalone ticket type creation.
 * eventId and formId are set from the parent form context.
 */
export type FormTicketTypeInput = {
  /** Maximum capacity. Null means unlimited. */
  capacity?: InputMaybe<Scalars['Int']>;
  /** ISO 4217 currency code (e.g., 'USD', 'EUR'). Required. */
  currency: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** Price in minor currency units (cents for USD). Defaults to 0 (free ticket). */
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** When ticket sales end. Null means no end date. */
  salesEndAt?: InputMaybe<Scalars['DateTime']>;
  /** When ticket sales begin. Null means immediately available. */
  salesStartAt?: InputMaybe<Scalars['DateTime']>;
  /** State of this ticket type. Defaults to ACTIVE. */
  state?: InputMaybe<TicketTypeState>;
};

export type CreateFormTemplateInput = {
  config: Scalars['JSONObject'];
  description: Scalars['String'];
  eventCategoryTags: Array<Scalars['String']>;
  eventSubTypeTags: Array<Scalars['String']>;
  schemaUrl: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type CreateGeneralEventPayload = {
  eventCategory?: InputMaybe<Scalars['String']>;
  eventCategorySubtype?: InputMaybe<Scalars['String']>;
  eventDateIsFinalized?: InputMaybe<Scalars['Boolean']>;
  eventDateISOString?: InputMaybe<Scalars['String']>;
  eventDisplayName: Scalars['String'];
  eventEndTimeISOString?: InputMaybe<Scalars['String']>;
  /** List of feature flags to enable for this event */
  eventFeatures?: InputMaybe<Array<Scalars['String']>>;
  eventLocation?: InputMaybe<GeneralEventPlace>;
  /** Optional locale override (BCP 47 format, e.g., 'en-US', 'fr', 'ja'). Overrides middleware-detected locale if provided. */
  locale?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type GeneralEventPlace = {
  googlePlaceId?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  placeName?: InputMaybe<Scalars['String']>;
};

export type GuestlistCreateCustomColumnInput = {
  defaultValue?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  displayPriority?: InputMaybe<Scalars['Float']>;
  eventId: Scalars['String'];
  name: Scalars['String'];
  placeholderValue?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<GuestlistColumnScope>;
  settings?: InputMaybe<Scalars['JSON']>;
  type: GuestlistCustomColumnType;
};

export type CreateHotelTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateInviteePayload = {
  code?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** Display name for mailings/correspondence (e.g., 'Mr. Evan Jones & Guest', 'The Smith Family') */
  envelopeName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<InviteeLocation>;
};

export type CreateJoyFeatureCheckoutInput = {
  checkoutFailureUrlTemplate: Scalars['String'];
  checkoutSuccessUrlTemplate: Scalars['String'];
  currencyConversionData?: InputMaybe<Scalars['JSON']>;
  currencyISO4217?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email: Scalars['String'];
  eventId: Scalars['String'];
  featureType: JoyFeatureType;
  priceConfigId: Scalars['ID'];
  quantity: Scalars['Int'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
};

export type CreateJsonDataContainerPayload = {
  content: Scalars['JSONObject'];
  eventId: Scalars['ID'];
  schemaUrl: Scalars['String'];
  type: Scalars['String'];
};

export type CreateLinkRedirectInput = {
  /** Will be set to true if not provided. */
  active?: InputMaybe<Scalars['Boolean']>;
  eventId?: InputMaybe<Scalars['ID']>;
  /**
   * https://withjoy.com/go/<link> part.
   * Supports custom links, will generate a short link if not provided.
   */
  link?: InputMaybe<Scalars['String']>;
  /** Metadata: How much service charged for creating this link */
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  redirectUrl: Scalars['Url'];
  sourceService: Scalars['String'];
  userId: Scalars['ID'];
};

export type CreateLinkRedirectBlockInput = {
  blockType: BlockType;
  reason?: InputMaybe<Scalars['String']>;
  targetValue: Scalars['String'];
};

export type CreateListTravelItemPayload = {
  eventId: Scalars['ID'];
  name: Scalars['String'];
  newItems: Array<InputMaybe<ListTravelSubItems>>;
};

export type ListTravelSubItems = {
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateMatchPayload = {
  eventId: Scalars['String'];
  matchNote?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<MatchStatus>;
  vendorId: Scalars['String'];
  vendorTypeId?: InputMaybe<Scalars['String']>;
};

export type CreateMediaCollectionInput = {
  eventId: Scalars['ID'];
  mediaCollectionAttributes?: InputMaybe<MediaCollectionAlbumAttributeInput>;
  name: Scalars['String'];
  sortBy?: InputMaybe<MediaCollectionSortField>;
  sortDirection?: InputMaybe<MediaCollectionSortDirection>;
};

/** Partial album settings. Optional fields may be omitted; explicit null is treated as omit (merge keeps existing). */
export type MediaCollectionAlbumAttributeInput = {
  displayMode?: InputMaybe<MediaCollectionDisplayMode>;
};

export type createMediaPhotoInput = {
  eventId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  photoId: Scalars['ID'];
};

export type createMediaPhotosInput = {
  eventId: Scalars['ID'];
  magicToken?: InputMaybe<Scalars['String']>;
  photoIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateNewEventAdminInvitePayload = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type CreateNoteTravelItemPayload = {
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type PageContainerCreatePayload = {
  contentType?: InputMaybe<PageContentType>;
  eventId: Scalars['ID'];
  mainPhotoAlignment?: InputMaybe<PhotoAlignment>;
  mainPhotoCropInfo?: InputMaybe<MainPhotoCropInfoInput>;
  mainPhotoId?: InputMaybe<Scalars['ID']>;
  mainPhotoPresentationLayout?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  sortOrder: Scalars['Float'];
  title: Scalars['String'];
  visibility: EventPageVisibility;
};

export type PhotoAlignment = {
  x: PhotoXPosition;
  y: PhotoYPosition;
};

export type MainPhotoCropInfoInput = {
  height: Scalars['Float'];
  unit: Scalars['String'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type CreateColorPayload = {
  color: Scalars['String'];
  eventDesignId: Scalars['ID'];
};

export type CreatePlusOneGuestInput = {
  eventId: Scalars['ID'];
  guestListMemberId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  /**
   * Optional ID of a previously created plus-one placeholder to consume.
   * If provided, the placeholder will be marked as consumed and linked to the new contact.
   */
  plusOneId?: InputMaybe<Scalars['ID']>;
};

export type CreatePostRsvpHotelBookReminderMessageInput = {
  contactIds: Array<Scalars['String']>;
  eventId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
};

export type CreateQandaPayload = {
  answer: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
  sampleQuestionId?: InputMaybe<Scalars['String']>;
  type: QandaType;
};

export type CreateQRCodeInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  fillColor?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  logoUrl?: InputMaybe<Scalars['String']>;
};

export type CreateRegistryPayload = {
  name: Scalars['String'];
  /** The URL to the Registry website */
  url: Scalars['String'];
};

export type CreateRegistryChecklistPayload = {
  checklistTemplate: ChecklistTemplateEnum;
  eventId: Scalars['ID'];
};

export enum ChecklistTemplateEnum {
  defaultBabyChecklist = 'defaultBabyChecklist',
  /** Used by default for deprecated createRegistryChecklist mutation. */
  defaultWeddingChecklist = 'defaultWeddingChecklist',
}

export type CreateRegistryItemPayload = {
  /** product level data that we own */
  custom: CreateCustomItemDataInput;
  /** Floating point index value, see docs for RegistryItem type */
  fpIndex?: InputMaybe<Scalars['Float']>;
  /** flag to allow the couple to enable get cash equivalent feature */
  isGetCashEquivalent?: InputMaybe<Scalars['Boolean']>;
  /** registry item metadata */
  metadata?: InputMaybe<RegistryItemMetadata>;
  /** flag to allow the couple to mark an item as a 'must have' / favorite */
  mustHave?: InputMaybe<Scalars['Boolean']>;
  /** note added to registry item by couple */
  note?: InputMaybe<Scalars['String']>;
  /**
   * Insertion position in list of all items in event.
   * If specified, this value takes precedence over any fpIndex value
   */
  position?: InputMaybe<InsertPositionType>;
  /** the quantity (number of) items */
  totalRequested?: InputMaybe<Scalars['Int']>;
};

export type CreateCustomItemDataInput = {
  /** External url of image to be imported for product photo */
  imageUrlForImport?: InputMaybe<Scalars['String']>;
  priceAsFloatingPointDecimalString?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CustomItemDataType;
  url: Scalars['String'];
};

export type CreateRegistryItemFromCatalogItemPayload = {
  /**
   * The id of the catalog category that the item was added from.
   *
   * An item may appear under multiple categories and the specific category
   * needs to be captured for context.
   *
   * Ideally this field would be mandatory (non-null), but we need a migration
   * path as code is already in the wild.
   */
  catalogCategoryId?: InputMaybe<Scalars['ID']>;
  /** The id of the catalog curation type category */
  catalogItemId: Scalars['ID'];
  /** Indicates whether this item should be hidden for guests */
  isHidden?: InputMaybe<Scalars['Boolean']>;
  /** registry item metadata */
  metadata?: InputMaybe<RegistryItemMetadata>;
  /** optional note added to registry item by couple */
  note?: InputMaybe<Scalars['String']>;
  /** Insertion position in list of all items in event. Uses default if omitted */
  position?: InputMaybe<InsertPositionType>;
  /** the quantity (number of) items */
  totalRequested: Scalars['Int'];
};

export type CreateRegistryItemsFromCatalogCategoryPayload = {
  /** The id of the catalog curation type category */
  catalogCategoryId: Scalars['ID'];
  /** Optional note added to registry item by couple */
  note?: InputMaybe<Scalars['String']>;
  /** Optional insertion position in list of all items in event. Uses default if omitted */
  position?: InputMaybe<InsertPositionType>;
  /** Optional quantity (number of) times to add each item. Defaults to 1 */
  totalRequested?: InputMaybe<Scalars['Int']>;
};

export type CreateRegistryPaymentIntentInput = {
  address?: InputMaybe<ShippingAddressInput>;
  /**
   * Used for automatic server-side payment confirmation.
   * Read more about [confirmation tokens](https://docs.stripe.com/payments/finalize-payments-on-the-server?platform=web&type=payment#create-ct)
   */
  confirmationTokenId?: InputMaybe<Scalars['String']>;
  eCard?: InputMaybe<ECard>;
  email: Scalars['String'];
  eventId: Scalars['ID'];
  lineItems?: InputMaybe<Array<RegistryLineItemInput>>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  printOrder?: InputMaybe<PrintOrder>;
  /** example: 'https://withjoy.com/success/${purchaseContextId}' */
  returnUrlTemplate: Scalars['String'];
};

export type CreateRegistryPayoutAccountInput = {
  /** Country code in ISO 3166-1 alpha-3 */
  countryCode?: InputMaybe<Scalars['String']>;
  /** Currency code in ISO 4217 alpha-3 */
  currencyCode: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type CreateRegistryPurchaseContextInput = {
  address?: InputMaybe<ShippingAddressInput>;
  eCard?: InputMaybe<ECard>;
  email: Scalars['String'];
  eventId: Scalars['ID'];
  /** will be mandatory (non-nullable) in future */
  failureUrlTemplate?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<RegistryLineItemInput>>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  printOrder?: InputMaybe<PrintOrder>;
  /** deprecated, use successUrlTemplate and failureUrlTemplate instead, this field will be removed in future */
  rootUrl?: InputMaybe<Scalars['String']>;
  /** example: 'https://withjoy.com/success/${purchaseContextId}' will be mandatory (non-nullable) in future */
  successUrlTemplate?: InputMaybe<Scalars['String']>;
};

export type CreateRegistryOptions = {
  /** If missing, the registry will automatically check if it is syncable */
  type?: InputMaybe<CreateRegistryType>;
};

/** Subset of the 'RegistryType' enum */
export enum CreateRegistryType {
  linked = 'linked',
  synced = 'synced',
}

export type CreateRemindMeLaterEmailInput = {
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
};

export type CreateRentalCarTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateRentalHomeTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateServiceTagPayload = {
  tagName: Scalars['String'];
  vendorId: Scalars['ID'];
};

export type CreateShuttleTravelItemPayload = {
  eventId: Scalars['ID'];
  name: Scalars['String'];
  newItems: Array<InputMaybe<ShuttleTravelSubItems>>;
  notes?: InputMaybe<Scalars['String']>;
};

export type ShuttleTravelSubItems = {
  endTime?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateSingleRegistryItemOrderInput = {
  email: Scalars['String'];
  isPurchased?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  registryItemId: Scalars['String'];
  trackingNumber?: InputMaybe<Scalars['String']>;
};

export type CreateSlimEventAndCollection = {
  collectionName: Scalars['String'];
  description: Scalars['String'];
};

export type CreateStationeryDraftPreviewInput = {
  cardConfig: Scalars['JSON'];
  eventID?: InputMaybe<Scalars['String']>;
  hasRecipientAddress?: InputMaybe<Scalars['Boolean']>;
  noLegacyAddressFallback?: InputMaybe<Scalars['Boolean']>;
  stationeryDraftId?: InputMaybe<Scalars['String']>;
};

export type CreateStationeryDraftInput = {
  cardJSON: Scalars['JSON'];
  eventId?: InputMaybe<Scalars['ID']>;
  format?: InputMaybe<StationeryDraftFormat>;
  priceConfigId?: InputMaybe<Scalars['ID']>;
  stationeryTemplateId: Scalars['ID'];
};

export type CreateStationeryDraftFromPrintOrderInput = {
  format?: InputMaybe<StationeryDraftFormat>;
  orderId: Scalars['String'];
};

export type CreateStationeryPriceConfigInput = {
  /** Defaults to false */
  active?: InputMaybe<Scalars['Boolean']>;
  currencyISO4217: Scalars['String'];
  priceConfig: Scalars['JSON'];
  productId: Scalars['ID'];
};

export type CreateStationeryPrintOrderInput = {
  category?: InputMaybe<Scalars['String']>;
  currencyConversionData?: InputMaybe<Scalars['JSON']>;
  currencyISO4217?: InputMaybe<Scalars['String']>;
  deliveryMethod: StationeryPrintOrderDeliveryMethodEnum;
  deliveryPriceCurrencyISO4217?: InputMaybe<Scalars['String']>;
  deliveryPriceInMinorUnits?: InputMaybe<Scalars['Int']>;
  details: StationeryPrintOrderDetailsInput;
  discount?: InputMaybe<StationeryPrintOrderDiscountInput>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  issues?: InputMaybe<Array<CreateStationeryPrintOrderIssueInput>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  priceConfigId?: InputMaybe<Scalars['ID']>;
  priceInMinorUnits: Scalars['Int'];
  purchaseContextId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  salesOrderId?: InputMaybe<Scalars['ID']>;
  selectedProductDetails?: InputMaybe<StationeryPrintOrderProductInput>;
  shippingAddress: StationeryPrintOrderShippingAddressInput;
  stationeryDraftId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['String']>;
  vendor: StationeryPrintOrderVendorEnum;
};

export type StationeryPrintOrderDetailsInput = {
  assetUrl: Scalars['String'];
  cardType: Scalars['String'];
  cardTypeSku: Scalars['String'];
  dieCut?: InputMaybe<Scalars['String']>;
  envelope?: InputMaybe<StationeryPrintOrderDetailsEnvelopeInput>;
  foil?: InputMaybe<StationeryPrintOrderDetailsFoilInput>;
  paymentInfo?: InputMaybe<StationeryPrintOrderPaymentInfoInput>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
  taxCode?: InputMaybe<Scalars['String']>;
};

export type StationeryPrintOrderDetailsEnvelopeInput = {
  backImageUrl?: InputMaybe<Scalars['String']>;
  frontImageUrl?: InputMaybe<Scalars['String']>;
  hasRecipientAddress: Scalars['Boolean'];
  sku: Scalars['String'];
  url: Scalars['String'];
};

export type StationeryPrintOrderDetailsFoilInput = {
  colorId: Scalars['String'];
  foilAssetId: Scalars['String'];
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
};

export type StationeryPrintOrderPaymentInfoInput = {
  creditCardBrand: Scalars['String'];
  creditCardLast4: Scalars['String'];
};

export type CreateTaxiTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateTentTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Input for creating a new ticket type. */
export type CreateTicketTypeInput = {
  /** Maximum capacity. Null means unlimited. */
  capacity?: InputMaybe<Scalars['Int']>;
  /** ISO 4217 currency code (e.g., 'USD', 'EUR'). Required. */
  currency: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  formId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  /** Price in minor currency units (cents for USD). Defaults to 0 (free ticket). */
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** When ticket sales end. Null means no end date. */
  salesEndAt?: InputMaybe<Scalars['DateTime']>;
  /** When ticket sales begin. Null means immediately available. */
  salesStartAt?: InputMaybe<Scalars['DateTime']>;
  /** State of this ticket type. Defaults to ACTIVE. */
  state?: InputMaybe<TicketTypeState>;
};

export type CreateTrainTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateTransitionalRegistryPayload = {
  eventId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type CreateTravelAlertSubscriptionInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  baselinePricingInfo?: InputMaybe<AccommodationCatalogPropertyPricingInfoInput>;
  consentAccepted: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  phoneNumber: Scalars['String'];
  source: TravelAlertSubscriptionSource;
  subscribedAlertTypes?: InputMaybe<Array<TravelAlertTriggerType>>;
};

export type AccommodationCatalogPropertyPricingInfoInput = {
  /** base rate is a price without taxes and fees */
  baseRate: TravelMonetaryValueInput;
  /** Platform fees applied to this pricing (e.g. payment processing fee) */
  fees?: InputMaybe<Array<TravelOfferFeeInput>>;
  /** nightly base rate is a price without taxes and fees for a one night stay */
  nightlyBaseRate: TravelMonetaryValueInput;
  /** nightly total rate is a price with taxes and fees for a one night stay */
  nightlyTotalRate: TravelMonetaryValueInput;
  /** nightly base rate per occupancy for a one night stay */
  perNightPerOccupancyBaseAmount?: InputMaybe<TravelMonetaryValueInput>;
  /** nightly base rate per occupancy for a one night stay from a compared provider */
  perNightPerOccupancyStrikeoutBaseAmount?: InputMaybe<TravelMonetaryValueInput>;
  /** nightly total rate per occupancy for a one night stay */
  perNightPerOccupancyTotalAmount?: InputMaybe<TravelMonetaryValueInput>;
  /** a price without taxes and fees from a compared provider */
  strikeoutBaseRate?: InputMaybe<TravelMonetaryValueInput>;
  /** a price without taxes and fees for a one night stay from a compared provider */
  strikeoutNightlyBaseRate?: InputMaybe<TravelMonetaryValueInput>;
  /** a price with taxes and fees for a one night stay from a compared provider */
  strikeoutNightlyTotalRate?: InputMaybe<TravelMonetaryValueInput>;
  /** a provider which was used to get strikeout rates (a compared provider) */
  strikeoutRateProvider?: InputMaybe<StrikeoutRateProvider>;
  /** a price with taxes and fees from a compared provider */
  strikeoutTotalRate?: InputMaybe<TravelMonetaryValueInput>;
  /** total rate is a price with taxes and fees, but without some fees which can be paid in the hotel */
  totalRate: TravelMonetaryValueInput;
};

export type TravelMonetaryValueInput = {
  currency: TravelCurrencyCode;
  digits: Scalars['Int'];
  floatingPointDecimalString: Scalars['String'];
  valueInMinorUnits: Scalars['Int'];
  valueInMinorUnitsBigInt: Scalars['String'];
};

export type TravelOfferFeeInput = {
  amount: TravelMonetaryValueInput;
  isIncludedInTotal: Scalars['Boolean'];
  rate: Scalars['Float'];
  type: FeeType;
  visibility: Scalars['String'];
};

export type CreateVendor = {
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  handle: Scalars['String'];
  location?: InputMaybe<LocationInput>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  startingPrice?: InputMaybe<Scalars['Int']>;
  typeId: Scalars['String'];
  typicalSpend?: InputMaybe<Scalars['Int']>;
  website?: InputMaybe<Scalars['String']>;
};

export type LocationInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type CreateVendorAsCoupleForContactList = {
  email: Scalars['String'];
  eventId: Scalars['String'];
  location?: InputMaybe<LocationInput>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  typeId: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type CreateVendorOrganizationInput = {
  handle: Scalars['String'];
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
};

export type UserInviteInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  role: VendorUserRole;
  vendorId: Scalars['String'];
};

export type CreateVendorUserOnVendor = {
  vendorId: Scalars['String'];
};

export type CreateVenueFromPlaceIdPayload = {
  eventId: Scalars['ID'];
  placeId: Scalars['String'];
};

export type CreateVipPayload = {
  alias?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type DeleteAccommodationPlaceV2Payload = {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteCustomThemeAssetPayload = {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
};

export type EventScheduleDeleteItemPayload = {
  scheduleId: Scalars['ID'];
};

export type DeleteEventTypeInput = {
  id: Scalars['ID'];
};

export type DeleteJsonDataContainerPayload = {
  id: Scalars['ID'];
};

export type PageComponentDeletePayload = {
  id: Scalars['ID'];
};

export type PageContainerDeletePayload = {
  id: Scalars['ID'];
};

export type PointsOnMapDeletePayload = {
  id: Scalars['ID'];
};

export type DeleteVipPayload = {
  id: Scalars['ID'];
};

export type DeliverGuestNotFoundMessagePayload = {
  eventId: Scalars['ID'];
  guest: EmailPerson;
};

export type DeliverRequestForPasswordPayload = {
  eventId: Scalars['ID'];
  guest: EmailPerson;
};

export type DuplicateCashFundInput = {
  cashFundId: Scalars['ID'];
  newName?: InputMaybe<Scalars['String']>;
};

export enum CacheModes {
  CACHE = 'CACHE',
  NOCACHE = 'NOCACHE',
}

export type EditCollectionInfoPayload = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type EditCollectionItemDataPayload = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type SetConfigurationInput = {
  category: Category;
  fontId?: InputMaybe<Scalars['ID']>;
  fontSizePercent?: InputMaybe<Scalars['Float']>;
};

export type EditStationeryPrintOrderInput = {
  card: EditStationeryPrintOrderDraftBlobCardInput;
  customizations?: InputMaybe<EditStationeryPrintOrderDraftBlobCustomizationsInput>;
  details: EditStationeryPrintOrderDetailsInput;
  digitalCustomizations?: InputMaybe<EditStationeryPrintOrderDraftBlobDigitalCustomizationsInput>;
  orderId: Scalars['String'];
};

export type EditStationeryPrintOrderDraftBlobCardInput = {
  back?: InputMaybe<Scalars['JSON']>;
  envelope?: InputMaybe<Scalars['JSON']>;
  front: Scalars['JSON'];
};

export type EditStationeryPrintOrderDraftBlobCustomizationsInput = {
  shape?: InputMaybe<Scalars['String']>;
};

export type EditStationeryPrintOrderDetailsInput = {
  assetUrl: Scalars['String'];
  digitalEnvelopeImageUrl?: InputMaybe<Scalars['String']>;
  envelope?: InputMaybe<EditStationeryPrintOrderDetailsEnvelopeInput>;
  printCardBackPreviewUrl: Scalars['String'];
  printCardFrontPreviewUrl: Scalars['String'];
};

export type EditStationeryPrintOrderDetailsEnvelopeInput = {
  backImageUrl?: InputMaybe<Scalars['String']>;
  frontImageUrl?: InputMaybe<Scalars['String']>;
  hasRecipientAddress?: InputMaybe<Scalars['Boolean']>;
  url: Scalars['String'];
};

export type EditStationeryPrintOrderDraftBlobDigitalCustomizationsInput = {
  backgroundColor?: InputMaybe<Scalars['String']>;
  envelopeAnimation?: InputMaybe<Scalars['String']>;
  envelopeColor?: InputMaybe<Scalars['String']>;
};

export type EventSetWebsiteStatePayload = {
  eventId: Scalars['ID'];
  websiteState: EventWebsiteState;
};

export type ExtractMetadataPayload = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  handle: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateAccommodationRecommendationsPayload = {
  /**
   * Override configuration for AI recommendation agent. Only available to superAdmin users.
   * Allows experimentation with different prompts and recommendation limits.
   * Note: Only applies when OpenAI recommendation strategy is active.
   */
  agentConfigOverride?: InputMaybe<AiRecommendationAgentConfigInput>;
  /** Override autorecommendation algorithm. */
  algorithmOverride?: InputMaybe<AutoRecommendationAlgoDtoEnum>;
  customLocation?: InputMaybe<GenerateAccommodationRecommendationsCustomLocation>;
  eventId: Scalars['ID'];
  filters?: InputMaybe<AutoPopulateAccommodationPlacesFilters>;
  /** Optional idempotency key for deferred operation. If provided, enables polling for async results using this ID. */
  idempotentId?: InputMaybe<Scalars['String']>;
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Scalars['String']>;
  scoringPriorityFields?: InputMaybe<Array<ScoringPriorityField>>;
  searchRadiusKm?: InputMaybe<Scalars['Int']>;
  /** Optional user feedback driving regeneration behavior. */
  userFeedback?: InputMaybe<UserFeedbackDtoEnum>;
};

export type AiRecommendationAgentConfigInput = {
  maxRecommendations?: InputMaybe<Scalars['Int']>;
  modelReasoningEffort?: InputMaybe<Scalars['String']>;
  modelVersion?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  systemPrompt?: InputMaybe<Scalars['String']>;
};

/** AutoRecommendation algorithm */
export enum AutoRecommendationAlgoDtoEnum {
  LuxSolidDecent = 'LuxSolidDecent',
  OpenAIInternetFirst = 'OpenAIInternetFirst',
  OpenAIInternetFirstV3 = 'OpenAIInternetFirstV3',
  PartnerPicks = 'PartnerPicks',
  UserPreferences = 'UserPreferences',
}

export type GenerateAccommodationRecommendationsCustomLocation = {
  googlePlaceId?: InputMaybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type GroupContactsInput = {
  contactIds: Array<Scalars['ID']>;
  eventId: Scalars['ID'];
};

/** Input for creating a Cash Funds Host, which associates payout details with an event. */
export type CreateCashFundsHostInput = {
  /** Address details for the payout account. */
  address: CashFundsHostAddressInput;
  /** An ISO 4217 three-letter currency code */
  currencyCode: Scalars['String'];
  /** The ID of the event to host the cash funds for. */
  eventId: Scalars['ID'];
  /** First name of the host (payee). */
  firstName: Scalars['String'];
  /** Last name of the host (payee). */
  lastName: Scalars['String'];
};

/** Input for the address associated with a Cash Funds Host for payout purposes. */
export type CashFundsHostAddressInput = {
  /** City. */
  city?: InputMaybe<Scalars['String']>;
  /** Country code in ISO 3166-1 alpha-3 */
  countryCode: Scalars['String'];
  /** Primary address line. */
  line1?: InputMaybe<Scalars['String']>;
  /** Secondary address line. */
  line2?: InputMaybe<Scalars['String']>;
  /** Full name on the payout account. */
  name?: InputMaybe<Scalars['String']>;
  /** Phone number for verification. */
  phone?: InputMaybe<Scalars['String']>;
  /** Postal code. */
  postalCode?: InputMaybe<Scalars['String']>;
  /** State or province. */
  state?: InputMaybe<Scalars['String']>;
};

export type InstagramAuthorizationPayload = {
  code: Scalars['String'];
  vendorId: Scalars['String'];
};

export type JoinEventAsActiveUserWithPasswordPayload = {
  /** Event Password, optional for public Events */
  eventPassword?: InputMaybe<Scalars['String']>;
};

export type JoinEventAsPersonWithPasswordPayload = {
  /** Event Password, optional for public Events */
  eventPassword?: InputMaybe<Scalars['String']>;
  /** Person ID Tag, optional for anonymous unlock */
  personIdTag?: InputMaybe<Scalars['String']>;
};

export type JoinEventWithGuidPayload = {
  guidId: Scalars['String'];
};

export type GoogleCalendarCallbackInput = {
  code: Scalars['String'];
  vendorUserId: Scalars['String'];
};

export type LoadImageMetadataPayload = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  url: Scalars['String'];
};

export type LogUserActivityInput = {
  business: UserActivityBusinessInput;
  target: UserActivityTargetInput;
};

export type UserActivityBusinessInput = {
  print?: InputMaybe<PrintUserActivityInput>;
};

export type PrintUserActivityInput = {
  activity: PrintUserActivity;
};

export enum PrintUserActivity {
  createDraft = 'createDraft',
}

/** Input for managing (replacing) the full list of recipients for a Cash Fund Solicitation. This performs a full replacement: deletes all existing and inserts new. */
export type ManageCashFundSolicitationRecipientsInput = {
  /** The complete new list of recipients; must provide all. */
  recipients: Array<CashFundSolicitationRecipientInput>;
  /** The ID of the solicitation whose recipients are being managed. */
  solicitationId: Scalars['ID'];
};

/** Input for specifying a recipient of a Cash Fund Solicitation invite, linking to contacts or providing direct details. */
export type CashFundSolicitationRecipientInput = {
  /** The email address to send the invite to. */
  email: Scalars['String'];
  /** Optional full name of the recipient. */
  fullName?: InputMaybe<Scalars['String']>;
  /** ID of an existing contact from contact_service. */
  guestKey?: InputMaybe<Scalars['String']>;
};

export type MergeContactsInput = {
  contactId: Scalars['ID'];
  contactIdToMerge: Scalars['ID'];
};

export type MilestonesAddDependenciesBatchInput = {
  /** Array of dependency pairs to create */
  dependencies: Array<MilestonesDependencyInput>;
  /** Project ID for authorization */
  projectId: Scalars['ID'];
};

export type MilestonesDependencyInput = {
  dependsOnId: Scalars['ID'];
  milestoneId: Scalars['ID'];
};

export type MilestonesCreateAttachmentInput = {
  blobName: Scalars['String'];
  name: Scalars['String'];
};

export type MilestonesCreateCategoriesBatchInput = {
  /** Array of category data to create */
  categories: Array<MilestonesCreateCategoryItemInput>;
  /** Project ID - all categories will be created in this project */
  projectId: Scalars['ID'];
};

export type MilestonesCreateCategoryItemInput = {
  name: Scalars['String'];
};

export type MilestonesCreateCategoryInput = {
  name: Scalars['String'];
  projectId: Scalars['ID'];
};

export type MilestonesCreateCommentInput = {
  text: Scalars['String'];
};

export type MilestonesCreateMilestoneInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<MilestoneCategory>;
  categoryId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['Timestamp'];
  name: Scalars['String'];
  phaseId?: InputMaybe<Scalars['ID']>;
  projectId: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
  status?: InputMaybe<MilestoneStatus>;
};

export type MilestonesCreateMilestonesBatchInput = {
  /** Array of milestone data to create */
  milestones: Array<MilestonesCreateMilestoneItemInput>;
  /** Project ID - all milestones will be created in this project */
  projectId: Scalars['ID'];
};

export type MilestonesCreateMilestoneItemInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<MilestoneCategory>;
  categoryId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate: Scalars['Timestamp'];
  name: Scalars['String'];
  phaseId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
  status?: InputMaybe<MilestoneStatus>;
};

export type MilestonesCreatePhaseInput = {
  endDate: Scalars['Timestamp'];
  focus?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  projectId: Scalars['ID'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Timestamp'];
};

export type MilestonesCreatePhasesBatchInput = {
  /** Array of phase data to create */
  phases: Array<MilestonesCreatePhaseItemInput>;
  /** Project ID - all phases will be created in this project */
  projectId: Scalars['ID'];
};

export type MilestonesCreatePhaseItemInput = {
  endDate: Scalars['Timestamp'];
  focus?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['Timestamp'];
};

export type MilestonesCreateProjectInput = {
  endDate: Scalars['Timestamp'];
  eventId: Scalars['ID'];
  startDate: Scalars['Timestamp'];
  summary?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type MilestonesCreateStatusNoteInput = {
  text: Scalars['String'];
};

export type MilestonesDeleteCategoriesBatchInput = {
  /** IDs of categories to delete */
  categoryIds: Array<Scalars['ID']>;
  /** Project ID for authorization */
  projectId: Scalars['ID'];
};

export type MilestonesDeleteMilestonesBatchInput = {
  /** IDs of milestones to delete */
  milestoneIds: Array<Scalars['ID']>;
  /** Project ID for authorization */
  projectId: Scalars['ID'];
};

export type MilestonesDeletePhasesBatchInput = {
  /** IDs of phases to delete */
  phaseIds: Array<Scalars['ID']>;
  /** Project ID for authorization */
  projectId: Scalars['ID'];
};

export type MilestonesExportInput = {
  format: MilestonesImportExportFormat;
  projectId: Scalars['ID'];
};

export type MilestonesRemoveDependenciesBatchInput = {
  /** Array of dependency pairs to remove */
  dependencies: Array<MilestonesDependencyInput>;
  /** Project ID for authorization */
  projectId: Scalars['ID'];
};

export type MilestonesStartImportInput = {
  format: MilestonesImportExportFormat;
  projectId: Scalars['ID'];
  sourceUrl: Scalars['String'];
};

export type MilestonesUpdateCategoryInput = {
  name: Scalars['String'];
};

export type MilestonesUpdateMilestoneInput = {
  assigneeUserId?: InputMaybe<Scalars['ID']>;
  category?: InputMaybe<MilestoneCategory>;
  categoryId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Timestamp']>;
  name?: InputMaybe<Scalars['String']>;
  phaseId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
  status?: InputMaybe<MilestoneStatus>;
};

export type MilestonesUpdatePhaseInput = {
  collapsed?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['Timestamp']>;
  focus?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
};

export type MilestonesUpdateProjectInput = {
  endDate?: InputMaybe<Scalars['Timestamp']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
  summary?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** You must provide 3 of 5 properties; (1) `targetId`, (2) **either** `beforeId` or `toLast`, and (3) **either** `afterId` or `toFirst` */
export type ModelReorderPayload = {
  /** The ID of the Model to the left of the Model's new position; *do not specify* `toFirst` */
  afterId?: InputMaybe<Scalars['ID']>;
  /** The ID of the Model to the right of the Model's new position; *do not specify* `toLast` */
  beforeId?: InputMaybe<Scalars['ID']>;
  /** The ID of the Model being moved to a new position in the list */
  targetId: Scalars['ID'];
  /** The Model's new position will be at the start of the list; *do not specify* `afterId` */
  toFirst?: InputMaybe<Scalars['Boolean']>;
  /** The Model's new position will be at the end of the list; *do not specify* `beforeId` */
  toLast?: InputMaybe<Scalars['Boolean']>;
};

export type StationeryPrintOrderProcessInput = {
  id: Scalars['ID'];
  paymentInfo?: InputMaybe<StationeryPrintOrderPaymentInfoInput>;
  purchaseContextId?: InputMaybe<Scalars['ID']>;
  salesOrderId?: InputMaybe<Scalars['ID']>;
  settlementAmountInMinorUnits?: InputMaybe<Scalars['Int']>;
  stripePaymentIntentId?: InputMaybe<Scalars['ID']>;
  taxAmountInMinorUnits?: InputMaybe<Scalars['Int']>;
};

export type ProcessRecommendationPayload = {
  action: ProcessRecommendationAction;
  catalogItemId?: InputMaybe<Scalars['ID']>;
  registryItemId: Scalars['ID'];
};

export enum ProcessRecommendationAction {
  skip = 'skip',
  swap = 'swap',
}

export type QuarantineContactMessageBatchDetailsInput = {
  eventId: Scalars['String'];
  messageBatchId: Scalars['String'];
  messageBatchPayload: Scalars['JSON'];
  messageBatchType: Scalars['String'];
  spamIndicatorsPayload?: InputMaybe<Scalars['JSON']>;
};

export type RecentTravelReservationsByEventMarkAsReadPayload = {
  eventId: Scalars['ID'];
  reservationIds: Array<Scalars['ID']>;
};

export type RefreshOfferTokenAfterReservationPayload = {
  currency: Scalars['String'];
  joyOfferId: Scalars['String'];
  originalPriceInMinorUnits: Scalars['Int'];
  /** Room details for all rooms in the reservation. Used for matching offers when old offer is expired. */
  roomDetails: Array<RefreshOfferTokenRoomDetails>;
};

export type RefreshOfferTokenRoomDetails = {
  /** Number of adults in this room */
  adults: Scalars['Int'];
  /** Board basis type */
  boardBasis: Scalars['String'];
  /** Ages of children in this room */
  childrenAges: Array<Scalars['Int']>;
  /** refundable or nonRefundable */
  refundability: Scalars['String'];
  roomName: Scalars['String'];
};

export type RefreshVendorUserTokenPayload = {
  vendorUserId: Scalars['String'];
};

export type TravelOfferReservationRegeneratePaymentPayload = {
  id: Scalars['String'];
};

export type RemoveContactFromGroupInput = {
  contactId: Scalars['ID'];
  groupId: Scalars['ID'];
};

export type RemoveHostFromBookingTypePayload = {
  bookingTypeId: Scalars['String'];
  vendorUserId: Scalars['String'];
};

export type removeMediaFromCollectionInput = {
  collectionId: Scalars['ID'];
  mediaId: Scalars['ID'];
};

export type RemoveMultipleInviteesPayload = {
  eventId: Scalars['ID'];
  personIdsList: Array<Scalars['ID']>;
};

export type RemoveStayAreaPayload = {
  id: Scalars['ID'];
};

export type RemoveStayAreaPayloadV2 = {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
};

export type RemoveMatchFromListPayload = {
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
};

export type ReorderPayload = {
  currentId: Scalars['String'];
  nextId?: InputMaybe<Scalars['String']>;
  previousId?: InputMaybe<Scalars['String']>;
};

export type GuestlistReorderCustomColumnsInput = {
  columnIds: Array<Scalars['ID']>;
  eventId: Scalars['String'];
};

export type ReorderPageComponent = {
  id: Scalars['ID'];
};

export type RequestVendorEdit = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: InputMaybe<LocationInput>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type ResetUserActivityInput = {
  business: UserActivityBusinessInput;
  target: UserActivityTargetInput;
};

/** Input for bulk reviewing (approving or rejecting) photos in a collection */
export type ReviewMediaPhotosInput = {
  /** The collection containing the photos to review */
  collectionId: Scalars['ID'];
  /** The event the collection belongs to */
  eventId: Scalars['ID'];
  /** IDs of the media photos to review (max 500) */
  mediaPhotoIds: Array<Scalars['ID']>;
  /** The approval status to apply */
  status: ApprovalStatus;
};

/** Approval status for admin review actions. Only APPROVED and REJECTED are valid for review — PENDING is set automatically on guest uploads. */
export enum ApprovalStatus {
  /** Photo has been approved by an admin and will appear in the slideshow */
  APPROVED = 'APPROVED',
  /** Photo has been rejected by an admin and will not appear in the slideshow */
  REJECTED = 'REJECTED',
}

/** Machine-readable result code for the reviewMediaPhotos mutation */
export enum ReviewMediaPhotosCode {
  /** All requested photos were reviewed successfully */
  REVIEW_COMPLETE = 'REVIEW_COMPLETE',
  /** Some requested photos were not found in the collection and were skipped */
  REVIEW_PARTIAL = 'REVIEW_PARTIAL',
}

export type ElectronicCardInput = {
  additionalMessage?: InputMaybe<Scalars['String']>;
  coupleNameFormat?: InputMaybe<Scalars['String']>;
  displayDateFormat?: InputMaybe<Scalars['String']>;
  displayDateString?: InputMaybe<Scalars['String']>;
  displayEventLink?: InputMaybe<Scalars['Boolean']>;
  displayTypeString?: InputMaybe<Scalars['String']>;
  ecardId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['String'];
  linkOptionPrimary?: InputMaybe<Scalars['String']>;
  linkOptionSecondary?: InputMaybe<Scalars['String']>;
  locationString?: InputMaybe<Scalars['String']>;
  locationStringFormat?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  photoEcardTheme?: InputMaybe<Scalars['String']>;
  photoEcardThemePositionX?: InputMaybe<Scalars['Float']>;
  photoEcardThemePositionY?: InputMaybe<Scalars['Float']>;
  photoEcardThemeScale?: InputMaybe<Scalars['Float']>;
  photoId?: InputMaybe<Scalars['String']>;
  recipientIds: Array<Scalars['ID']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type EcardDesignInput = {
  ecardDesignId?: InputMaybe<Scalars['ID']>;
  ecardId: Scalars['ID'];
  shouldUseEventDesign: Scalars['Boolean'];
  themeId: Scalars['ID'];
};

export type ElectronicCardEmailDraftInput = {
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  ecardEmailDraftId?: InputMaybe<Scalars['ID']>;
  ecardId: Scalars['ID'];
  ecardType: EcardType;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAddToCalendar: Scalars['Boolean'];
  includeDate: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  recipientIds?: InputMaybe<Array<Scalars['ID']>>;
  replyToEmail: Scalars['String'];
  salutation: Scalars['String'];
  subject: Scalars['String'];
  subTitle?: InputMaybe<Scalars['String']>;
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ElectronicCardPhotoPayloadInput = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  ecardId: Scalars['ID'];
};

export type EmailPhotoPayloadInput = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  emailId: Scalars['ID'];
};

export type UpdateEventProductVerticalsPayload = {
  optOutOfGuestList?: InputMaybe<Scalars['Boolean']>;
  optOutOfInvites?: InputMaybe<Scalars['Boolean']>;
  optOutOfRegistry?: InputMaybe<Scalars['Boolean']>;
  optOutOfWebsite?: InputMaybe<Scalars['Boolean']>;
};

export type EventRegistrationInput = {
  answers?: InputMaybe<Array<CreateAnswerInput>>;
  contactInfo?: InputMaybe<FormContactInput>;
  formId: Scalars['ID'];
  guestKey?: InputMaybe<Scalars['String']>;
  /** Selected ticket type ID. Required when form has ticketingEnabled in settings. */
  ticketTypeId?: InputMaybe<Scalars['ID']>;
};

export type CreateAnswerInput = {
  answerValue: Scalars['String'];
  questionId: Scalars['ID'];
};

export type FormContactInput = {
  address?: InputMaybe<FormContactAddressInput>;
  contact: FormContactInputData;
  phoneNumbers?: InputMaybe<Array<InputMaybe<FormContactPhoneNumberInput>>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type FormContactAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  householdId?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  region: Scalars['String'];
  validated: Scalars['Boolean'];
};

export type FormContactInputData = {
  email?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  householdDisplayName?: InputMaybe<Scalars['String']>;
  householdId?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  party?: InputMaybe<Scalars['String']>;
};

export type FormContactPhoneNumberInput = {
  allowSMS: Scalars['Boolean'];
  label?: InputMaybe<Scalars['String']>;
  mobile: Scalars['Boolean'];
  number: Scalars['String'];
};

export type GreetingCardInput = {
  cardDetails: Scalars['JSONObject'];
  eventId: Scalars['String'];
  purchaseID?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
  type: Scalars['String'];
};

export type GreetingCardInputWithUrl = {
  baseUrl: Scalars['String'];
  cardDetails: Scalars['JSONObject'];
  eventId: Scalars['String'];
  purchaseID?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
  type: Scalars['String'];
};

export type InsightSaveRagPostWithEmbeddingInput = {
  content: Scalars['String'];
  description: Scalars['String'];
  embeddings: Array<Array<Scalars['Float']>>;
  id?: InputMaybe<Scalars['ID']>;
  postSource: InsightRagPostSource;
  title: Scalars['String'];
  url: Scalars['String'];
};

export enum InsightRagPostSource {
  blog = 'blog',
  intercom = 'intercom',
}

export type PostOfficeGenericEmailMessageInput = {
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions: Scalars['Boolean'];
  includeEventPassword: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails: Scalars['Boolean'];
  message: Scalars['String'];
  personIds: Array<Scalars['ID']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
};

export type PostOfficeGiftWrapEmailMessageInput = {
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  giftExtraCount?: InputMaybe<Scalars['Int']>;
  giftImage?: InputMaybe<Scalars['String']>;
  giftLink?: InputMaybe<Scalars['String']>;
  giftProvider?: InputMaybe<Scalars['String']>;
  giftTitle?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  replyToEmail?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
};

export type PostOfficeGreetingCardEmailMessageInput = {
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  greetingCardUrl: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type PostOfficeReminderEmailMessageInput = {
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions: Scalars['Boolean'];
  includeEventPassword: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails: Scalars['Boolean'];
  message: Scalars['String'];
  personIds: Array<Scalars['ID']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
};

export type PostOfficeThankYouEmailMessageInput = {
  assetId?: InputMaybe<Scalars['String']>;
  containerId?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  personEmails?: InputMaybe<Array<Scalars['String']>>;
  personIds?: InputMaybe<Array<Scalars['ID']>>;
  replyToEmail: Scalars['String'];
  subject: Scalars['String'];
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
};

export type SaveStationeryProductInput = {
  attributesConfig: Scalars['JSON'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  productType: Scalars['String'];
  vendor: StationeryPrintOrderVendorEnum;
  vendorBaseSKU: Scalars['String'];
};

export type SaveStationeryTemplateInput = {
  approved?: InputMaybe<Scalars['Boolean']>;
  category: StationeryTemplateCategoryEnum;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  side: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  themeId: Scalars['ID'];
  themeJSON: Scalars['JSON'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type SaveUserConsentForEventInput = {
  consentAnswer: Scalars['Boolean'];
  consentKey: Scalars['String'];
  consentTermsOfServiceLink?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
};

export type ShortListPayload = {
  eventId: Scalars['String'];
  vendorId: Scalars['String'];
};

export type ShortListEventCreatePayload = {
  vendorId: Scalars['String'];
};

export type ScheduleEventReminderInput = {
  endDate: Scalars['DateTime'];
  isTest?: InputMaybe<Scalars['Boolean']>;
  referenceDate?: InputMaybe<Scalars['DateTime']>;
  startDate: Scalars['DateTime'];
};

/** Input for sending a test email for a Cash Fund Solicitation to verify formatting and content. */
export type SendCashFundSolicitationTestEmailInput = {
  /** Email address to send the test to. */
  email: Scalars['String'];
  /** Name to use for the test recipient personalization. */
  name: Scalars['String'];
  /** The ID of the solicitation to test. */
  solicitationId: Scalars['ID'];
};

export type SendContactCollectorMessagesInput = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  linkLabel?: InputMaybe<Scalars['String']>;
  smsContent?: InputMaybe<Scalars['String']>;
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
  testSMSNumber?: InputMaybe<Scalars['String']>;
};

export type EcardEmailArgs = {
  buttonLink: Scalars['String'];
  buttonText: Scalars['String'];
  date: Scalars['String'];
  emailType: Scalars['String'];
  eventId: Scalars['ID'];
  eventName: Scalars['String'];
  eventWebsite: Scalars['String'];
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAddToCalendar: Scalars['Boolean'];
  includeDate: Scalars['Boolean'];
  location?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  sentToPersonId: Scalars['String'];
  subject: Scalars['String'];
  subTitle: Scalars['String'];
  title: Scalars['String'];
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type ElectronicCardEmailMessageInput = {
  buttonLink?: InputMaybe<Scalars['String']>;
  buttonText?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  ecardEmailId?: InputMaybe<Scalars['ID']>;
  ecardId?: InputMaybe<Scalars['ID']>;
  ecardType?: InputMaybe<EcardType>;
  footerText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAddToCalendar: Scalars['Boolean'];
  includeDate: Scalars['Boolean'];
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  recipientIds?: InputMaybe<Array<Scalars['ID']>>;
  replyToEmail?: InputMaybe<Scalars['String']>;
  salutation: Scalars['String'];
  subject: Scalars['String'];
  subTitle?: InputMaybe<Scalars['String']>;
  testEmail?: InputMaybe<Scalars['String']>;
  testName?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type SendEventDateReminderInput = {
  emailHeadline: Scalars['String'];
  emailTypeOverride: Scalars['String'];
  eventId: Scalars['String'];
  guestFirstName: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  recipientEmailList: Array<Scalars['String']>;
  recipientPhoneNumberList: Array<Scalars['String']>;
  smsHeadline: Scalars['String'];
  subject: Scalars['String'];
  utmCampaign: Scalars['String'];
};

export type GenericEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventLink?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPassword?: InputMaybe<Scalars['String']>;
  eventWebsite?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions?: InputMaybe<Scalars['Boolean']>;
  includeEventPassword?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type GiftCardEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  fromEmail: Scalars['String'];
  giftExtraCount?: InputMaybe<Scalars['Int']>;
  giftImage?: InputMaybe<Scalars['String']>;
  giftLink?: InputMaybe<Scalars['String']>;
  giftProvider?: InputMaybe<Scalars['String']>;
  giftTitle?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  theme: Scalars['String'];
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type MessageRelationArgs = {
  externalMessageId: Scalars['String'];
  redirectUri?: InputMaybe<Scalars['String']>;
  relationId?: InputMaybe<Scalars['ID']>;
  relationshipTag?: InputMaybe<Scalars['String']>;
};

export type SendHotelBlockReminderRequest = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['String'];
  link: Scalars['String'];
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
  testSMSNumber?: InputMaybe<Scalars['String']>;
};

export type SendHotelReminderEmailRequest = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['String'];
  link: Scalars['String'];
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
};

export type SendHotelReminderEmailV2Input = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  smsContent?: InputMaybe<Scalars['String']>;
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  testEmailAddress?: InputMaybe<Scalars['String']>;
  testSMSNumber?: InputMaybe<Scalars['String']>;
};

/**
 * Input for sending a JSON-structured message email to guests.
 * The payload must include schemaURI (URL to JSON schema), subject, and messageType fields.
 */
export type SendJoyJsonMessageEmailInput = {
  eventId: Scalars['String'];
  /** List of guest keys to send the message to */
  guestKeys: Array<Scalars['String']>;
  /** JSON payload that will be validated against the schema specified in payload.schemaURI */
  payload: Scalars['JSON'];
  /** Subject line for the email message */
  subject: Scalars['String'];
};

/**
 * Input for sending a JSON-structured message email to people.
 * The payload must include schemaURI (URL to JSON schema), subject, and messageType fields.
 * NOTE: This is only for Events during the transitionary state before full wedding parity.
 */
export type SendJoyJsonMessageEmailByPeopleIdsInput = {
  eventId: Scalars['String'];
  /** JSON payload that will be validated against the schema specified in payload.schemaURI */
  payload: Scalars['JSON'];
  /** List of people to send the message to */
  people: Array<PersonRecipientInput>;
  /** Subject line for the email message */
  subject: Scalars['String'];
};

/**
 * Person recipient information for sending emails.
 * Client provides all necessary data to avoid redundant M2M calls.
 * NOTE: This is only for Events during the transitionary state before full wedding parity.
 */
export type PersonRecipientInput = {
  /** Person's email address (required for delivery) */
  email: Scalars['String'];
  /** Person's first name for email personalization */
  firstName?: InputMaybe<Scalars['String']>;
  /** Person's last name for email personalization */
  lastName?: InputMaybe<Scalars['String']>;
  personId: Scalars['String'];
};

export type SendJoyJsonMessagesInput = {
  /** Guest keys for email recipients */
  emailGuestKeys: Array<Scalars['String']>;
  eventId: Scalars['String'];
  /** JSON payload validated against payload.schemaURI. Must include schemaURI and messageType. */
  payload: Scalars['JSON'];
  /**
   * Plain-text content for SMS messages. Required when sending SMS.
   * The email JSON payload structure is dynamic and there is no reliable way to extract
   * appropriate SMS content from it, so explicit SMS text must be provided when sending SMS.
   */
  smsContent?: InputMaybe<Scalars['String']>;
  /** Guest keys for SMS recipients. Requires Messaging Plus tier. */
  smsGuestKeys: Array<Scalars['String']>;
  /** Subject line for the email message */
  subject: Scalars['String'];
};

export type SendJoyJsonMessagesByPersonIdsInput = {
  /** Person IDs for email recipients */
  emailPersonIds: Array<Scalars['ID']>;
  eventId: Scalars['String'];
  /** JSON payload validated against payload.schemaURI. Must include schemaURI and messageType. */
  payload: Scalars['JSON'];
  /**
   * Plain-text content for SMS messages. Required when sending SMS.
   * The email JSON payload structure is dynamic and there is no reliable way to extract
   * appropriate SMS content from it, so explicit SMS text must be provided when sending SMS.
   */
  smsContent?: InputMaybe<Scalars['String']>;
  /** Person IDs for SMS recipients. Requires Messaging Plus tier. */
  smsPersonIds: Array<Scalars['ID']>;
  /** Subject line for the email message */
  subject: Scalars['String'];
};

export type SendJoyProGeneralMessageEmailInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  guestKeys: Array<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type MessageToMultipleVendorsPayload = {
  budget?: InputMaybe<Scalars['Int']>;
  coupleName?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['String']>;
  fianceeFirstName: Scalars['String'];
  fromEmail: Scalars['String'];
  ids: Array<Scalars['String']>;
  ownerFirstName: Scalars['String'];
  photosForCollection?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeIdForVenue?: InputMaybe<Scalars['String']>;
  requestSentAt: Scalars['String'];
  text: Scalars['String'];
};

export type MessageToVendorPayload = {
  budget?: InputMaybe<Scalars['Int']>;
  coupleName?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['String']>;
  fianceeFirstName: Scalars['String'];
  fromEmail: Scalars['String'];
  id: Scalars['ID'];
  ownerFirstName: Scalars['String'];
  photosForCollection?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placeIdForVenue?: InputMaybe<Scalars['String']>;
  requestSentAt: Scalars['String'];
  text: Scalars['String'];
};

export type PostOfficeGreetingCardEmailInput = {
  draftId: Scalars['ID'];
  eventId: Scalars['ID'];
  giverName: Scalars['String'];
  replyToEmail: Scalars['String'];
};

export type EmailRelationInput = {
  externalMessageId: Scalars['String'];
  redirectUri: Scalars['String'];
  relationshipTag?: InputMaybe<Scalars['String']>;
};

export type SendPostOfficeThankYouEmailV2Input = {
  eventId: Scalars['String'];
  eventName: Scalars['String'];
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  personId: Scalars['String'];
  relationData?: InputMaybe<SendPostOfficeThankYouEmailRelationDataV2Input>;
  replyToEmail: Scalars['String'];
  subject: Scalars['String'];
  toEmail: Scalars['String'];
};

export type SendPostOfficeThankYouEmailRelationDataV2Input = {
  externalMessageId: Scalars['String'];
  redirectUri: Scalars['String'];
  relationshipTag?: InputMaybe<Scalars['String']>;
};

export type SendPostRsvpEventDetailsEmailInput = {
  email: Scalars['String'];
  eventId: Scalars['String'];
  guestFirstName: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type SendPostRsvpMessagesInput = {
  eventId: Scalars['String'];
  recipientResponses: Array<RsvpResponse>;
};

export type RsvpResponse = {
  guestFirebaseId: Scalars['String'];
  isRsvpSubmitter?: InputMaybe<Scalars['Boolean']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  questions: Array<RsvpQuestion>;
  sendHouseholdSms?: InputMaybe<Scalars['Boolean']>;
  skipRsvpEmails?: InputMaybe<Scalars['Boolean']>;
};

export type RsvpQuestion = {
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type SendPostRsvpMessagesInputV2 = {
  eventId: Scalars['String'];
  recipientResponses: Array<RsvpResponseV2>;
};

export type RsvpResponseV2 = {
  guestFirebaseId: Scalars['String'];
  isRsvpSubmitter?: InputMaybe<Scalars['Boolean']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  questions: Array<RsvpQuestionV2>;
  sendHouseholdSms?: InputMaybe<Scalars['Boolean']>;
  skipRsvpEmails?: InputMaybe<Scalars['Boolean']>;
};

export type RsvpQuestionV2 = {
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type SendPostRsvpSmsInput = {
  code: Scalars['String'];
  eventId: Scalars['String'];
  guestId?: InputMaybe<Scalars['String']>;
  notAttending?: InputMaybe<Scalars['Boolean']>;
  phone: Scalars['String'];
};

export type SendPremiumDigitalOrderInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  recipientIdList: Array<Scalars['ID']>;
  senderName: Scalars['String'];
  smsRecipientIdList?: InputMaybe<Array<Scalars['ID']>>;
  subject: Scalars['String'];
};

/** An registryItemId and email used to lookup a RegistryOrder item for resending an email */
export type SendRegistryOrderConfirmationInput = {
  email: Scalars['String'];
  emailIntent?: InputMaybe<RegistryOrderEmailIntent>;
  registryItemId: Scalars['String'];
};

/** Email type so send different subject lines and headers */
export enum RegistryOrderEmailIntent {
  find = 'find',
  reminder = 'reminder',
  reservation = 'reservation',
}

export type ReminderEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventLink?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPassword?: InputMaybe<Scalars['String']>;
  eventWebsite?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions?: InputMaybe<Scalars['Boolean']>;
  includeEventPassword?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type SendRsvpReminderV2Input = {
  body: Scalars['String'];
  emailPersonIds?: InputMaybe<Array<Scalars['String']>>;
  eventId: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  smsContent?: InputMaybe<Scalars['String']>;
  smsPersonIds?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
};

export type AutomaticEventReminderInput = {
  eventDate: Scalars['DateTime'];
  eventDisplayName: Scalars['String'];
  eventId: Scalars['ID'];
  firebaseEventId: Scalars['String'];
};

export type TestEmailWithTemplateArgs = {
  subject: Scalars['String'];
  templateName: Scalars['String'];
  toEmail: Scalars['String'];
};

export type SendTestJoyJsonMessageEmailInput = {
  eventId: Scalars['String'];
  payload: Scalars['JSON'];
  subject: Scalars['String'];
  testEmailAddress: Scalars['String'];
  testName: Scalars['String'];
};

export type SendTestJoyProGeneralMessageEmailInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  includeGuestNames?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  testEmailAddress: Scalars['String'];
  testName: Scalars['String'];
};

export type SendTestPremiumDigitalCardInput = {
  idempotencyKey?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  senderName: Scalars['String'];
  subject: Scalars['String'];
};

export type SendTestRsvpReminderV2Input = {
  body: Scalars['String'];
  eventId: Scalars['String'];
  imageUrl?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  subject: Scalars['String'];
  testEmailAddress: Scalars['String'];
};

export type ThankYouEmailArgs = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventName?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type SendTravelAlertOtpInput = {
  channel: TravelAlertChannel;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export enum TravelAlertChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}

export type SetAccentPayload = {
  accent: Scalars['String'];
  eventDesignId: Scalars['ID'];
};

export type SetFeaturePreferenceColor = {
  colorLocation?: InputMaybe<ColorPointerLocation>;
  eventDesignId: Scalars['ID'];
  index: Scalars['Int'];
};

export type AttendanceInput = {
  attendanceState: AttendanceState;
  eventId: Scalars['ID'];
  formId?: InputMaybe<Scalars['ID']>;
  guestKey: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export type DesignPreferenceRangeInput = {
  eventDesignId: Scalars['ID'];
  featureId: Scalars['ID'];
  rangeValue: Scalars['Float'];
};

export type DesignPreferenceBooleanInput = {
  booleanValue: Scalars['Boolean'];
  eventDesignId: Scalars['ID'];
  featureId: Scalars['ID'];
};

export type SetCustomCssPayload = {
  customCss: Scalars['String'];
  eventDesignId: Scalars['ID'];
};

export type BookingTypeDefaultAvailabilityInput = {
  bookingWindowLeadHours?: InputMaybe<Scalars['Int']>;
  friday: Array<BookingTypeAvailabilityDayInput>;
  handle: Scalars['String'];
  monday: Array<BookingTypeAvailabilityDayInput>;
  saturday: Array<BookingTypeAvailabilityDayInput>;
  sunday: Array<BookingTypeAvailabilityDayInput>;
  thursday: Array<BookingTypeAvailabilityDayInput>;
  tuesday: Array<BookingTypeAvailabilityDayInput>;
  wednesday: Array<BookingTypeAvailabilityDayInput>;
};

/** Asset information for an Image */
export type SetAssetPayload = {
  assetId: Scalars['String'];
  fileSize: Scalars['Int'];
  height: Scalars['Int'];
  ignoreChannel?: InputMaybe<Scalars['Boolean']>;
  md5?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
  width: Scalars['Int'];
};

export type SetDesignPhotoPayload = {
  designPhotoId?: InputMaybe<Scalars['ID']>;
  eventDesignId: Scalars['ID'];
};

/** Set the desktop photo URL for an event */
export type SetEventPhotoV2Payload = {
  eventId: Scalars['ID'];
  photoV2Url: Scalars['String'];
};

/** Set the mobile version of photo URL for an event */
export type SetEventPhotoV2MobilePayload = {
  eventId: Scalars['ID'];
  photoV2UrlMobile: Scalars['String'];
};

export type SetEventStylePayload = {
  accent?: InputMaybe<Scalars['String']>;
  backgroundType?: InputMaybe<Scalars['String']>;
  customCss?: InputMaybe<Scalars['String']>;
  font?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Layout>;
  primaryColor?: InputMaybe<Scalars['String']>;
  primaryTextColor?: InputMaybe<Scalars['String']>;
  suggestedColor?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<Scalars['String']>;
  translucent?: InputMaybe<Scalars['Boolean']>;
  useSuggestedThemeColorAloha?: InputMaybe<Scalars['Boolean']>;
};

export type SetFontPayload = {
  eventDesignId: Scalars['ID'];
  fontId: Scalars['ID'];
};

export type GuestlistSetCustomColumnValueInput = {
  columnId: Scalars['ID'];
  contactId: Scalars['ID'];
  eventId: Scalars['String'];
  value?: InputMaybe<Scalars['JSON']>;
};

export type GuestlistBulkSetColumnValueEntry = {
  columnId: Scalars['ID'];
  contactId: Scalars['ID'];
  value?: InputMaybe<Scalars['JSON']>;
};

export type SetHasVisitedDesignPagePayload = {
  eventDesignId: Scalars['ID'];
  hasVisitedDesignPage: Scalars['Boolean'];
};

export type setMediaTokenPermissionsInput = {
  collectionId: Scalars['ID'];
  permissions: Array<InputMaybe<MagicTokenPermissions>>;
};

export type SetColorPayload = {
  color: Scalars['String'];
  eventDesignId: Scalars['ID'];
  paletteId: Scalars['ID'];
};

export type SetPhotoAlignmentPayload = {
  alignment: PhotoAlignment;
  isMobile?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<EventPageType>;
};

export type StationeryPrintOrderStatusInput = {
  message?: InputMaybe<Scalars['String']>;
  printOrderId: Scalars['ID'];
  status: StationeryPrintOrderStatusEnum;
};

export type SetPropertiesPayload = {
  accent?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  customCss?: InputMaybe<Scalars['String']>;
  eventDesignId: Scalars['ID'];
  fontId?: InputMaybe<Scalars['ID']>;
  layoutId?: InputMaybe<Scalars['ID']>;
  paletteId?: InputMaybe<Scalars['ID']>;
  themeId?: InputMaybe<Scalars['ID']>;
  useSuggestedThemeColor?: InputMaybe<Scalars['Boolean']>;
};

/** The currency code */
export type EventCurrencyInput = {
  code: Scalars['String'];
};

export type RegistryEventDataInput = {
  delayOrderFulfillment?: InputMaybe<Scalars['Boolean']>;
  disableWhiteGloveforPartnerItems?: InputMaybe<Scalars['Boolean']>;
  disableWhiteGloveforSyncedItems?: InputMaybe<Scalars['Boolean']>;
  disableWhiteGloveforTransferredItems?: InputMaybe<Scalars['Boolean']>;
  hideRegistryInMessaging?: InputMaybe<Scalars['Boolean']>;
};

export type ReservedRoomBlocksRequest = {
  address?: InputMaybe<Scalars['String']>;
  bookingUrl?: InputMaybe<Scalars['String']>;
  checkInDate?: InputMaybe<Scalars['DateTime']>;
  checkOutDate?: InputMaybe<Scalars['DateTime']>;
  cutoffDate?: InputMaybe<Scalars['DateTime']>;
  displayName?: InputMaybe<Scalars['String']>;
  hotelMoreInfoUrl?: InputMaybe<Scalars['String']>;
  hotelRoomBlocksId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  note?: InputMaybe<Scalars['String']>;
  numberOfNightsBooked?: InputMaybe<Scalars['Int']>;
  numberOfNightsGuestBooked?: InputMaybe<Scalars['Int']>;
  numberOfRoomsBooked?: InputMaybe<Scalars['Int']>;
  numberOfRoomsGuestBooked?: InputMaybe<Scalars['Int']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  pricePerNight?: InputMaybe<Scalars['Float']>;
  starRating?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<ReservedRoomBlockStatus>;
  strikeoutPricePerNight?: InputMaybe<Scalars['Float']>;
};

export type SetSearchMetadataInput = {
  description?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  templateID: Scalars['String'];
};

export type SetStationeryDigitalPrintOrderFeatureSmsInput = {
  enabled: Scalars['Boolean'];
  orderId: Scalars['String'];
};

export type SetStationeryDigitalPrintOrderQuantityInput = {
  orderId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type SetStationeryDraftRecipientIdListInput = {
  id: Scalars['ID'];
  recipientIdList?: InputMaybe<Array<Scalars['ID']>>;
};

export type SetThemePayload = {
  eventDesignId: Scalars['ID'];
  themeId: Scalars['ID'];
  useSuggestedThemeColor?: InputMaybe<Scalars['Boolean']>;
};

export type SetThemeAndLayoutPayload = {
  brannanNavigation?: InputMaybe<BrannanNavigation>;
  eventDesignId: Scalars['ID'];
  layoutId: Scalars['ID'];
  themeId: Scalars['ID'];
  useCustomTheme?: InputMaybe<Scalars['Boolean']>;
  useSuggestedThemeColor?: InputMaybe<Scalars['Boolean']>;
};

export type SetLayoutPayload = {
  eventDesignId: Scalars['ID'];
  layoutId: Scalars['ID'];
};

export type AddSimpleTagToPhotosInCollectionPayload = {
  collectionId: Scalars['ID'];
  tags: Array<Scalars['String']>;
};

export type AddSimpleTagPayload = {
  photoIds: Array<Scalars['String']>;
  tags: Array<Scalars['String']>;
};

export type SortItemsPayload = {
  eventId: Scalars['String'];
  items: Array<ItemToSort>;
};

export type ItemToSort = {
  id: Scalars['ID'];
  sortKey: Scalars['String'];
};

export enum SalesOrderRefundMethod {
  REFUND = 'REFUND',
  STRIPE_REFUND = 'STRIPE_REFUND',
  SWAP_FOR_CASH = 'SWAP_FOR_CASH',
}

export type StartStationeryCheckoutInput = {
  address: StationeryShippingAddressInput;
  email: Scalars['String'];
  eventId: Scalars['ID'];
  failureUrlTemplate: Scalars['String'];
  name: Scalars['String'];
  printOrder: StationeryCheckoutPrintOrderInput;
  successUrlTemplate: Scalars['String'];
  themeDisplayName?: InputMaybe<Scalars['String']>;
};

export type StationeryShippingAddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  validated?: InputMaybe<Scalars['Boolean']>;
};

export type StationeryCheckoutPrintOrderInput = {
  orderId: Scalars['String'];
};

export type StartStationeryInternationalCheckoutInput = {
  failureUrlTemplate: Scalars['String'];
  printOrderId: Scalars['String'];
  successUrlTemplate: Scalars['String'];
};

export type AIBackgroundPromptPayload = {
  prompt: Scalars['String'];
  style: Scalars['String'];
};

export type CreateStationeryDigitalViewInput = {
  cardOrderId: Scalars['String'];
  personId: Scalars['String'];
  src: Scalars['String'];
};

export type SubmitFormAnswersInput = {
  answers: Array<CreateAnswerInput>;
  formId: Scalars['ID'];
  guestKey?: InputMaybe<Scalars['String']>;
};

export type HotelRoomBlockLeadInfoSubmittedRequest = {
  address?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  anyOtherInformation?: InputMaybe<Scalars['String']>;
  calendlyUri?: InputMaybe<Scalars['String']>;
  checkInDate?: InputMaybe<Scalars['DateOnly']>;
  checkOutDate?: InputMaybe<Scalars['DateOnly']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  destinationWedding?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  externalHotelInfo?: InputMaybe<Array<ExternalHotelInfo>>;
  fullName?: InputMaybe<Scalars['String']>;
  guestCount?: InputMaybe<Scalars['Float']>;
  /** deprecated, use externalHotelInfo */
  hotelUrls?: InputMaybe<Array<Scalars['String']>>;
  /** Is the given address same as the address of the venue */
  isAddressTheVenue?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  long?: InputMaybe<Scalars['Float']>;
  outOfTown?: InputMaybe<Scalars['Float']>;
  partner1?: InputMaybe<PartnerInfo>;
  partner2?: InputMaybe<PartnerInfo>;
  phone?: InputMaybe<Scalars['String']>;
  placeName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  preferredContactMethod?: InputMaybe<ContactMethods>;
  roomsToBlock?: InputMaybe<Scalars['String']>;
  secondaryEmail?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<LeadSourceTypes>;
  stateRegionProvince?: InputMaybe<Scalars['String']>;
};

export type ExternalHotelInfo = {
  address?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  hotelUrl: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  long?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<HotelLocationProvider>;
};

/** The provider of the hotels data */
export enum HotelLocationProvider {
  Google = 'Google',
  Zentrumhub = 'Zentrumhub',
}

export type PartnerInfo = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

/** The source of the lead */
export enum LeadSourceTypes {
  preferred = 'preferred',
}

export type SyncReserveRoomBlocksToAccommodationPlacesRequest = {
  batchSize?: InputMaybe<Scalars['Float']>;
};

export type TagUserInPhotoPayload = {
  photoId: Scalars['ID'];
  userId: Scalars['String'];
};

export type TagVendorInPhotoPayload = {
  photoId: Scalars['ID'];
  vendorId: Scalars['String'];
};

export type TagVendorInPhotosOnCollectionPayload = {
  collectionId: Scalars['ID'];
  vendorIds: Array<Scalars['String']>;
};

export type ToggleDesignFavoriteInput = {
  eventId: Scalars['ID'];
  isFavorite: Scalars['Boolean'];
  /** Primary resource to favorite (Font: FontId, Art: ThemeId, Template: ThemeId) */
  resourceId: Scalars['ID'];
  /** Secondary resource to favorite (Template: LayoutId) */
  secondaryResourceId?: InputMaybe<Scalars['ID']>;
  type: FavoriteType;
};

export type ImpactRadiusTrackingPayload = {
  actionTrackerId: Scalars['Int'];
  campaignId: Scalars['Int'];
  clickId: Scalars['String'];
  customerEmail: Scalars['String'];
  customerId: Scalars['String'];
  /** New or Returning */
  customerStatus: Scalars['String'];
  /** An ISO-8601 timestamp */
  eventDate: Scalars['String'];
  itemCategory1?: InputMaybe<Scalars['String']>;
  itemQuantity1?: InputMaybe<Scalars['Int']>;
  itemSKU1?: InputMaybe<Scalars['String']>;
  itemSubtotal1?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['String'];
  text1?: InputMaybe<Scalars['String']>;
};

export type TransferTransitionalRegistryItemsPayload = {
  transitionalRegistryId: Scalars['ID'];
  transitionalRegistryItemIds: Array<Scalars['ID']>;
};

export type TravelOfferReservationCancelPayload = {
  reservationId: Scalars['String'];
};

export type TravelOfferReservationConfirmPayload = {
  billingContact: TravelOfferReservationBillingContact;
  campaignId?: InputMaybe<Scalars['String']>;
  paymentCredential: Scalars['String'];
  paymentCredentialType: TravelPaymentCredentialType;
  travelOfferReservationId: Scalars['String'];
};

export type TravelOfferReservationBillingContact = {
  age?: InputMaybe<Scalars['Float']>;
  contact?: InputMaybe<TravelOfferReservationBillingContactContact>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: TravelReservationGuestAgeClassification;
};

export type TravelOfferReservationBillingContactContact = {
  address: TravelOfferReservationBillingContactAddress;
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type TravelOfferReservationBillingContactAddress = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

export enum TravelPaymentCredentialType {
  VAULTERA_CREDIT_CARD_TOKENIZED = 'VAULTERA_CREDIT_CARD_TOKENIZED',
}

export type TravelOfferReservationCreatePayload = {
  billingContact?: InputMaybe<TravelOfferReservationBillingContact>;
  campaignId?: InputMaybe<Scalars['String']>;
  checkoutType?: InputMaybe<TravelOfferReservationCheckoutType>;
  couponCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  offerToken: Scalars['String'];
  roomGuests?: InputMaybe<Array<TravelOfferReservationRoomGuestsInput>>;
};

/** Type of checkout for TravelOfferReservation */
export enum TravelOfferReservationCheckoutType {
  stripe_native = 'stripe_native',
  vaultera_vault = 'vaultera_vault',
}

export type TravelOfferReservationRoomGuestsInput = {
  guests: Array<TravelOfferReservationGuestInformationInput>;
  unitId: Scalars['String'];
};

export type TravelOfferReservationGuestInformationInput = {
  age?: InputMaybe<Scalars['Float']>;
  ageClassification: TravelReservationGuestAgeClassification;
  countryCode?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<TravelReservationGuestTitle>;
};

export type TravelOfferReservationUpdatePayload = {
  billingContact?: InputMaybe<TravelOfferReservationBillingContact>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  roomGuests?: InputMaybe<Array<TravelOfferReservationRoomGuestsInput>>;
};

export type TravelReservationEvaluationApproveInput = {
  dispositionCode: TravelReservationEvaluationApproveDispositionCode;
  evaluationId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export enum TravelReservationEvaluationApproveDispositionCode {
  APPROVED_LEGIT = 'APPROVED_LEGIT',
}

export type TravelReservationEvaluationCancelInput = {
  dispositionCode: TravelReservationEvaluationCancelDispositionCode;
  evaluationId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
};

export enum TravelReservationEvaluationCancelDispositionCode {
  CANCELED_EFW_ACTIONABLE = 'CANCELED_EFW_ACTIONABLE',
  CANCELED_FRAUD_SUSPECTED = 'CANCELED_FRAUD_SUSPECTED',
  CANCELED_IDENTITY_COLLISION = 'CANCELED_IDENTITY_COLLISION',
  CANCELED_IDENTITY_FRAUD_ACTIVITY = 'CANCELED_IDENTITY_FRAUD_ACTIVITY',
  CANCELED_NON_REFUNDABLE_RISK = 'CANCELED_NON_REFUNDABLE_RISK',
}

export type TravelEventCacheWarmUpRequestPayload = {
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  /** Event handle/website identifier (e.g., "my-event-handle") */
  eventHandle: Scalars['String'];
  /** Whether fees should be included in totalAmount. Defaults to false. */
  includeFees?: InputMaybe<Scalars['Boolean']>;
  /** UX scenario triggering the warm-up request */
  scenario: TravelEventCacheWarmUpRequestUxType;
};

/** UX which is triggering the warm-up request */
export enum TravelEventCacheWarmUpRequestUxType {
  GUEST = 'GUEST',
  HOST = 'HOST',
  HOST_CHANGED_VENUE = 'HOST_CHANGED_VENUE',
}

export type UnlockRequestForProposalPayload = {
  id: Scalars['ID'];
};

export type UpdateAccommodationPlaceV2Request = {
  accommodationRoomBlock?: InputMaybe<AccommodationPlaceV2RoomBlockRequest>;
  autoSuggestionAlgo?: InputMaybe<AutoSuggestionAlgoType>;
  category?: InputMaybe<AccommodationPlaceCategory>;
  customAddress?: InputMaybe<Scalars['String']>;
  customName?: InputMaybe<Scalars['String']>;
  customPhone?: InputMaybe<Scalars['String']>;
  customPhotoId?: InputMaybe<Scalars['String']>;
  customStarRating?: InputMaybe<Scalars['Float']>;
  customUrl?: InputMaybe<Scalars['String']>;
  displayLocation?: InputMaybe<AccommodationPlaceDisplayLocation>;
  id: Scalars['ID'];
  isCustomLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isHostStayingHere?: InputMaybe<Scalars['Boolean']>;
  isPhotoHidden?: InputMaybe<Scalars['Boolean']>;
  layoutType?: InputMaybe<Scalars['String']>;
  sourceOfData?: InputMaybe<AccommodationPlaceSourceOfData>;
  userNote?: InputMaybe<Scalars['String']>;
};

export type UpdateAccommodationPlaceV2RequestV2 = {
  accommodationRoomBlock?: InputMaybe<AccommodationPlaceV2RoomBlockRequest>;
  autoSuggestionAlgo?: InputMaybe<AutoSuggestionAlgoType>;
  category?: InputMaybe<AccommodationPlaceCategory>;
  customAddress?: InputMaybe<Scalars['String']>;
  customName?: InputMaybe<Scalars['String']>;
  customPhone?: InputMaybe<Scalars['String']>;
  customPhotoId?: InputMaybe<Scalars['String']>;
  customStarRating?: InputMaybe<Scalars['Float']>;
  customUrl?: InputMaybe<Scalars['String']>;
  displayLocation?: InputMaybe<AccommodationPlaceDisplayLocation>;
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  isCustomLinkEnabled?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isHostStayingHere?: InputMaybe<Scalars['Boolean']>;
  isPhotoHidden?: InputMaybe<Scalars['Boolean']>;
  layoutType?: InputMaybe<Scalars['String']>;
  sourceOfData?: InputMaybe<AccommodationPlaceSourceOfData>;
  userNote?: InputMaybe<Scalars['String']>;
};

export type UpdateEventSessionPayload = {
  givenPassword?: InputMaybe<Scalars['String']>;
  givenSecret?: InputMaybe<Scalars['String']>;
  guestKey?: InputMaybe<Scalars['String']>;
  isLoggedOut?: InputMaybe<Scalars['Boolean']>;
  permitUserId?: InputMaybe<Scalars['String']>;
  personIdTag?: InputMaybe<Scalars['String']>;
};

export type UpdateBookingSlotArgs = {
  alternateEmail?: InputMaybe<Scalars['String']>;
  customerInsights?: InputMaybe<BookingSlotCustomerInsightsInput>;
  dateString?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  simpleNotes?: InputMaybe<Scalars['String']>;
  simpleSurvey?: InputMaybe<SimpleSurveyInput>;
  status?: InputMaybe<BookingSlotStatusType>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type BookingSlotStatusArgs = {
  id: Scalars['ID'];
  status: BookingSlotStatusType;
};

export type UpdateBookingTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  bookingType?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateBookingTypeInput = {
  availability?: InputMaybe<BookingTypeAvailabilityPayload>;
  bookingProcess?: InputMaybe<BookingTypeProcessType>;
  description?: InputMaybe<Scalars['String']>;
  eventLength?: InputMaybe<Scalars['Int']>;
  eventType?: InputMaybe<BookingTypeEventType>;
  handle?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  interval?: InputMaybe<Scalars['Int']>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  locationString?: InputMaybe<Scalars['String']>;
  meetingInfoNotes?: InputMaybe<Scalars['String']>;
  meetingUrl?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BookingTypeAvailabilityPayload = {
  friday: Array<BookingTypeAvailabilityDayInput>;
  monday: Array<BookingTypeAvailabilityDayInput>;
  saturday: Array<BookingTypeAvailabilityDayInput>;
  sunday: Array<BookingTypeAvailabilityDayInput>;
  thursday: Array<BookingTypeAvailabilityDayInput>;
  tuesday: Array<BookingTypeAvailabilityDayInput>;
  wednesday: Array<BookingTypeAvailabilityDayInput>;
};

/**
 * Used for updating an existing Cash Fund with complete replacement of fields.
 * Dense input: the caller must provide **all Fields** in the input. Any field that is omitted will be either nulled or blanked.
 * Currency cannot be updated.
 */
export type UpdateCashFundInput = {
  /** The ID of the cash fund to update. */
  cashFundId: Scalars['ID'];
  /** Updated fixed contribution amount, if omitted will be cleared. */
  fixedContributionAmountInMinorUnits?: InputMaybe<Scalars['Int']>;
  /** Updated hide goal flag. */
  hideGoal: Scalars['Boolean'];
  /** Updated name of the cash fund. */
  name: Scalars['String'];
  /** Updated note, if omitted will be cleared. */
  note?: InputMaybe<Scalars['String']>;
  /**
   * Updated photo URL, if omitted will be cleared.
   * Contributes to the Solicitation Photo reference
   */
  photoUrl?: InputMaybe<Scalars['String']>;
  /** Updated goal amount, if omitted will be cleared. */
  totalGoalInMinorUnits?: InputMaybe<Scalars['Int']>;
};

/**
 * Used for updating an existing Cash Fund Solicitation.
 * Dense input: the caller must provide **all Fields** in the input. Any field that is omitted will be either nulled or blanked.
 */
export type UpdateCashFundSolicitationInput = {
  /** Updated configuration. */
  config: CashFundSolicitationConfigInput;
  /** Updated message body. */
  inviteMessage: Scalars['String'];
  /** Updated subject line. */
  inviteSubject: Scalars['String'];
  /** Updated name, if omitted cleared. */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the solicitation to update. */
  solicitationId: Scalars['ID'];
};

export type ChecklistItemUpdateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  reminderAt?: InputMaybe<Scalars['DateTime']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ChecklistSubItemUpdateInput = {
  action?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ConciergeImageUpload = {
  photoUrl: Scalars['String'];
  salesforceOwnerId: Scalars['String'];
};

/** Added in erorr. Do not use */
export type UpdateDonationFundDonationInput = {
  amountMonetaryMinorValue: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  platformType: DonationFundPaymentMethodEnum;
};

export type UpdateEmailTemplateInput = {
  eventId: Scalars['String'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  templateData?: InputMaybe<Scalars['JSON']>;
};

export type EventChecklistUpdateInput = {
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateEventCountdownComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateEventDetailsComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateEventDetailsMessagingPayload = {
  eventDetailsAutomaticRemindersEnabled?: InputMaybe<Scalars['Boolean']>;
  eventDetailsMessagingEnabled?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['String'];
  rsvpNoCustomRedirectEnabled?: InputMaybe<Scalars['Boolean']>;
  rsvpNoCustomRedirectUrl?: InputMaybe<Scalars['String']>;
  rsvpPendingCustomRedirectEnabled?: InputMaybe<Scalars['Boolean']>;
  rsvpPendingCustomRedirectUrl?: InputMaybe<Scalars['String']>;
  rsvpYesCustomRedirectEnabled?: InputMaybe<Scalars['Boolean']>;
  rsvpYesCustomRedirectUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateEventDisplayNameComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateEventDomainPayload = {
  /** The domain name; set this property to null to delete the Event Domain */
  domainName?: InputMaybe<Scalars['String']>;
};

export type UpdateEventInfoPayload = {
  announcementBanner?: InputMaybe<EventAnnouncementBannerPayload>;
  /** An ISO-8601 timestamp or datestamp (no 'T') */
  date?: InputMaybe<Scalars['String']>;
  eventDateIsFinalized?: InputMaybe<Scalars['Boolean']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  /** NOT FOR CLIENT USE.  @deprecated(reason: 'for M2M communication only') */
  eventPassword?: InputMaybe<Scalars['String']>;
  /** NOT FOR CLIENT USE.  @deprecated(reason: 'for M2M communication only') */
  eventSecret?: InputMaybe<Scalars['String']>;
  fianceeFirstName?: InputMaybe<Scalars['String']>;
  fianceeLastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationInput>;
  ownerFirstName?: InputMaybe<Scalars['String']>;
  ownerLastName?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type EventAnnouncementBannerPayload = {
  active: Scalars['Boolean'];
  message?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type EventDataPayload = {
  budget?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['String']>;
  guestCount?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
};

export type UpdateEventPagePayload = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  pageSubTitle?: InputMaybe<Scalars['String']>;
  pageTitle?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  visibility?: InputMaybe<EventPageVisibility>;
};

export type EventPlaceUpdatePayload = {
  googlePlaceId: Scalars['String'];
  id: Scalars['ID'];
};

export type EventScheduleUpdateItemPayload = {
  description?: InputMaybe<Scalars['String']>;
  dressCode?: InputMaybe<Scalars['String']>;
  endTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  placeId?: InputMaybe<Scalars['String']>;
  scheduleId: Scalars['ID'];
  showMap?: InputMaybe<Scalars['Boolean']>;
  startTimeISO8601TZ?: InputMaybe<Scalars['String']>;
  unplugged?: InputMaybe<Scalars['Boolean']>;
  virtualEventLink?: InputMaybe<Scalars['String']>;
};

export type UpdateEventSettingsPayload = {
  allowFacebookAndInstagramSharingOnApp?: InputMaybe<Scalars['Boolean']>;
  allowGuestsNotInGuestListToRSVP?: InputMaybe<Scalars['Boolean']>;
  allowGuestsToInviteOtherGuestsOnApp?: InputMaybe<Scalars['Boolean']>;
  allowGuestsToRSVPPlusOne?: InputMaybe<Scalars['Boolean']>;
  allowGuestsToViewOtherGuestsOnApp?: InputMaybe<Scalars['Boolean']>;
  hideDownloadAppPage?: InputMaybe<Scalars['Boolean']>;
  hideEventCountdown?: InputMaybe<Scalars['Boolean']>;
  hideFromJoySearch?: InputMaybe<Scalars['Boolean']>;
  hideFromSearchEngines?: InputMaybe<Scalars['Boolean']>;
  requirePasswordForEventDate?: InputMaybe<Scalars['Boolean']>;
  requirePasswordForEventLocation?: InputMaybe<Scalars['Boolean']>;
  requirePasswordToUploadPhotos?: InputMaybe<Scalars['Boolean']>;
  requirePasswordToViewEngagementPhotos?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEventSuggestionPayload = {
  stateJSON?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateEventTypeInput = {
  category?: InputMaybe<Scalars['String']>;
  categorySubtype?: InputMaybe<Scalars['String']>;
  configJson?: InputMaybe<Scalars['JSONObject']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  schemaUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateFerryTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateFlightTravelItemPayload = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateFormInput = {
  config: Scalars['JSONObject'];
  description?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  schemaUrl: Scalars['String'];
  settings?: InputMaybe<Scalars['JSONObject']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateAnswerInput = {
  answerValue?: InputMaybe<Scalars['String']>;
  formId?: InputMaybe<Scalars['ID']>;
  guestKey?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  questionId?: InputMaybe<Scalars['ID']>;
};

export type UpdateFormTemplateInput = {
  config: Scalars['JSONObject'];
  description?: InputMaybe<Scalars['String']>;
  eventCategoryTags: Array<Scalars['String']>;
  eventSubTypeTags: Array<Scalars['String']>;
  id: Scalars['ID'];
  schemaUrl: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateGreetingMessageComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type GuestlistUpdateCustomColumnInput = {
  columnId: Scalars['ID'];
  defaultValue?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  displayPriority?: InputMaybe<Scalars['Float']>;
  displayState?: InputMaybe<GuestlistColumnDisplayState>;
  eventId: Scalars['String'];
  isRequired?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  placeholderValue?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<GuestlistCustomColumnType>;
  width?: InputMaybe<Scalars['Int']>;
};

/** Partial input for updating guest list view preferences. Only provided fields are changed; omitted fields retain their current values. */
export type UpdateGuestListSettingsInput = {
  /** Direction of the initial sort order. */
  defaultSortDirection?: InputMaybe<SortDirection>;
  /** Column used for the initial sort order. */
  defaultSortField?: InputMaybe<GuestListMemberSortField>;
  /** The event whose settings are being updated. */
  eventId: Scalars['String'];
  /** Number of groups shown per page (1–200). */
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type UpdateHotelTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateInviteePayload = {
  address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** Display name for mailings/correspondence (e.g., 'Mr. Evan Jones & Guest', 'The Smith Family') */
  envelopeName?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  /** Country code of the user's phone, numbers without a country code will be assumed to be in this country. Ignored if phoneDisplay has a country code, otherwise, this will be used to help parse it to E.164. */
  fallbackCountryCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  personId: Scalars['ID'];
  /** Phone number as entered by the user, not necessarily valid */
  phoneDisplay?: InputMaybe<Scalars['String']>;
};

export type UpdateJsonDataBlobComponentPayload = {
  id: Scalars['ID'];
  jsonDataContainerId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateJsonDataContainerPayload = {
  content?: InputMaybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  schemaUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateListTravelItemPayload = {
  id: Scalars['ID'];
  name: Scalars['String'];
  newItems?: InputMaybe<Array<InputMaybe<ListTravelSubItems>>>;
  updatedItems?: InputMaybe<Array<InputMaybe<ListTravelSubItemsWithId>>>;
};

export type ListTravelSubItemsWithId = {
  id: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type MarketingEmailPreferencesInput = {
  email: Scalars['String'];
  preferences: Array<MessagePreferenceInput>;
};

export type MessagePreferenceInput = {
  id: Scalars['Int'];
  isSubscribed: Scalars['Boolean'];
};

export type UpdateMediaCollectionInput = {
  mediaCollectionAttributes?: InputMaybe<MediaCollectionAlbumAttributeInput>;
  mediaCollectionId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<MediaCollectionSortField>;
  sortDirection?: InputMaybe<MediaCollectionSortDirection>;
};

export type UpdateMediaGalleryComponentPayload = {
  id: Scalars['ID'];
  mediaCollectionId: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateNoteTravelItemPayload = {
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type PageContainerUpdatePayload = {
  contentType?: InputMaybe<PageContentType>;
  defaultPhotoJson?: InputMaybe<DefaultPagePhotoInput>;
  id: Scalars['ID'];
  mainPhotoAlignment?: InputMaybe<PhotoAlignment>;
  mainPhotoCropInfo?: InputMaybe<MainPhotoCropInfoInput>;
  mainPhotoId?: InputMaybe<Scalars['ID']>;
  mainPhotoPresentationLayout?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<EventPageVisibility>;
};

export type DefaultPagePhotoInput = {
  assetId: Scalars['String'];
  height: Scalars['Float'];
  mimeType: Scalars['String'];
  url: Scalars['String'];
  width: Scalars['Float'];
};

export type UpdatePaidMessagingSettingsInput = {
  eventId: Scalars['String'];
  messagingTier?: InputMaybe<MessagingTier>;
};

export type PhotoComponentUpdatePayload = {
  id: Scalars['ID'];
  photoId: Scalars['String'];
  sortOrder: Scalars['Float'];
};

export type PointsOnMapUpdatePayload = {
  address: Scalars['String'];
  googlePlaceID?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  postalCode: Scalars['String'];
  type: PointOnMapType;
};

export type UpdateQandaPayload = {
  answer?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
};

/** Identical to RecommendRegistryOnboardingSurveyResults. */
export type RecommendRegistryOnboardingSurveyPayload = {
  coupleInterests?: InputMaybe<Array<Scalars['String']>>;
  guestCount?: InputMaybe<Scalars['Int']>;
  interestedInBrowserButton?: InputMaybe<Scalars['Boolean']>;
  isSurveyCompleted?: InputMaybe<Scalars['Boolean']>;
  registeringAtOtherStores?: InputMaybe<Scalars['Boolean']>;
  registryTypes?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateRegistryPayload = {
  name?: InputMaybe<Scalars['String']>;
  /** update status as user goes through recommendations */
  recommendationStatus?: InputMaybe<RegistryRecommendationStatus>;
  /** The URL to the Registry website */
  url?: InputMaybe<Scalars['String']>;
  wantSync?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRegistryChecklistItemPayload = {
  isChecked?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Generic update mutation. Note stillNeeded and totalRequested are being withdrawn
 * from this payload. Use specific mutations such as updateRegistryItemQuantity() to
 * update quantity values
 */
export type UpdateRegistryItemPayload = {
  /** product level data that we own */
  custom?: InputMaybe<UpdateCustomItemDataInput>;
  /** donation fund info for group gifting */
  donationFundPayload?: InputMaybe<CreateDonationFundInput>;
  /** always updatable, sort related updates may be moved to dedicated endpoints */
  fpIndex?: InputMaybe<Scalars['Float']>;
  /** flag to allow the couple to enable the get cash equivalent feature */
  isGetCashEquivalent?: InputMaybe<Scalars['Boolean']>;
  /** flag to allow the couple to enable the group gifting feature */
  isGroupGiftingEnabled?: InputMaybe<Scalars['Boolean']>;
  /** flag to allow the couple to hide an item */
  isHidden?: InputMaybe<Scalars['Boolean']>;
  /** flag to allow the couple to musthave an item */
  mustHave?: InputMaybe<Scalars['Boolean']>;
  /** note added to item by couple */
  note?: InputMaybe<Scalars['String']>;
  /**
   * Insertion position in list of all items in event.
   * If specified, this value takes precedence over any fpIndex value
   */
  position?: InputMaybe<InsertPositionType>;
  /** only updatable for custom items, being deprecated, use specific mutations */
  stillNeeded?: InputMaybe<Scalars['Int']>;
  /** only updatable for custom items, being deprecated, use specific mutations */
  totalRequested?: InputMaybe<Scalars['Int']>;
};

export type UpdateCustomItemDataInput = {
  priceAsFloatingPointDecimalString?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: CustomItemDataType;
  url: Scalars['String'];
};

/**
 * Used to attach donation fund to a physical gift as part of updateRegistryItem mutation
 * when group gifting feature is enabled.
 */
export type CreateDonationFundInput = {
  description?: InputMaybe<Scalars['String']>;
  donationsAreCapped?: InputMaybe<Scalars['Boolean']>;
  enableCashOrCheck?: InputMaybe<Scalars['Boolean']>;
  enforceSuggestedDonationAmount?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['String'];
  feePaidBy?: InputMaybe<FeePaidByEnum>;
  fpIndex?: InputMaybe<Scalars['Int']>;
  fundType?: InputMaybe<CustomItemDataType>;
  goalMonetaryMinorValue?: InputMaybe<Scalars['Int']>;
  hideFundingGoal?: InputMaybe<Scalars['Boolean']>;
  imageUrlForImport?: InputMaybe<Scalars['String']>;
  platformId?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<InsertPositionType>;
  suggestedDonationMonetaryMinorValue?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

export type UpdateRentalCarTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateRentalHomeTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ReservedRoomBlocksUpdateRequest = {
  hiddenForGuests?: InputMaybe<Scalars['Boolean']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  note?: InputMaybe<Scalars['String']>;
  reservedRoomBlockId: Scalars['ID'];
  status?: InputMaybe<ReservedRoomBlockStatus>;
};

export type UpdateRsvpAndUnlockGuestDetailsButtonComponentPayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateRsvpSettingsPayload = {
  deadlineDate?: InputMaybe<Scalars['DateTime']>;
  deadlineEnabled?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['String'];
  gracePeriodEnabled?: InputMaybe<Scalars['Boolean']>;
  gracePeriodHours?: InputMaybe<Scalars['Int']>;
  showDeadline?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateShuttleTravelItemPayload = {
  id: Scalars['ID'];
  name: Scalars['String'];
  newItems?: InputMaybe<Array<InputMaybe<ShuttleTravelSubItems>>>;
  notes?: InputMaybe<Scalars['String']>;
  updatedItems?: InputMaybe<Array<InputMaybe<ShuttleTravelSubItemsWithId>>>;
};

export type ShuttleTravelSubItemsWithId = {
  endTime?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateStationeryDraftInput = {
  cardJSON: Scalars['JSON'];
  eventId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

export type UpdateStationeryPrintOrderShippingAddressInput = {
  orderId: Scalars['ID'];
  shippingAddress: StationeryPrintOrderShippingAddressInput;
};

export type UpdateStayAreaRequest = {
  address?: InputMaybe<Scalars['String']>;
  bestForTags?: InputMaybe<Array<Scalars['String']>>;
  customPhotoIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  photoIdsToRemove?: InputMaybe<Array<Scalars['String']>>;
  proposedNoteFromHostToGuest?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StayAreaStatus>;
  watchOuts?: InputMaybe<Scalars['String']>;
  whyThisAreaIsAGreatPick?: InputMaybe<Scalars['String']>;
};

export type UpdateStayAreaRequestV2 = {
  address?: InputMaybe<Scalars['String']>;
  bestForTags?: InputMaybe<Array<Scalars['String']>>;
  customPhotoIds?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  photoIdsToRemove?: InputMaybe<Array<Scalars['String']>>;
  proposedNoteFromHostToGuest?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StayAreaStatus>;
  watchOuts?: InputMaybe<Scalars['String']>;
  whyThisAreaIsAGreatPick?: InputMaybe<Scalars['String']>;
};

export type UpdateTaxiTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateTentTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateTestimonyPayload = {
  content: Scalars['String'];
  reviewer?: InputMaybe<Scalars['String']>;
  testimonyId: Scalars['String'];
};

export type TextComponentUpdatePayload = {
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
  text: Scalars['String'];
};

export type UpdateThingsToDoContainersPayload = {
  /** An array of Things To Do content to update */
  contents: Array<Scalars['JSONObject']>;
  eventId: Scalars['ID'];
  /** @deprecated(reason: "It only update contents for containers with the same 'poi.id', so the strategy is no longer needed") */
  strategy?: InputMaybe<UpdateThingsToDoContainersStrategy>;
};

export enum UpdateThingsToDoContainersStrategy {
  /** Adds new containers */
  add = 'add',
  /** Removes all containers for the cities specified in the container contents and then creates new containers for that cities */
  replace = 'replace',
}

/**
 * Input for updating an existing ticket type.
 * Nullable fields can be cleared by setting their corresponding clear flag to true.
 */
export type UpdateTicketTypeInput = {
  capacity?: InputMaybe<Scalars['Int']>;
  /** Set to true to clear capacity (make unlimited) */
  clearCapacity?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to clear the description (set to null) */
  clearDescription?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to clear salesEndAt */
  clearSalesEndAt?: InputMaybe<Scalars['Boolean']>;
  /** Set to true to clear salesStartAt */
  clearSalesStartAt?: InputMaybe<Scalars['Boolean']>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInMinorUnits?: InputMaybe<Scalars['Int']>;
  salesEndAt?: InputMaybe<Scalars['DateTime']>;
  salesStartAt?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<TicketTypeState>;
};

export type UpdateTrainTravelItemPayload = {
  address?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateTravelAlertSubscriptionInput = {
  action: TravelAlertSubscriptionAction;
  eventId: Scalars['ID'];
  subscriptionId: Scalars['ID'];
};

export enum TravelAlertSubscriptionAction {
  OPT_OUT = 'OPT_OUT',
  RE_ENGAGE = 'RE_ENGAGE',
}

export type TravelMapComponentUpdatePayload = {
  blockOrdering?: InputMaybe<Array<Scalars['String']>>;
  hideExploreCTA?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
};

export type UpdateTravelSettingsRequest = {
  accommodationsNotePrompt?: InputMaybe<Scalars['String']>;
  checkInDate?: InputMaybe<Scalars['DateOnlyString']>;
  checkOutDate?: InputMaybe<Scalars['DateOnlyString']>;
  currencyCode?: InputMaybe<TravelCurrencyCode>;
  datesMatchingReminder?: InputMaybe<Scalars['Boolean']>;
  eventId: Scalars['ID'];
};

export type UpdateUserPayload = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateVendor = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  startingPrice?: InputMaybe<Scalars['Int']>;
  typicalSpend?: InputMaybe<Scalars['Int']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorAsCouplePayload = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: InputMaybe<LocationInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorUserPayload = {
  displayFirstName?: InputMaybe<Scalars['String']>;
  displayLastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateInviteInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  inviteId: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  role: VendorUserRole;
};

export type VendorUserInput = {
  acceptedTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<RoleTypeEnum>;
};

export type UpdateVendorInput = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNumberE164?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type VideoComponentUpdatePayload = {
  caption?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  sortOrder: Scalars['Float'];
  videoUrl: Scalars['String'];
};

export type UpdateVipPayload = {
  alias?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  photoUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateGreetingInput = {
  greeting: Scalars['String'];
};

export type UploadCustomThemeAssetPayload = {
  assetId: Scalars['String'];
  eventId: Scalars['ID'];
  height?: InputMaybe<Scalars['Int']>;
  mimeType?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type createMediaFromUrlsInput = {
  collectionId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  magicToken?: InputMaybe<Scalars['String']>;
  photos: Array<PhotoInput>;
};

export type PhotoInput = {
  assetId: Scalars['String'];
  handle?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type UploadPhotoFromUrlPayload = {
  assetId: Scalars['String'];
  containerId: Scalars['String'];
  url: Scalars['String'];
};

export enum PhotoEnvelopeActionCode {
  /** Processing is not possible, and never will be; do not retry */
  abandon = 'abandon',
  /** Processing failed; please retry */
  retry = 'retry',
  /** Processing was successful */
  success = 'success',
}

export type UpsertCustomThemePayload = {
  description?: InputMaybe<Scalars['String']>;
  desktopThemeAssetId?: InputMaybe<Scalars['ID']>;
  eventId: Scalars['ID'];
  mobileThemeAssetId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type UpsertStationeryTagInput = {
  category?: InputMaybe<Scalars['String']>;
  displayLabel: Scalars['String'];
  name: Scalars['String'];
  thumbnailUrl?: InputMaybe<Scalars['String']>;
};

export type VerifyEmailPayload = {
  returnUrl?: InputMaybe<Scalars['String']>;
};

export type VerifyTravelAlertOtpInput = {
  channel: TravelAlertChannel;
  email?: InputMaybe<Scalars['String']>;
  /** One-time code from SMS or email. Exactly 4 digits; must match the code we generated when sendTravelAlertOtp ran. */
  otp: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type WebsiteActivateHeaderForDesignInput = {
  designId: Scalars['String'];
  eventId: Scalars['String'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type WebsiteActivateHeaderForEventInput = {
  eventId: Scalars['String'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type WebsiteApplyHeaderPresentationSettingsInput = {
  dataJSON: Scalars['JSON'];
  eventId: Scalars['ID'];
  schemaURL: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type websiteCreateOrUpdatePagePhotoPresentationPayload = {
  cropInfo?: InputMaybe<WebsitePagePhotoPresentationCropInfoInput>;
  id?: InputMaybe<Scalars['ID']>;
  pageId?: InputMaybe<Scalars['ID']>;
  /** fullWidth, center */
  presentationLayout: Scalars['String'];
};

export type WebsitePagePhotoPresentationCropInfoInput = {
  height: Scalars['Float'];
  /** percent */
  unit: Scalars['String'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type WebsiteRemoveActiveHeaderForEventInput = {
  eventId: Scalars['String'];
  websiteLayout: Scalars['String'];
};

export type CalendarDate = {
  dayOfMonth: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

/** Represents the role of the user accessing the cash fund. */
export enum CashFundRole {
  admin = 'admin',
}

/** Different types of checkout mechanisms we support */
export enum CheckoutMechanismType {
  /** external link */
  externalNavigation = 'externalNavigation',
  /** we ship it */
  joyWeb = 'joyWeb',
}

export type ContactAuthorizedUseInput = {
  allow: Scalars['Boolean'];
  contactListId: Scalars['String'];
  householdId: Scalars['String'];
  personId: Scalars['String'];
};

export type ContactHouseholdInput = {
  displayName?: InputMaybe<Scalars['String']>;
  ownerId: Scalars['String'];
};

export type CreateEventPayload = {
  accentColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  accentLightText?: InputMaybe<Scalars['Boolean']>;
  accentText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  acquisitionContext?: InputMaybe<AcquisitionContext>;
  baseColor?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  baseLightText?: InputMaybe<Scalars['Boolean']>;
  baseText?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  calendarDate?: InputMaybe<CalendarDate>;
  /** Source of the event being created. ie: Create Wedding, Vendor RFP */
  creationSource?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Float']>;
  enableTranslucentEffect?: InputMaybe<Scalars['Boolean']>;
  eventDisplayName?: InputMaybe<Scalars['String']>;
  eventType?: InputMaybe<EventType>;
  exhibitId?: InputMaybe<Scalars['String']>;
  fianceeFirstName: Scalars['String'];
  fianceeLastName: Scalars['String'];
  font?: InputMaybe<Scalars['String']>;
  graphicAccent?: InputMaybe<Scalars['String']>;
  /** Tracking information for an Impact Radius Campaign */
  impactRadiusTracking?: InputMaybe<CreateEventImpactRadiusTrackingPayload>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  ownerFirstName: Scalars['String'];
  ownerLastName: Scalars['String'];
  paletteId?: InputMaybe<Scalars['String']>;
  paletteName?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['String']>;
  tzid?: InputMaybe<Scalars['String']>;
  useSuggestedBackgroundColor?: InputMaybe<Scalars['Boolean']>;
  useWeddingColor?: InputMaybe<Scalars['Boolean']>;
  venue?: InputMaybe<EventLocationInput>;
};

export type CreateRegistryOrderInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
};

export type EmailMessageInput = {
  emailType: Scalars['String'];
  eventId: Scalars['String'];
  eventLink?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<Scalars['String']>;
  eventPassword?: InputMaybe<Scalars['String']>;
  eventWebsite?: InputMaybe<Scalars['String']>;
  footerText?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  greeting?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  includeAppInstructions?: InputMaybe<Scalars['Boolean']>;
  includeEventPassword?: InputMaybe<Scalars['Boolean']>;
  includeWebsiteDetails?: InputMaybe<Scalars['Boolean']>;
  message: Scalars['String'];
  messageBatchId?: InputMaybe<Scalars['String']>;
  replyToEmail: Scalars['String'];
  salutation?: InputMaybe<Scalars['String']>;
  sentByUserId?: InputMaybe<Scalars['String']>;
  sentForEventId?: InputMaybe<Scalars['String']>;
  sentForVendorId?: InputMaybe<Scalars['String']>;
  sentToPersonId?: InputMaybe<Scalars['String']>;
  sentToUserId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  toEmail: Scalars['String'];
  userId: Scalars['String'];
};

export type EventFeaturePreferenceOptions = {
  considerThemeSupport?: InputMaybe<Scalars['Boolean']>;
};

export enum FormActionType {
  ADD_CONTACT_TO_GUEST_LIST = 'ADD_CONTACT_TO_GUEST_LIST',
  SEND_CONFIRMATION_EMAIL = 'SEND_CONFIRMATION_EMAIL',
  SET_ATTENDANCE = 'SET_ATTENDANCE',
}

/**
 * Machine-readable error codes returned in GraphQL error extensions.
 * Use these values to match on specific error conditions in client code.
 */
export enum FormServiceErrorCode {
  ANSWER_ATTENDANCE_ANSWER_REQUIRED = 'ANSWER_ATTENDANCE_ANSWER_REQUIRED',
  ANSWER_CONTACT_UPDATE_FAILED = 'ANSWER_CONTACT_UPDATE_FAILED',
  ANSWER_GUEST_KEY_REQUIRED = 'ANSWER_GUEST_KEY_REQUIRED',
  ANSWER_INVALID_APPROVAL_FLOW = 'ANSWER_INVALID_APPROVAL_FLOW',
  ANSWER_SUBMISSION_FAILED = 'ANSWER_SUBMISSION_FAILED',
  ANSWER_TICKET_TYPE_REQUIRED = 'ANSWER_TICKET_TYPE_REQUIRED',
  FORM_INVALID_SETTINGS = 'FORM_INVALID_SETTINGS',
  FORM_NO_EVENT = 'FORM_NO_EVENT',
  FORM_NOT_FOUND = 'FORM_NOT_FOUND',
  FORM_NOT_REGISTRATION_TYPE = 'FORM_NOT_REGISTRATION_TYPE',
  REGISTRATION_INVALID_STATE = 'REGISTRATION_INVALID_STATE',
  REGISTRATION_NO_FORM = 'REGISTRATION_NO_FORM',
  REGISTRATION_NOT_FOUND = 'REGISTRATION_NOT_FOUND',
  TICKETING_ORDER_ALREADY_CANCELLED = 'TICKETING_ORDER_ALREADY_CANCELLED',
  TICKETING_ORDER_INVALID_INPUT = 'TICKETING_ORDER_INVALID_INPUT',
  TICKETING_ORDER_INVALID_STATE = 'TICKETING_ORDER_INVALID_STATE',
  TICKETING_ORDER_NOT_FOUND = 'TICKETING_ORDER_NOT_FOUND',
  TICKETING_SALES_DATE_INVALID = 'TICKETING_SALES_DATE_INVALID',
  TICKETING_SOLD_OUT = 'TICKETING_SOLD_OUT',
  TICKETING_TICKET_INVALID_STATE = 'TICKETING_TICKET_INVALID_STATE',
  TICKETING_TICKET_NO_TYPE = 'TICKETING_TICKET_NO_TYPE',
  TICKETING_TICKET_NOT_FOUND = 'TICKETING_TICKET_NOT_FOUND',
  TICKETING_TICKET_PAYMENT_INCOMPLETE = 'TICKETING_TICKET_PAYMENT_INCOMPLETE',
  TICKETING_TICKET_TYPE_DUPLICATE_NAME = 'TICKETING_TICKET_TYPE_DUPLICATE_NAME',
  TICKETING_TICKET_TYPE_HAS_SALES = 'TICKETING_TICKET_TYPE_HAS_SALES',
  TICKETING_TICKET_TYPE_INVALID_INPUT = 'TICKETING_TICKET_TYPE_INVALID_INPUT',
  TICKETING_TICKET_TYPE_NOT_FOUND = 'TICKETING_TICKET_TYPE_NOT_FOUND',
  TICKETING_TICKET_TYPE_NOT_FREE = 'TICKETING_TICKET_TYPE_NOT_FREE',
  TICKETING_TICKET_TYPE_UNAVAILABLE = 'TICKETING_TICKET_TYPE_UNAVAILABLE',
}

export type InviteNewVendorToEventPayload = {
  email?: InputMaybe<Scalars['String']>;
  eventId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export enum ItemDiscountPolicyClause {
  CANNOT_DROPSHIP = 'CANNOT_DROPSHIP',
  IS_EXTERNAL = 'IS_EXTERNAL',
  IS_NOT_A_CATALOG_ITEM = 'IS_NOT_A_CATALOG_ITEM',
  IS_NOT_A_GIFT = 'IS_NOT_A_GIFT',
  IS_NOT_NEEDED = 'IS_NOT_NEEDED',
  IS_NOT_SHIPPABLE = 'IS_NOT_SHIPPABLE',
  QUANTITY_EXCEEDS_LIMIT = 'QUANTITY_EXCEEDS_LIMIT',
  WAS_ADDED_AFTER_EVENT_DATE = 'WAS_ADDED_AFTER_EVENT_DATE',
}

export type PageComponentPayload = {
  sortOrder: Scalars['Float'];
  text?: InputMaybe<Scalars['String']>;
  type: ComponentType;
  url?: InputMaybe<Scalars['String']>;
};

export enum ProductCatalogItemFulfillmentMethod {
  default = 'default',
  email = 'email',
}

export enum ProductCatalogItemType {
  cash = 'cash',
  charity = 'charity',
  experience = 'experience',
  gift_card = 'gift_card',
  product = 'product',
  travel = 'travel',
}

export type PublishEventDesignDraftPayload = {
  eventDesignId: Scalars['ID'];
};

export enum RegistrationApprovalFlow {
  AUTOMATIC = 'AUTOMATIC',
  GUEST_LIST_APPROVAL = 'GUEST_LIST_APPROVAL',
}

export enum RegistryChecklistItemType {
  registryItem = 'registryItem',
}

export enum RegistryDiscountPolicyClause {
  BEFORE_EVENT_DATE = 'BEFORE_EVENT_DATE',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  NO_CATALOG_ITEM_ADDED_BEFORE_CUTOFF_DATE = 'NO_CATALOG_ITEM_ADDED_BEFORE_CUTOFF_DATE',
  NO_DROPSHIP_ORDER_BEFORE_EVENT_DATE = 'NO_DROPSHIP_ORDER_BEFORE_EVENT_DATE',
  NOT_AN_ADMIN = 'NOT_AN_ADMIN',
  PAST_POST_WEDDING_DISCOUNT_END_DATE = 'PAST_POST_WEDDING_DISCOUNT_END_DATE',
}

export enum RegistryFulfillmentStatusType {
  processing = 'processing',
  shipped = 'shipped',
}

export enum RegistryPayoutAccountWithdrawalStatus {
  failed = 'failed',
  pending = 'pending',
  succeeded = 'succeeded',
}

export type StationeryProductChoiceInput = {
  attributeId: Scalars['ID'];
  attributeOptionId: Scalars['ID'];
};

export type StationeryProductInput = {
  choices: Array<StationeryProductChoiceInput>;
  productId: Scalars['ID'];
};

export type UpdateEventPayload = {
  website: Scalars['String'];
};

export enum WarehouseFulfillmentMethod {
  /** Standard Physical Item Shipping */
  default = 'default',
  /** E-Delivery */
  email = 'email',
  /**
   * Using the option of 'none' will trigger order fulfillment step to be skipped in commerce service for this item
   * avoiding unnecessary fees from Shopify and Logic Broker.  This is designed for features like Joy eCards that are
   * fulfilled with an automated email and do not need physical shipping, tracking, 3rd party vender interactions, returns, etc.
   */
  none = 'none',
  /** Joy Wallet / CC4$ Payout */
  payout = 'payout',
  /** Travel Fulfillment */
  travel = 'travel',
}

export enum WarehouseInventoryCheckResult {
  insufficientInventory = 'insufficientInventory',
  inventoryOK = 'inventoryOK',
  skuNotFound = 'skuNotFound',
  supplierProductNotFound = 'supplierProductNotFound',
}

export enum WarehouseTaxCode {
  cash_fund = 'cash_fund',
  default = 'default',
  /**
   * Digital Greeting Cards - Static text and/or images only  14111605A0003
   * An electronic greeting "card" typically sent via email that contains only static images or text
   * rather than an audio visual or audio only experience.
   */
  ecard_static = 'ecard_static',
  gift_card = 'gift_card',
  /**
   * Tax code: 82121500A0000
   * A charge for the printing, imprinting, lithographing, mimeographing, photocopying, and similar
   * reproductions of various articles including mailers, catalogs, letterhead, envelopes, business cards,
   * presentation folders, forms, signage, etc. The end result is the transfer of tangible personal property to the customer.
   */
  print_card = 'print_card',
  /** Yet TBD */
  travel_accommodation = 'travel_accommodation',
}

export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    LocationInterface: ['EventLocation', 'Location', 'VendorLocation'],
    FavoriteResource: ['DesignLayout', 'Font', 'Theme'],
    DesignPreference: [
      'DesignPreferenceColor',
      'DesignPreferenceRange',
      'DesignPreferenceBoolean',
      'EventDesignPreferenceBoolean',
      'EventDesignPreferenceColorPointer',
      'EventDesignPreferenceRange',
      'EventDesignPreferenceColor',
    ],
    WebsiteLayoutAlohaOptions: ['WebsiteLayoutAlohaSettings'],
    WebsiteLayoutBrannanOptions: ['WebsiteLayoutBrannanSettings'],
    EventDesignPreference: ['EventDesignPreferenceBoolean', 'EventDesignPreferenceColorPointer', 'EventDesignPreferenceRange'],
    EventTravel: ['EventTravelBookingType', 'EventTravelList', 'EventTravelNote', 'Ferry', 'Flight', 'Hotel', 'RentalCar', 'RentalHome', 'Shuttle', 'Taxi', 'Tent', 'Train'],
    EventTravelShared: ['EventTravelBookingType', 'EventTravelList', 'EventTravelNote', 'Ferry', 'Flight', 'Hotel', 'RentalCar', 'RentalHome', 'Shuttle', 'Taxi', 'Tent', 'Train'],
    EventMedia: ['MediaPhoto', 'MediaVideo'],
    PagePhoto: ['DefaultPagePhoto', 'Photo'],
    Component: [
      'EventCountdownComponent',
      'EventDetailsComponent',
      'EventDisplayNameComponent',
      'GreetingMessageComponent',
      'JsonDataBlobComponent',
      'MediaGalleryComponent',
      'PhotoComponent',
      'RsvpAndUnlockGuestDetailsButtonComponent',
      'TextComponent',
      'TravelMapComponent',
      'VideoComponent',
    ],
    Connection: ['CollectionItemsConnection'],
    Edge: ['CollectionItemsEdge'],
    VendorUserDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType', 'VendorUserV2'],
    ErrorType: ['AuthenticationErrorType', 'BadRequestErrorType', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    BookingSlotDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'BookingSlot', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    SalesOrderLine: [
      'SalesOrderCompensationLine',
      'SalesOrderChargeLine',
      'SalesOrderPostPurchaseFeeLine',
      'SalesOrderShippingAndHandlingLine',
      'SalesOrderItemLine',
      'SalesOrderTaxLine',
    ],
    CheckTransitionalRegistryUrlResult: ['InvalidTransitionalRegistryUrlResult', 'ValidTransitionalRegistryUrlResult'],
    ProductCatalogCollectionDisplayInfoInterface: ['ProductCatalogCollectionDisplayInfoToCategory', 'ProductCatalogCollectionDisplayInfo'],
    ProductCatalogEntity: [
      'ProductCatalogEntityBrand',
      'ProductCatalogEntityCategory',
      'ProductCatalogEntityCuration',
      'ProductCatalogEntityItem',
      'ProductCatalogEntityItemGroup',
    ],
    ProductCatalogAsset: ['ProductCatalogPhotoAsset', 'ProductCatalogVideoAsset'],
    RatingReviewAsset: ['RatingReviewPhotoAsset', 'RatingReviewVideoAsset'],
    CustomerInsightsDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'CustomerInsights', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    EnrichedCustomerInsightsUnion: ['EnrichedCompanyInsights', 'EnrichedCustomerInsights'],
    EventChecklistDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'EventChecklist', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    Email_Connection: ['EmailSearchResultsSummaryView'],
    Email_Edge: ['EmailSearchCollectionItemsEdge'],
    PostOfficeDraft: [
      'PostOfficeGenericEmailDraft',
      'PostOfficeGiftWrapEmailDraft',
      'PostOfficeGreetingCardEmailDraft',
      'PostOfficeReminderEmailDraft',
      'PostOfficeThankYouEmailDraft',
    ],
    Handle: ['Event'],
    ProductHeroContentMedia: ['ProductHeroImage', 'ProductHeroVideo'],
    ProductUniversalItemContainer: ['ProductExternalOfferContainer', 'ProductUniversalCatalogItemContainer', 'ProductUniversalProductContainer'],
    StationeryPricing: ['StationeryFlatFeePricing', 'StationeryTieredFlatFeePricing', 'StationeryTieredPricing'],
    StationeryProductShippingOption: ['StationeryProductShippingOptionV1'],
    StationeryShippingConstraint: ['StationeryAllowPoBoxShippingConstraint', 'StationeryCountryShippingConstraint', 'StationeryQuantityShippingConstraint'],
    TransitionalRegistryItem: ['TransitionalRegistryFund', 'TransitionalRegistryProduct'],
    TravelOfferComponent: ['TravelOfferAccommodationUnitsComponent'],
    BookingTypeDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'BookingType', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    VendorTypeResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType', 'VendorV2'],
    AcceptCashFundContributionResult: ['CashFundContribution', 'CashFundGeneralError'],
    CashFundError: ['CashFundGeneralError'],
    addMediaToCollectionResponses: ['addMediaToCollectionResponse', 'addMediaToCollectionResponseError'],
    MutationResponse: [
      'addMediaToCollectionResponse',
      'addMediaToCollectionResponseError',
      'createMediaPhotosResponse',
      'websiteCreateOrUpdatePagePhotoPresentationResponse',
      'websiteCreateOrUpdatePagePhotoPresentationResponseError',
    ],
    ArchiveCashFundResult: ['ArchiveCashFundSuccess', 'CashFundGeneralError'],
    CreateCashFundResult: ['CashFund', 'CashFundGeneralError'],
    CreateCashFundCheckoutSessionResult: ['CashFundCheckoutSession', 'CashFundGeneralError'],
    CreateCashFundPaymentIntentResult: ['CashFundGeneralError', 'CashFundPaymentIntent'],
    CreateCashFundSolicitationResult: ['CashFundGeneralError', 'CashFundSolicitation'],
    ChecklistItemDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'ChecklistItem', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    ChecklistSubItemDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'ChecklistSubItem', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType'],
    CreateRegistryPaymentIntentResult: ['RegistryPaymentIntent', 'RegistryPaymentIntentError'],
    CreateRegistryPayoutAccountResult: ['RegistryErrorResult', 'RegistryPayoutAccount'],
    VendorOrganizationTypeResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType', 'VendorOrganization'],
    VendorUserInviteDtoResult: ['AuthenticationErrorType', 'BadRequestErrorType', 'ForbiddenErrorType', 'InternalServerErrorType', 'NotFoundErrorType', 'VendorUserInvite'],
    DuplicateCashFundResult: ['CashFund', 'CashFundGeneralError'],
    GetImageMetadataResult: ['FailedImageMetadataResponse', 'Photo'],
    InitCashFundsHostResult: ['CashFundGeneralError', 'CashFundsHost'],
    ManageCashFundSolicitationRecipientsResult: ['CashFundGeneralError', 'CashFundSolicitation'],
    ReactivateCashFundResult: ['CashFund', 'CashFundGeneralError'],
    RefundCashFundContributionResult: ['CashFundContribution', 'CashFundGeneralError'],
    TravelOfferReservationRegenerateTokenResult: ['TravelOfferReservationCreateStripeNativeResult', 'TravelOfferReservationCreateVaulteraVaultResult'],
    SendCashFundSolicitationEmailsResult: ['CashFundGeneralError', 'SendCashFundSolicitationEmailsSuccess'],
    SendCashFundSolicitationTestEmailResult: ['CashFundGeneralError', 'SendCashFundSolicitationTestEmailSuccess'],
    TravelOfferReservationCancelResult: ['TravelOfferReservationCancelFailure', 'TravelOfferReservationCancelSuccess'],
    TravelOfferReservationConfirmResult: ['TravelOfferReservationConfirmFailure', 'TravelOfferReservationConfirmSuccess'],
    TravelOfferReservationCreateResult: ['TravelOfferReservationCreateStripeNativeResult', 'TravelOfferReservationCreateVaulteraVaultResult'],
    UpdateCashFundResult: ['CashFund', 'CashFundGeneralError'],
    UpdateCashFundSolicitationResult: ['CashFundGeneralError', 'CashFundSolicitation'],
    uploadPhotosFromUrlsResponse: ['uploadPhotosFromUrlsResponseError', 'uploadPhotosFromUrlsResponseSuccess'],
    websiteCreateOrUpdatePagePhotoPresentationResponses: ['websiteCreateOrUpdatePagePhotoPresentationResponse', 'websiteCreateOrUpdatePagePhotoPresentationResponseError'],
    WithdrawCashFundsPayoutAccountResult: ['CashFundGeneralError', 'CashFundsPayoutAccountWithdrawal'],
    DesignFeature: [],
  },
};
export default result;
